var items = {
  "block.minecraft.acacia_button": "बबूल का बटन",
  "block.minecraft.acacia_door": "बबूल का दरवाजा",
  "block.minecraft.acacia_fence": "बबूल का बाड़ा",
  "block.minecraft.acacia_fence_gate": "बबूल का फाटक",
  "block.minecraft.acacia_hanging_sign": "बबूल लटकने का चिन्ह",
  "block.minecraft.acacia_leaves": "बबूल के पत्तें",
  "block.minecraft.acacia_log": "बबूल का तना",
  "block.minecraft.acacia_planks": "बबूल का तख्ता",
  "block.minecraft.acacia_pressure_plate": "बबूल का दाब पट्ट",
  "block.minecraft.acacia_sapling": "बबूल का पौधा",
  "block.minecraft.acacia_shelf": "बबूल की शेल्फ",
  "block.minecraft.acacia_sign": "बबूल का संकेत",
  "block.minecraft.acacia_slab": "बबूल की पटिया",
  "block.minecraft.acacia_stairs": "बबूल की सीढ़ियाँ",
  "block.minecraft.acacia_trapdoor": "बबूल का कूट द्वार",
  "block.minecraft.acacia_wall_hanging_sign": "बबूल की दीवार पर लटकने वाला चिन्ह",
  "block.minecraft.acacia_wall_sign": "बबूल का दीवार संकेत",
  "block.minecraft.acacia_wood": "बबूल की लकड़ी",
  "block.minecraft.activator_rail": "एक्टिवेटर रेल",
  "block.minecraft.air": "हवा",
  "block.minecraft.allium": "प्याज फूल",
  "block.minecraft.amethyst_block": "जंबुमणि का प्रखंड",
  "block.minecraft.amethyst_cluster": "जंबुमणि का झुंड",
  "block.minecraft.ancient_debris": "प्राचीन अवशेष",
  "block.minecraft.andesite": "एंडीसाइट",
  "block.minecraft.andesite_slab": "एंडीसाइट की पटिया",
  "block.minecraft.andesite_stairs": "एंडीसाइट की सीढ़ियाँ",
  "block.minecraft.andesite_wall": "एंडीसाइट का दीवार",
  "block.minecraft.anvil": "निहाई",
  "block.minecraft.attached_melon_stem": "संलग्न तरबूज स्टेम",
  "block.minecraft.attached_pumpkin_stem": "संलग्न कद्दू स्टेम",
  "block.minecraft.azalea": "अज़ेलिया",
  "block.minecraft.azalea_leaves": "अज़ेलिया के पत्ते",
  "block.minecraft.azure_bluet": "एज़ूर ब्लूट",
  "block.minecraft.bamboo": "बाँस",
  "block.minecraft.bamboo_block": "बाँस का ब्लॉक",
  "block.minecraft.bamboo_button": "बांस का बटन",
  "block.minecraft.bamboo_door": "बाँस का दरवाजा",
  "block.minecraft.bamboo_fence": "बांस की बाड़",
  "block.minecraft.bamboo_fence_gate": "बांस का फाटक",
  "block.minecraft.bamboo_hanging_sign": "बाँस से लटका हुआ चिन्ह",
  "block.minecraft.bamboo_mosaic": "बांस मोज़ेक",
  "block.minecraft.bamboo_mosaic_slab": "बांस मोज़ेक स्लैब",
  "block.minecraft.bamboo_mosaic_stairs": "बांस मोज़ेक सीढ़ियाँ",
  "block.minecraft.bamboo_planks": "बाँस की तख्तियाँ",
  "block.minecraft.bamboo_pressure_plate": "बांस दबाव प्लेट",
  "block.minecraft.bamboo_sapling": "बाँस का प्ररोह",
  "block.minecraft.bamboo_shelf": "बांस की शेल्फ",
  "block.minecraft.bamboo_sign": "बाँस का चिह्न",
  "block.minecraft.bamboo_slab": "बाँस की पटिया",
  "block.minecraft.bamboo_stairs": "बाँस की सीढ़ियाँ",
  "block.minecraft.bamboo_trapdoor": "बाँस का कूट दरवाज़ा",
  "block.minecraft.bamboo_wall_hanging_sign": "बाँस वॉल हैंगिंग साइन",
  "block.minecraft.bamboo_wall_sign": "बाँस की दीवार का चिन्ह",
  "block.minecraft.banner.base.black": "पूर्ण काली सतह",
  "block.minecraft.banner.base.blue": "पूर्ण नीली सतह",
  "block.minecraft.banner.base.brown": "पूर्ण भूरी सतह",
  "block.minecraft.banner.base.cyan": "पूर्ण हरिनील सतह",
  "block.minecraft.banner.base.gray": "पूर्ण स्लेटी सतह",
  "block.minecraft.banner.base.green": "पूर्ण हरी सतह",
  "block.minecraft.banner.base.light_blue": "पूर्ण हल्की नीली सतह",
  "block.minecraft.banner.base.light_gray": "पूर्ण हल्की स्लेटी सतह",
  "block.minecraft.banner.base.lime": "पूर्ण लाइम सतह",
  "block.minecraft.banner.base.magenta": "पूर्ण नीलातिरक्त सतह",
  "block.minecraft.banner.base.orange": "पूर्ण नारंगी सतह",
  "block.minecraft.banner.base.pink": "पूर्ण गुलाबी सतह",
  "block.minecraft.banner.base.purple": "पूर्ण जामुनी सतह",
  "block.minecraft.banner.base.red": "पूर्ण लाल सतह",
  "block.minecraft.banner.base.white": "पूर्ण सफेद सतह",
  "block.minecraft.banner.base.yellow": "पूर्ण पीली सतह",
  "block.minecraft.banner.border.black": "काली सीमा",
  "block.minecraft.banner.border.blue": "नीली सीमा",
  "block.minecraft.banner.border.brown": "भूरी सीमा",
  "block.minecraft.banner.border.cyan": "हरिनील सीमा",
  "block.minecraft.banner.border.gray": "स्लेटी सीमा",
  "block.minecraft.banner.border.green": "हरी सीमा",
  "block.minecraft.banner.border.light_blue": "हल्की नीली सीमा",
  "block.minecraft.banner.border.light_gray": "हल्की स्लेटी सीमा",
  "block.minecraft.banner.border.lime": "लाइम सीमा",
  "block.minecraft.banner.border.magenta": "नीलातिरक्त सीमा",
  "block.minecraft.banner.border.orange": "नारंगी सीमा",
  "block.minecraft.banner.border.pink": "गुलाबी सीमा",
  "block.minecraft.banner.border.purple": "जामुनी सीमा",
  "block.minecraft.banner.border.red": "लाल सीमा",
  "block.minecraft.banner.border.white": "सफेद सीमा",
  "block.minecraft.banner.border.yellow": "पीली सीमा",
  "block.minecraft.banner.bricks.black": "काली ईंट का अभिकल्प",
  "block.minecraft.banner.bricks.blue": "नीली ईंट का अभिकल्प",
  "block.minecraft.banner.bricks.brown": "भूरी ईंट का अभिकल्प",
  "block.minecraft.banner.bricks.cyan": "हरिनील ईंट का अभिकल्प",
  "block.minecraft.banner.bricks.gray": "स्लेटी ईंट का अभिकल्प",
  "block.minecraft.banner.bricks.green": "हरी ईंट का अभिकल्प",
  "block.minecraft.banner.bricks.light_blue": "हल्की नीला ईंट का अभिकल्प",
  "block.minecraft.banner.bricks.light_gray": "हल्की स्लेटी ईंट का अभिकल्प",
  "block.minecraft.banner.bricks.lime": "लाइम ईंट का अभिकल्प",
  "block.minecraft.banner.bricks.magenta": "नीलातिरक्त ईंट का अभिकल्प",
  "block.minecraft.banner.bricks.orange": "नारंगी ईंट का अभिकल्प",
  "block.minecraft.banner.bricks.pink": "गुलाबी ईंट का अभिकल्प",
  "block.minecraft.banner.bricks.purple": "जामुनी ईंट का अभिकल्प",
  "block.minecraft.banner.bricks.red": "लाल ईंट का अभिकल्प",
  "block.minecraft.banner.bricks.white": "सफेद ईंट का अभिकल्प",
  "block.minecraft.banner.bricks.yellow": "पीली ईंट का अभिकल्प",
  "block.minecraft.banner.circle.black": "काला पदक",
  "block.minecraft.banner.circle.blue": "नीला पदक",
  "block.minecraft.banner.circle.brown": "भूरा पदक",
  "block.minecraft.banner.circle.cyan": "हरिनील पदक",
  "block.minecraft.banner.circle.gray": "स्लेटी पदक",
  "block.minecraft.banner.circle.green": "हरा पदक",
  "block.minecraft.banner.circle.light_blue": "हल्का नीला पदक",
  "block.minecraft.banner.circle.light_gray": "हल्का स्लेटी पदक",
  "block.minecraft.banner.circle.lime": "लाइम पदक",
  "block.minecraft.banner.circle.magenta": "नीलातिरक्त पदक",
  "block.minecraft.banner.circle.orange": "नारंगी पदक",
  "block.minecraft.banner.circle.pink": "गुलाबी पदक",
  "block.minecraft.banner.circle.purple": "जामुनी पदक",
  "block.minecraft.banner.circle.red": "लाल पदक",
  "block.minecraft.banner.circle.white": "सफेद पदक",
  "block.minecraft.banner.circle.yellow": "पीला पदक",
  "block.minecraft.banner.creeper.black": "काला क्रीपर का अभिकल्प",
  "block.minecraft.banner.creeper.blue": "नीला क्रीपर का अभिकल्प",
  "block.minecraft.banner.creeper.brown": "भूरा क्रीपर का अभिकल्प",
  "block.minecraft.banner.creeper.cyan": "हरिनील क्रीपर का अभिकल्प",
  "block.minecraft.banner.creeper.gray": "स्लेटी क्रीपर का अभिकल्प",
  "block.minecraft.banner.creeper.green": "हरा क्रीपर का अभिकल्प",
  "block.minecraft.banner.creeper.light_blue": "हल्का नीला क्रीपर का अभिकल्प",
  "block.minecraft.banner.creeper.light_gray": "हल्का स्लेटी क्रीपर का अभिकल्प",
  "block.minecraft.banner.creeper.lime": "लाइम क्रीपर का अभिकल्प",
  "block.minecraft.banner.creeper.magenta": "नीलातिरक्त क्रीपर का अभिकल्प",
  "block.minecraft.banner.creeper.orange": "नारंगी क्रीपर का अभिकल्प",
  "block.minecraft.banner.creeper.pink": "गुलाबी क्रीपर का अभिकल्प",
  "block.minecraft.banner.creeper.purple": "जामुनी क्रीपर का अभिकल्प",
  "block.minecraft.banner.creeper.red": "लाल क्रीपर का अभिकल्प",
  "block.minecraft.banner.creeper.white": "सफेद क्रीपर का अभिकल्प",
  "block.minecraft.banner.creeper.yellow": "पीला क्रीपर का अभिकल्प",
  "block.minecraft.banner.cross.black": "काला गुणन चिन्ह",
  "block.minecraft.banner.cross.blue": "नीला गुणन चिन्ह",
  "block.minecraft.banner.cross.brown": "भूरा गुणन चिन्ह",
  "block.minecraft.banner.cross.cyan": "हरिनील गुणन चिन्ह",
  "block.minecraft.banner.cross.gray": "स्लेटी गुणन चिन्ह",
  "block.minecraft.banner.cross.green": "हरा गुणन चिन्ह",
  "block.minecraft.banner.cross.light_blue": "हल्का नीला गुणन चिन्ह",
  "block.minecraft.banner.cross.light_gray": "हल्का स्लेटी गुणन चिन्ह",
  "block.minecraft.banner.cross.lime": "लाइम गुणन चिन्ह",
  "block.minecraft.banner.cross.magenta": "नीलातिरक्त गुणन चिन्ह",
  "block.minecraft.banner.cross.orange": "नारंगी गुणन चिन्ह",
  "block.minecraft.banner.cross.pink": "गुलाबी गुणन चिन्ह",
  "block.minecraft.banner.cross.purple": "जामुनी गुणन चिन्ह",
  "block.minecraft.banner.cross.red": "लाल गुणन चिन्ह",
  "block.minecraft.banner.cross.white": "सफेद गुणन चिन्ह",
  "block.minecraft.banner.cross.yellow": "पीला गुणन चिन्ह",
  "block.minecraft.banner.curly_border.black": "काली घुँघराली सीमा",
  "block.minecraft.banner.curly_border.blue": "नीली घुँघराली सीमा",
  "block.minecraft.banner.curly_border.brown": "भूरी घुँघराली सीमा",
  "block.minecraft.banner.curly_border.cyan": "हरिनील घुँघराली सीमा",
  "block.minecraft.banner.curly_border.gray": "स्लेटी घुँघराली सीमा",
  "block.minecraft.banner.curly_border.green": "हरी घुँघराली सीमा",
  "block.minecraft.banner.curly_border.light_blue": "हलकी नीली घुँघराली सीमा",
  "block.minecraft.banner.curly_border.light_gray": "हल्की स्लेटी घुँघराली सीमा",
  "block.minecraft.banner.curly_border.lime": "लाइम घुँघराली सीमा",
  "block.minecraft.banner.curly_border.magenta": "नीलातिरक्त घुँघराली सीमा",
  "block.minecraft.banner.curly_border.orange": "नारंगी घुँघराली सीमा",
  "block.minecraft.banner.curly_border.pink": "गुलाबी घुँघराली सीमा",
  "block.minecraft.banner.curly_border.purple": "जामुनी घुँघराली सीमा",
  "block.minecraft.banner.curly_border.red": "लाल घुँघराली सीमा",
  "block.minecraft.banner.curly_border.white": "सफेद घुँघराली सीमा",
  "block.minecraft.banner.curly_border.yellow": "पीली घुँघराली सीमा",
  "block.minecraft.banner.diagonal_left.black": "काला रंग से भरा हुआ उलटा विकर्ण का बायाँ भाग",
  "block.minecraft.banner.diagonal_left.blue": "नीला रंग से भरा हुआ उलटा विकर्ण का बायाँ भाग",
  "block.minecraft.banner.diagonal_left.brown": "भूरा रंग से भरा हुआ उलटा विकर्ण का बायाँ भाग",
  "block.minecraft.banner.diagonal_left.cyan": "हरिनील रंग से भरा हुआ उलटा विकर्ण का बायाँ भाग",
  "block.minecraft.banner.diagonal_left.gray": "स्लेटी रंग से भरा हुआ उलटा विकर्ण का बायाँ भाग",
  "block.minecraft.banner.diagonal_left.green": "हरा रंग से भरा हुआ उलटा विकर्ण का बायाँ भाग",
  "block.minecraft.banner.diagonal_left.light_blue": "हल्का नीला रंग से भरा हुआ उलटा विकर्ण का बायाँ भाग",
  "block.minecraft.banner.diagonal_left.light_gray": "हल्का स्लेटी रंग से भरा हुआ उलटा विकर्ण का बायाँ भाग",
  "block.minecraft.banner.diagonal_left.lime": "लाइम रंग से भरा हुआ उलटा विकर्ण का बायाँ भाग",
  "block.minecraft.banner.diagonal_left.magenta": "नीलातिरक्त रंग से भरा हुआ उलटा विकर्ण का बायाँ भाग",
  "block.minecraft.banner.diagonal_left.orange": "नारंगी रंग से भरा हुआ उलटा विकर्ण का बायाँ भाग",
  "block.minecraft.banner.diagonal_left.pink": "गुलाबी रंग से भरा हुआ उलटा विकर्ण का बायाँ भाग",
  "block.minecraft.banner.diagonal_left.purple": "जामुनी रंग से भरा हुआ उलटा विकर्ण का बायाँ भाग",
  "block.minecraft.banner.diagonal_left.red": "लाल रंग से भरा हुआ उलटा विकर्ण का बायाँ भाग",
  "block.minecraft.banner.diagonal_left.white": "सफेद रंग से भरा हुआ उलटा विकर्ण का बायाँ भाग",
  "block.minecraft.banner.diagonal_left.yellow": "पीला रंग से भरा हुआ उलटा विकर्ण का बायाँ भाग",
  "block.minecraft.banner.diagonal_right.black": "काला रंग से भरा हुआ विकर्ण का दायाँ भाग",
  "block.minecraft.banner.diagonal_right.blue": "नीला रंग से भरा हुआ विकर्ण का दायाँ भाग",
  "block.minecraft.banner.diagonal_right.brown": "भूरा रंग से भरा हुआ विकर्ण का दायाँ भाग",
  "block.minecraft.banner.diagonal_right.cyan": "हरिनील रंग से भरा हुआ विकर्ण का दायाँ भाग",
  "block.minecraft.banner.diagonal_right.gray": "स्लेटी रंग से भरा हुआ विकर्ण का दायाँ भाग",
  "block.minecraft.banner.diagonal_right.green": "हरा रंग से भरा हुआ विकर्ण का दायाँ भाग",
  "block.minecraft.banner.diagonal_right.light_blue": "हल्का नीला रंग से भरा हुआ विकर्ण का दायाँ भाग",
  "block.minecraft.banner.diagonal_right.light_gray": "हल्का स्लेटी रंग से भरा हुआ विकर्ण का दायाँ भाग",
  "block.minecraft.banner.diagonal_right.lime": "लाइम रंग से भरा हुआ विकर्ण का दायाँ भाग",
  "block.minecraft.banner.diagonal_right.magenta": "नीलातिरक्त रंग से भरा हुआ विकर्ण का दायाँ भाग",
  "block.minecraft.banner.diagonal_right.orange": "नारंगी रंग से भरा हुआ विकर्ण का दायाँ भाग",
  "block.minecraft.banner.diagonal_right.pink": "गुलाबी रंग से भरा हुआ विकर्ण का दायाँ भाग",
  "block.minecraft.banner.diagonal_right.purple": "जामुनी रंग से भरा हुआ विकर्ण का दायाँ भाग",
  "block.minecraft.banner.diagonal_right.red": "लाल रंग से भरा हुआ विकर्ण का दायाँ भाग",
  "block.minecraft.banner.diagonal_right.white": "सफेद रंग से भरा हुआ विकर्ण का दायाँ भाग",
  "block.minecraft.banner.diagonal_right.yellow": "पीला रंग से भरा हुआ विकर्ण का दायाँ भाग",
  "block.minecraft.banner.diagonal_up_left.black": "काला रंग से भरा हुआ विकर्ण का बायाँ भाग",
  "block.minecraft.banner.diagonal_up_left.blue": "नीला रंग से भरा हुआ विकर्ण का बायाँ भाग",
  "block.minecraft.banner.diagonal_up_left.brown": "भूरा रंग से भरा हुआ विकर्ण का बायाँ भाग",
  "block.minecraft.banner.diagonal_up_left.cyan": "हरिनील रंग से भरा हुआ विकर्ण का बायाँ भाग",
  "block.minecraft.banner.diagonal_up_left.gray": "स्लेटी रंग से भरा हुआ विकर्ण का बायाँ भाग",
  "block.minecraft.banner.diagonal_up_left.green": "हरा रंग से भरा हुआ विकर्ण का बायाँ भाग",
  "block.minecraft.banner.diagonal_up_left.light_blue": "हल्का नीला रंग से भरा हुआ विकर्ण का बायाँ भाग",
  "block.minecraft.banner.diagonal_up_left.light_gray": "हल्का स्लेटी रंग से भरा हुआ विकर्ण का बायाँ भाग",
  "block.minecraft.banner.diagonal_up_left.lime": "लाइम रंग से भरा हुआ विकर्ण का बायाँ भाग",
  "block.minecraft.banner.diagonal_up_left.magenta": "नीलातिरक्त रंग से भरा हुआ विकर्ण का बायाँ भाग",
  "block.minecraft.banner.diagonal_up_left.orange": "नारंगी रंग से भरा हुआ विकर्ण का बायाँ भाग",
  "block.minecraft.banner.diagonal_up_left.pink": "गुलाबी रंग से भरा हुआ विकर्ण का बायाँ भाग",
  "block.minecraft.banner.diagonal_up_left.purple": "जामुनी रंग से भरा हुआ विकर्ण का बायाँ भाग",
  "block.minecraft.banner.diagonal_up_left.red": "लाल रंग से भरा हुआ विकर्ण का बायाँ भाग",
  "block.minecraft.banner.diagonal_up_left.white": "सफेद रंग से भरा हुआ विकर्ण का बायाँ भाग",
  "block.minecraft.banner.diagonal_up_left.yellow": "पीला रंग से भरा हुआ विकर्ण का बायाँ भाग",
  "block.minecraft.banner.diagonal_up_right.black": "काला रंग से भरा हुआ उलटा विकर्ण का दायाँ भाग",
  "block.minecraft.banner.diagonal_up_right.blue": "नीला रंग से भरा हुआ उलटा विकर्ण का दायाँ भाग",
  "block.minecraft.banner.diagonal_up_right.brown": "भूरा रंग से भरा हुआ उलटा विकर्ण का दायाँ भाग",
  "block.minecraft.banner.diagonal_up_right.cyan": "हरिनील रंग से भरा हुआ उलटा विकर्ण का दायाँ भाग",
  "block.minecraft.banner.diagonal_up_right.gray": "स्लेटी रंग से भरा हुआ उलटा विकर्ण का दायाँ भाग",
  "block.minecraft.banner.diagonal_up_right.green": "हरा रंग से भरा हुआ उलटा विकर्ण का दायाँ भाग",
  "block.minecraft.banner.diagonal_up_right.light_blue": "हल्का नीला रंग से भरा हुआ उलटा विकर्ण का दायाँ भाग",
  "block.minecraft.banner.diagonal_up_right.light_gray": "हल्का रंग से भरा हुआ उलटा विकर्ण का दायाँ भाग",
  "block.minecraft.banner.diagonal_up_right.lime": "लाइम रंग से भरा हुआ उलटा विकर्ण का दायाँ भाग",
  "block.minecraft.banner.diagonal_up_right.magenta": "नीलातिरक्त रंग से भरा हुआ उलटा विकर्ण का दायाँ भाग",
  "block.minecraft.banner.diagonal_up_right.orange": "नारंगी रंग से भरा हुआ उलटा विकर्ण का दायाँ भाग",
  "block.minecraft.banner.diagonal_up_right.pink": "गुलाबी रंग से भरा हुआ उलटा विकर्ण का दायाँ भाग",
  "block.minecraft.banner.diagonal_up_right.purple": "जामुनी रंग से भरा हुआ उलटा विकर्ण का दायाँ भाग",
  "block.minecraft.banner.diagonal_up_right.red": "लाल रंग से भरा हुआ उलटा विकर्ण का दायाँ भाग",
  "block.minecraft.banner.diagonal_up_right.white": "सफेद रंग से भरा हुआ उलटा विकर्ण का दायाँ भाग",
  "block.minecraft.banner.diagonal_up_right.yellow": "पीला रंग से भरा हुआ उलटा विकर्ण का दायाँ भाग",
  "block.minecraft.banner.flow.black": "काला प्रावाह​",
  "block.minecraft.banner.flow.blue": "काला प्रावाह​",
  "block.minecraft.banner.flow.brown": "भूरा प्रावाह​",
  "block.minecraft.banner.flow.cyan": "हरिनील प्रावाह​",
  "block.minecraft.banner.flow.gray": "स्लेटी प्रावाह​",
  "block.minecraft.banner.flow.green": "हरा प्रावाह​",
  "block.minecraft.banner.flow.light_blue": "हल्का नीला प्रावाह​",
  "block.minecraft.banner.flow.light_gray": "हल्का स्लेटी प्रावाह​",
  "block.minecraft.banner.flow.lime": "नींबु हरा​ प्रावाह​",
  "block.minecraft.banner.flow.magenta": "नीलातिरक्त प्रावाह​",
  "block.minecraft.banner.flow.orange": "नारंगी प्रावाह​",
  "block.minecraft.banner.flow.pink": "गुलाबी प्रावाह​",
  "block.minecraft.banner.flow.purple": "जामुनी प्रावाह​",
  "block.minecraft.banner.flow.red": "लाल प्रावाह​​",
  "block.minecraft.banner.flow.white": "सफ़ेद प्रावाह​​",
  "block.minecraft.banner.flow.yellow": "पीला प्रावाह​​",
  "block.minecraft.banner.flower.black": "काला फूल का अभिकल्प",
  "block.minecraft.banner.flower.blue": "नीला फूल का अभिकल्प",
  "block.minecraft.banner.flower.brown": "भूरा फूल का अभिकल्प",
  "block.minecraft.banner.flower.cyan": "हरिनील फूल का अभिकल्प",
  "block.minecraft.banner.flower.gray": "स्लेटी फूल का अभिकल्प",
  "block.minecraft.banner.flower.green": "हरा फूल का अभिकल्प",
  "block.minecraft.banner.flower.light_blue": "हल्का नीला फूल का अभिकल्प",
  "block.minecraft.banner.flower.light_gray": "हल्का स्लेटी फूल का अभिकल्प",
  "block.minecraft.banner.flower.lime": "लाईम फूल का अभिकल्प",
  "block.minecraft.banner.flower.magenta": "नीलातिरक्त फूल का अभिकल्प",
  "block.minecraft.banner.flower.orange": "नारंगी फूल का अभिकल्प",
  "block.minecraft.banner.flower.pink": "गुलाबी फूल का अभिकल्प",
  "block.minecraft.banner.flower.purple": "जामुनी फूल का अभिकल्प",
  "block.minecraft.banner.flower.red": "लाल फूल का अभिकल्प",
  "block.minecraft.banner.flower.white": "सफेद फूल का अभिकल्प",
  "block.minecraft.banner.flower.yellow": "पीला फूल का अभिकल्प",
  "block.minecraft.banner.globe.black": "काला ग्लोब",
  "block.minecraft.banner.globe.blue": "नीला ग्लोब",
  "block.minecraft.banner.globe.brown": "भूरा ग्लोब",
  "block.minecraft.banner.globe.cyan": "हरिनील ग्लोब",
  "block.minecraft.banner.globe.gray": "स्लेटी ग्लोब",
  "block.minecraft.banner.globe.green": "हरा ग्लोब",
  "block.minecraft.banner.globe.light_blue": "हल्का नीला ग्लोब",
  "block.minecraft.banner.globe.light_gray": "हल्का स्लेटी ग्लोब",
  "block.minecraft.banner.globe.lime": "लाइम ग्लोब",
  "block.minecraft.banner.globe.magenta": "नीलातिरक्त ग्लोब",
  "block.minecraft.banner.globe.orange": "नारंगी ग्लोब",
  "block.minecraft.banner.globe.pink": "गुलाबी ग्लोब",
  "block.minecraft.banner.globe.purple": "जामुनी ग्लोब",
  "block.minecraft.banner.globe.red": "लाल ग्लोब",
  "block.minecraft.banner.globe.white": "सफेद ग्लोब",
  "block.minecraft.banner.globe.yellow": "पीला ग्लोब",
  "block.minecraft.banner.gradient.black": "काली प्रवणता",
  "block.minecraft.banner.gradient.blue": "नीली प्रवणता",
  "block.minecraft.banner.gradient.brown": "भूरी प्रवणता",
  "block.minecraft.banner.gradient.cyan": "हरिनील प्रवणता",
  "block.minecraft.banner.gradient.gray": "स्लेटी प्रवणता",
  "block.minecraft.banner.gradient.green": "हरी प्रवणता",
  "block.minecraft.banner.gradient.light_blue": "हल्की नीली प्रवणता",
  "block.minecraft.banner.gradient.light_gray": "हल्की स्लेटी प्रवणता",
  "block.minecraft.banner.gradient.lime": "लाइम प्रवणता",
  "block.minecraft.banner.gradient.magenta": "नीलातिरक्त प्रवणता",
  "block.minecraft.banner.gradient.orange": "नारंगी प्रवणता",
  "block.minecraft.banner.gradient.pink": "गुलाबी प्रवणता",
  "block.minecraft.banner.gradient.purple": "जामुनी प्रवणता",
  "block.minecraft.banner.gradient.red": "लाल प्रवणता",
  "block.minecraft.banner.gradient.white": "सफेद प्रवणता",
  "block.minecraft.banner.gradient.yellow": "पीली प्रवणता",
  "block.minecraft.banner.gradient_up.black": "काली उल्टी प्रवणता",
  "block.minecraft.banner.gradient_up.blue": "नीली उल्टी प्रवणता",
  "block.minecraft.banner.gradient_up.brown": "भूरी उल्टी प्रवणता",
  "block.minecraft.banner.gradient_up.cyan": "हरिनील उल्टी प्रवणता",
  "block.minecraft.banner.gradient_up.gray": "स्लेटी उल्टी प्रवणता",
  "block.minecraft.banner.gradient_up.green": "हरी उल्टी प्रवणता",
  "block.minecraft.banner.gradient_up.light_blue": "हल्की नीली उल्टी प्रवणता",
  "block.minecraft.banner.gradient_up.light_gray": "हल्की स्लेटी उल्टी प्रवणता",
  "block.minecraft.banner.gradient_up.lime": "लाइम उल्टी प्रवणता",
  "block.minecraft.banner.gradient_up.magenta": "नीलातिरक्त उल्टी प्रवणता",
  "block.minecraft.banner.gradient_up.orange": "नारंगी उल्टी प्रवणता",
  "block.minecraft.banner.gradient_up.pink": "गुलाबी उल्टी प्रवणता",
  "block.minecraft.banner.gradient_up.purple": "जामुनी उल्टी प्रवणता",
  "block.minecraft.banner.gradient_up.red": "लाल उल्टी प्रवणता",
  "block.minecraft.banner.gradient_up.white": "सफेद उल्टी प्रवणता",
  "block.minecraft.banner.gradient_up.yellow": "पीली उल्टी प्रवणता",
  "block.minecraft.banner.guster.black": "काला बैनर",
  "block.minecraft.banner.guster.blue": "नीला बैनर",
  "block.minecraft.banner.guster.brown": "भूरा बैनर",
  "block.minecraft.banner.guster.cyan": "हरिनील बैनर",
  "block.minecraft.banner.guster.gray": "ग्रे बैनर",
  "block.minecraft.banner.guster.green": "हरा बैनर",
  "block.minecraft.banner.guster.light_blue": "हल्का नीला बैनर",
  "block.minecraft.banner.guster.light_gray": "हल्का ग्रे बैनर",
  "block.minecraft.banner.guster.lime": "नारंगी बैनर",
  "block.minecraft.banner.guster.magenta": "मैजेंटा बैनर",
  "block.minecraft.banner.guster.orange": "नारंगी बैनर",
  "block.minecraft.banner.guster.pink": "गुलाबी बैनर",
  "block.minecraft.banner.guster.purple": "बैंगनी बैनर",
  "block.minecraft.banner.guster.red": "लाल बैनर",
  "block.minecraft.banner.guster.white": "स्वेत बैनर",
  "block.minecraft.banner.guster.yellow": "पीला बैनर",
  "block.minecraft.banner.half_horizontal.black": "काला ऊपरी आधा हिस्सा",
  "block.minecraft.banner.half_horizontal.blue": "नीला ऊपरी आधा हिस्सा",
  "block.minecraft.banner.half_horizontal.brown": "भूरा ऊपरी आधा हिस्सा",
  "block.minecraft.banner.half_horizontal.cyan": "हरिनील ऊपरी आधा हिस्सा",
  "block.minecraft.banner.half_horizontal.gray": "स्लेटी ऊपरी आधा हिस्सा",
  "block.minecraft.banner.half_horizontal.green": "हरा ऊपरी आधा हिस्सा",
  "block.minecraft.banner.half_horizontal.light_blue": "हल्का नीला ऊपरी आधा हिस्सा",
  "block.minecraft.banner.half_horizontal.light_gray": "हल्का स्लेटी ऊपरी आधा हिस्सा",
  "block.minecraft.banner.half_horizontal.lime": "लाइम ऊपरी आधा हिस्सा",
  "block.minecraft.banner.half_horizontal.magenta": "नीलातिरक्त ऊपरी आधा हिस्सा",
  "block.minecraft.banner.half_horizontal.orange": "नारंगी ऊपरी आधा हिस्सा",
  "block.minecraft.banner.half_horizontal.pink": "गुलाबी ऊपरी आधा हिस्सा",
  "block.minecraft.banner.half_horizontal.purple": "जामुनी ऊपरी आधा हिस्सा",
  "block.minecraft.banner.half_horizontal.red": "लाल ऊपरी आधा हिस्सा",
  "block.minecraft.banner.half_horizontal.white": "सफेद ऊपरी आधा हिस्सा",
  "block.minecraft.banner.half_horizontal.yellow": "पीला ऊपरी आधा हिस्सा",
  "block.minecraft.banner.half_horizontal_bottom.black": "काला निचला आधा हिस्सा",
  "block.minecraft.banner.half_horizontal_bottom.blue": "नीला निचला आधा हिस्सा",
  "block.minecraft.banner.half_horizontal_bottom.brown": "भूरा निचला आधा हिस्सा",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "हरिनील निचला आधा हिस्सा",
  "block.minecraft.banner.half_horizontal_bottom.gray": "स्लेटी निचला आधा हिस्सा",
  "block.minecraft.banner.half_horizontal_bottom.green": "हरा निचला आधा हिस्सा",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "हल्का नीला निचला आधा हिस्सा",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "हल्का स्लेटी निचला आधा हिस्सा",
  "block.minecraft.banner.half_horizontal_bottom.lime": "लाइम निचला आधा हिस्सा",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "नीलातिरक्त निचला आधा हिस्सा",
  "block.minecraft.banner.half_horizontal_bottom.orange": "नारंगी निचला आधा हिस्सा",
  "block.minecraft.banner.half_horizontal_bottom.pink": "गुलाबी निचला आधा हिस्सा",
  "block.minecraft.banner.half_horizontal_bottom.purple": "जामुनी निचला आधा हिस्सा",
  "block.minecraft.banner.half_horizontal_bottom.red": "लाल निचला आधा हिस्सा",
  "block.minecraft.banner.half_horizontal_bottom.white": "सफेद निचला आधा हिस्सा",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "पीला निचला आधा हिस्सा",
  "block.minecraft.banner.half_vertical.black": "काला खड़ा वाम अर्ध भाग",
  "block.minecraft.banner.half_vertical.blue": "नीला खड़ा वाम अर्ध भाग",
  "block.minecraft.banner.half_vertical.brown": "भूरा खड़ा वाम अर्ध भाग",
  "block.minecraft.banner.half_vertical.cyan": "हरिनील खड़ा वाम अर्ध भाग",
  "block.minecraft.banner.half_vertical.gray": "स्लेटी खड़ा वाम अर्ध भाग",
  "block.minecraft.banner.half_vertical.green": "हरा खड़ा वाम अर्ध भाग",
  "block.minecraft.banner.half_vertical.light_blue": "हल्का नीला खड़ा वाम अर्ध भाग",
  "block.minecraft.banner.half_vertical.light_gray": "हल्का स्लेटी खड़ा वाम अर्ध भाग",
  "block.minecraft.banner.half_vertical.lime": "लाइम खड़ा वाम अर्ध भाग",
  "block.minecraft.banner.half_vertical.magenta": "नीलातिरक्त खड़ा वाम अर्ध भाग",
  "block.minecraft.banner.half_vertical.orange": "नारंगी खड़ा वाम अर्ध भाग",
  "block.minecraft.banner.half_vertical.pink": "गुलाबी खड़ा वाम अर्ध भाग",
  "block.minecraft.banner.half_vertical.purple": "जामुनी खड़ा वाम अर्ध भाग",
  "block.minecraft.banner.half_vertical.red": "लाल खड़ा वाम अर्ध भाग",
  "block.minecraft.banner.half_vertical.white": "सफेद खड़ा वाम अर्ध भाग",
  "block.minecraft.banner.half_vertical.yellow": "पीला खड़ा वाम अर्ध भाग",
  "block.minecraft.banner.half_vertical_right.black": "काला खड़ा दाहिना अर्ध भाग",
  "block.minecraft.banner.half_vertical_right.blue": "नीला खड़ा दाहिना अर्ध भाग",
  "block.minecraft.banner.half_vertical_right.brown": "भूरा खड़ा दाहिना अर्ध भाग",
  "block.minecraft.banner.half_vertical_right.cyan": "हरिनील खड़ा दाहिना अर्ध भाग",
  "block.minecraft.banner.half_vertical_right.gray": "स्लेटी खड़ा दाहिना अर्ध भाग",
  "block.minecraft.banner.half_vertical_right.green": "हरा खड़ा दाहिना अर्ध भाग",
  "block.minecraft.banner.half_vertical_right.light_blue": "हल्का नीला खड़ा दाहिना अर्ध भाग",
  "block.minecraft.banner.half_vertical_right.light_gray": "हल्का स्लेटी खड़ा दाहिना अर्ध भाग",
  "block.minecraft.banner.half_vertical_right.lime": "लाइम खड़ा दाहिना अर्ध भाग",
  "block.minecraft.banner.half_vertical_right.magenta": "नीलातिरक्त खड़ा दाहिना अर्ध भाग",
  "block.minecraft.banner.half_vertical_right.orange": "नारंगी खड़ा दाहिना अर्ध भाग",
  "block.minecraft.banner.half_vertical_right.pink": "गुलाबी खड़ा दाहिना अर्ध भाग",
  "block.minecraft.banner.half_vertical_right.purple": "जामुनी खड़ा दाहिना अर्ध भाग",
  "block.minecraft.banner.half_vertical_right.red": "लाल खड़ा दाहिना अर्ध भाग",
  "block.minecraft.banner.half_vertical_right.white": "सफेद खड़ा दाहिना अर्ध भाग",
  "block.minecraft.banner.half_vertical_right.yellow": "पीला ऊर्ध्वाधर आधा भाग",
  "block.minecraft.banner.mojang.black": "काली चीज",
  "block.minecraft.banner.mojang.blue": "नीली चीज",
  "block.minecraft.banner.mojang.brown": "भूरी चीज",
  "block.minecraft.banner.mojang.cyan": "हरिनील चीज",
  "block.minecraft.banner.mojang.gray": "स्लेटी चीज",
  "block.minecraft.banner.mojang.green": "हरी चीज",
  "block.minecraft.banner.mojang.light_blue": "हल्की नीली चीज",
  "block.minecraft.banner.mojang.light_gray": "हल्की स्लेटी चीज",
  "block.minecraft.banner.mojang.lime": "लाइम चीज",
  "block.minecraft.banner.mojang.magenta": "नीलातिरक्त चीज",
  "block.minecraft.banner.mojang.orange": "नारंगी चीज",
  "block.minecraft.banner.mojang.pink": "गुलाबी चीज",
  "block.minecraft.banner.mojang.purple": "जामुनी चीज",
  "block.minecraft.banner.mojang.red": "लाल चीज",
  "block.minecraft.banner.mojang.white": "सफेद चीज़",
  "block.minecraft.banner.mojang.yellow": "पीली चीज",
  "block.minecraft.banner.piglin.black": "काला थूथन",
  "block.minecraft.banner.piglin.blue": "नीला थूथन",
  "block.minecraft.banner.piglin.brown": "भूरा थूथन",
  "block.minecraft.banner.piglin.cyan": "हरिनील थूथन",
  "block.minecraft.banner.piglin.gray": "स्लेटी थूथन",
  "block.minecraft.banner.piglin.green": "हरा थूथन",
  "block.minecraft.banner.piglin.light_blue": "हल्का नीला थूथन",
  "block.minecraft.banner.piglin.light_gray": "हल्का स्लेटी थूथन",
  "block.minecraft.banner.piglin.lime": "लाइम थूथन",
  "block.minecraft.banner.piglin.magenta": "नीलातिरक्त थूथन",
  "block.minecraft.banner.piglin.orange": "नारंगी थूथन",
  "block.minecraft.banner.piglin.pink": "गुलाबी थूथन",
  "block.minecraft.banner.piglin.purple": "जामुनी थूथन",
  "block.minecraft.banner.piglin.red": "लाल थूथन",
  "block.minecraft.banner.piglin.white": "सफेद थूथन",
  "block.minecraft.banner.piglin.yellow": "पीला थूथन",
  "block.minecraft.banner.rhombus.black": "काला समचतुर्भुज",
  "block.minecraft.banner.rhombus.blue": "नीला समचतुर्भुज",
  "block.minecraft.banner.rhombus.brown": "भूरा समचतुर्भुज",
  "block.minecraft.banner.rhombus.cyan": "हरिनील समचतुर्भुज",
  "block.minecraft.banner.rhombus.gray": "स्लेटी समचतुर्भुज",
  "block.minecraft.banner.rhombus.green": "हरा समचतुर्भुज",
  "block.minecraft.banner.rhombus.light_blue": "हल्का नीला समचतुर्भुज",
  "block.minecraft.banner.rhombus.light_gray": "हल्का स्लेटी समचतुर्भुज",
  "block.minecraft.banner.rhombus.lime": "लाइम समचतुर्भुज",
  "block.minecraft.banner.rhombus.magenta": "नीलातिरक्त समचतुर्भुज",
  "block.minecraft.banner.rhombus.orange": "नारंगी समचतुर्भुज",
  "block.minecraft.banner.rhombus.pink": "गुलाबी समचतुर्भुज",
  "block.minecraft.banner.rhombus.purple": "जामुनी समचतुर्भुज",
  "block.minecraft.banner.rhombus.red": "लाल समचतुर्भुज",
  "block.minecraft.banner.rhombus.white": "सफेद समचतुर्भुज",
  "block.minecraft.banner.rhombus.yellow": "पिला समचतुर्भुज",
  "block.minecraft.banner.skull.black": "काली खोपड़ी का अभिकल्प",
  "block.minecraft.banner.skull.blue": "नीली खोपड़ी का अभिकल्प",
  "block.minecraft.banner.skull.brown": "भूरी खोपड़ी का अभिकल्प",
  "block.minecraft.banner.skull.cyan": "हारेनील खोपड़ी का अभिकल्प",
  "block.minecraft.banner.skull.gray": "स्लेटी खोपड़ी का अभिकल्प",
  "block.minecraft.banner.skull.green": "हरी खोपड़ी का अभिकल्प",
  "block.minecraft.banner.skull.light_blue": "हल्की नीली खोपड़ी का अभिकल्प",
  "block.minecraft.banner.skull.light_gray": "हल्की स्लेटी खोपड़ी का अभिकल्प",
  "block.minecraft.banner.skull.lime": "लाइम खोपड़ी का अभिकल्प",
  "block.minecraft.banner.skull.magenta": "नीलातिरक्त खोपड़ी का अभिकल्प",
  "block.minecraft.banner.skull.orange": "नारंगी खोपड़ी का अभिकल्प",
  "block.minecraft.banner.skull.pink": "गुलाबी खोपड़ी का अभिकल्प",
  "block.minecraft.banner.skull.purple": "जामुनी खोपड़ी का अभिकल्प",
  "block.minecraft.banner.skull.red": "लाल खोपड़ी का अभिकल्प",
  "block.minecraft.banner.skull.white": "सपेद खोपड़ी का अभिकल्प",
  "block.minecraft.banner.skull.yellow": "पीली खोपड़ी का अभिकल्प",
  "block.minecraft.banner.small_stripes.black": "काली खड़ी पट्टियाँ",
  "block.minecraft.banner.small_stripes.blue": "नीली खड़ी पट्टियाँ",
  "block.minecraft.banner.small_stripes.brown": "भूरी खड़ी पट्टियाँ",
  "block.minecraft.banner.small_stripes.cyan": "हरिनील खड़ी पट्टियाँ",
  "block.minecraft.banner.small_stripes.gray": "स्लेटी खड़ी पट्टियाँ",
  "block.minecraft.banner.small_stripes.green": "हरी खड़ी पट्टियाँ",
  "block.minecraft.banner.small_stripes.light_blue": "हल्की नीली खड़ी पट्टियाँ",
  "block.minecraft.banner.small_stripes.light_gray": "हल्की स्लेटी छोटी पट्टियाँ",
  "block.minecraft.banner.small_stripes.lime": "लाइम खड़ी पट्टियाँ",
  "block.minecraft.banner.small_stripes.magenta": "नीलातिरक्त खड़ी पट्टियाँ",
  "block.minecraft.banner.small_stripes.orange": "नारंगी खड़ी पट्टियाँ",
  "block.minecraft.banner.small_stripes.pink": "गुलाबी खड़ी पट्टियाँ",
  "block.minecraft.banner.small_stripes.purple": "जामुनी खड़ी पट्टियाँ",
  "block.minecraft.banner.small_stripes.red": "लाल खड़ी पट्टियाँ",
  "block.minecraft.banner.small_stripes.white": "सफेद खड़ी पट्टियाँ",
  "block.minecraft.banner.small_stripes.yellow": "पीली खड़ी पट्टियाँ",
  "block.minecraft.banner.square_bottom_left.black": "काला निचला वाम भाग",
  "block.minecraft.banner.square_bottom_left.blue": "नीला निचला वाम भाग",
  "block.minecraft.banner.square_bottom_left.brown": "भूरा निचला वाम भाग",
  "block.minecraft.banner.square_bottom_left.cyan": "हरिनील निचला वाम भाग",
  "block.minecraft.banner.square_bottom_left.gray": "स्लेटी निचला वाम भाग",
  "block.minecraft.banner.square_bottom_left.green": "हरा निचला वाम भाग",
  "block.minecraft.banner.square_bottom_left.light_blue": "हल्का नीला निचला वाम भाग",
  "block.minecraft.banner.square_bottom_left.light_gray": "हल्का स्लेटी निचला वाम भाग",
  "block.minecraft.banner.square_bottom_left.lime": "लाइम निचला वाम भाग",
  "block.minecraft.banner.square_bottom_left.magenta": "नीलातिरक्त निचला वाम भाग",
  "block.minecraft.banner.square_bottom_left.orange": "नारंगी निचला वाम भाग",
  "block.minecraft.banner.square_bottom_left.pink": "गुलाबी निचला वाम भाग",
  "block.minecraft.banner.square_bottom_left.purple": "जामुनी निचला वाम भाग",
  "block.minecraft.banner.square_bottom_left.red": "लाल निचला वाम भाग",
  "block.minecraft.banner.square_bottom_left.white": "सफेद निचला वाम भाग",
  "block.minecraft.banner.square_bottom_left.yellow": "पीला निचला वाम भाग",
  "block.minecraft.banner.square_bottom_right.black": "काला निचला दाहिना भाग",
  "block.minecraft.banner.square_bottom_right.blue": "नीला निचला दाहिना भाग",
  "block.minecraft.banner.square_bottom_right.brown": "भूरा निचला दाहिना भाग",
  "block.minecraft.banner.square_bottom_right.cyan": "हरिनील निचला दाहिना भाग",
  "block.minecraft.banner.square_bottom_right.gray": "स्लेटी निचला दाहिना भाग",
  "block.minecraft.banner.square_bottom_right.green": "हरा निचला दाहिना भाग",
  "block.minecraft.banner.square_bottom_right.light_blue": "हल्का नीला निचला दाहिना भाग",
  "block.minecraft.banner.square_bottom_right.light_gray": "हल्का स्लेटी निचला दाहिना भाग",
  "block.minecraft.banner.square_bottom_right.lime": "लाइम निचला दाहिना भाग",
  "block.minecraft.banner.square_bottom_right.magenta": "नीलातिरक्त निचला दाहिना भाग",
  "block.minecraft.banner.square_bottom_right.orange": "नारंगी निचला दाहिना भाग",
  "block.minecraft.banner.square_bottom_right.pink": "गुलाबी निचला दाहिना भाग",
  "block.minecraft.banner.square_bottom_right.purple": "जामुनी निचला दाहिना भाग",
  "block.minecraft.banner.square_bottom_right.red": "लाल निचला दाहिना भाग",
  "block.minecraft.banner.square_bottom_right.white": "सफेद निचला दाहिना भाग",
  "block.minecraft.banner.square_bottom_right.yellow": "पीला निचला दाहिना भाग",
  "block.minecraft.banner.square_top_left.black": "काला ऊपरी वाम भाग",
  "block.minecraft.banner.square_top_left.blue": "नीला ऊपरी वाम भाग",
  "block.minecraft.banner.square_top_left.brown": "भूरा ऊपरी वाम भाग",
  "block.minecraft.banner.square_top_left.cyan": "हरिनील ऊपरी वाम भाग",
  "block.minecraft.banner.square_top_left.gray": "स्लेटी ऊपरी वाम भाग",
  "block.minecraft.banner.square_top_left.green": "हरा ऊपरी वाम भाग",
  "block.minecraft.banner.square_top_left.light_blue": "उल्का नीला ऊपरी वाम भाग",
  "block.minecraft.banner.square_top_left.light_gray": "हल्का स्लेटी ऊपरी वाम भाग",
  "block.minecraft.banner.square_top_left.lime": "लाइम ऊपरी वाम भाग",
  "block.minecraft.banner.square_top_left.magenta": "नीलातिरक्त ऊपरी वाम भाग",
  "block.minecraft.banner.square_top_left.orange": "नारंगी ऊपरी वाम भाग",
  "block.minecraft.banner.square_top_left.pink": "गुलाबी ऊपरी वाम भाग",
  "block.minecraft.banner.square_top_left.purple": "जामुनी ऊपरी वाम भाग",
  "block.minecraft.banner.square_top_left.red": "लाल ऊपरी वाम भाग",
  "block.minecraft.banner.square_top_left.white": "सफेद ऊपरी वाम भाग",
  "block.minecraft.banner.square_top_left.yellow": "पीला ऊपरी वाम भाग",
  "block.minecraft.banner.square_top_right.black": "काला ऊपरी दाहिना भाग",
  "block.minecraft.banner.square_top_right.blue": "नीला ऊपरी दाहिना भाग",
  "block.minecraft.banner.square_top_right.brown": "भूरा ऊपरी दाहिना भाग",
  "block.minecraft.banner.square_top_right.cyan": "हरिनील ऊपरी दाहिना भाग",
  "block.minecraft.banner.square_top_right.gray": "स्लेटी ऊपरी दाहिना भाग",
  "block.minecraft.banner.square_top_right.green": "हरा ऊपरी दाहिना भाग",
  "block.minecraft.banner.square_top_right.light_blue": "हल्का नीला ऊपरी दाहिना भाग",
  "block.minecraft.banner.square_top_right.light_gray": "हल्का स्लेटी ऊपरी दाहिना भाग",
  "block.minecraft.banner.square_top_right.lime": "लाइम ऊपरी दाहिना भाग",
  "block.minecraft.banner.square_top_right.magenta": "नीलातिरक्त ऊपरी दाहिना भाग",
  "block.minecraft.banner.square_top_right.orange": "नारंगी ऊपरी दाहिना भाग",
  "block.minecraft.banner.square_top_right.pink": "गुलाबी ऊपरी दाहिना भाग",
  "block.minecraft.banner.square_top_right.purple": "जामुनी ऊपरी दाहिना भाग",
  "block.minecraft.banner.square_top_right.red": "लाल ऊपरी दाहिना भाग",
  "block.minecraft.banner.square_top_right.white": "सफेद ऊपरी दाहिना भाग",
  "block.minecraft.banner.square_top_right.yellow": "पीला ऊपरी दाहिना भाग",
  "block.minecraft.banner.straight_cross.black": "काला धन चिह्न",
  "block.minecraft.banner.straight_cross.blue": "नीला धन चिह्न",
  "block.minecraft.banner.straight_cross.brown": "भूरा धन चिह्न",
  "block.minecraft.banner.straight_cross.cyan": "हरिनील धन चिह्न",
  "block.minecraft.banner.straight_cross.gray": "स्लेटी धन चिह्न",
  "block.minecraft.banner.straight_cross.green": "हरा धन चिह्न",
  "block.minecraft.banner.straight_cross.light_blue": "हल्का नीला धन चिह्न",
  "block.minecraft.banner.straight_cross.light_gray": "हल्का स्लेटी धन चिह्न",
  "block.minecraft.banner.straight_cross.lime": "लाइम धन चिह्न",
  "block.minecraft.banner.straight_cross.magenta": "नीलातिरक्त धन चिह्न",
  "block.minecraft.banner.straight_cross.orange": "नारंगी धन चिह्न",
  "block.minecraft.banner.straight_cross.pink": "गुलाबी धन चिह्न",
  "block.minecraft.banner.straight_cross.purple": "जामुनी धन चिह्न",
  "block.minecraft.banner.straight_cross.red": "लाल धन चिह्न",
  "block.minecraft.banner.straight_cross.white": "सफेद धन चिह्न",
  "block.minecraft.banner.straight_cross.yellow": "पीला धन चिह्न",
  "block.minecraft.banner.stripe_bottom.black": "काली निचली पट्टी",
  "block.minecraft.banner.stripe_bottom.blue": "नीली निचली पट्टी",
  "block.minecraft.banner.stripe_bottom.brown": "भूरी निचली पट्टी",
  "block.minecraft.banner.stripe_bottom.cyan": "हरिनील निचली पट्टी",
  "block.minecraft.banner.stripe_bottom.gray": "स्लेटी निचली पट्टी",
  "block.minecraft.banner.stripe_bottom.green": "हरी निचली पट्टी",
  "block.minecraft.banner.stripe_bottom.light_blue": "उल्की नीली निचली पट्टी",
  "block.minecraft.banner.stripe_bottom.light_gray": "हल्की स्लेटी निचली पट्टी",
  "block.minecraft.banner.stripe_bottom.lime": "लाइम निचली पट्टी",
  "block.minecraft.banner.stripe_bottom.magenta": "नीलातिरक्त निचली पट्टी",
  "block.minecraft.banner.stripe_bottom.orange": "नारंगी निचली पट्टी",
  "block.minecraft.banner.stripe_bottom.pink": "गुलाबी निचली पट्टी",
  "block.minecraft.banner.stripe_bottom.purple": "जामुनी निचली पट्टी",
  "block.minecraft.banner.stripe_bottom.red": "लाल निचली पट्टी",
  "block.minecraft.banner.stripe_bottom.white": "सफेद निचली पट्टी",
  "block.minecraft.banner.stripe_bottom.yellow": "पीली निचली पट्टी",
  "block.minecraft.banner.stripe_center.black": "काली खड़ी मध्य पट्टी",
  "block.minecraft.banner.stripe_center.blue": "नीली खड़ी मध्य पट्टी",
  "block.minecraft.banner.stripe_center.brown": "भूरी खड़ी मध्य पट्टी",
  "block.minecraft.banner.stripe_center.cyan": "हरिनील खड़ी मध्य पट्टी",
  "block.minecraft.banner.stripe_center.gray": "स्लेटी खड़ी मध्य पट्टी",
  "block.minecraft.banner.stripe_center.green": "हरी खड़ी मध्य पट्टी",
  "block.minecraft.banner.stripe_center.light_blue": "हल्की नीली खड़ी मध्य पट्टी",
  "block.minecraft.banner.stripe_center.light_gray": "हल्की स्लेटी खड़ी मध्य पट्टी",
  "block.minecraft.banner.stripe_center.lime": "लाईम खड़ी मध्य पट्टी",
  "block.minecraft.banner.stripe_center.magenta": "नीलातिरक्त खड़ी मध्य पट्टी",
  "block.minecraft.banner.stripe_center.orange": "नारंगी खड़ी मध्य पट्टी",
  "block.minecraft.banner.stripe_center.pink": "गुलाबी खड़ी मध्य पट्टी",
  "block.minecraft.banner.stripe_center.purple": "जामुनी खड़ी मध्य पट्टी",
  "block.minecraft.banner.stripe_center.red": "लाल खड़ी मध्य पट्टी",
  "block.minecraft.banner.stripe_center.white": "सफेद खड़ी मध्य पट्टी",
  "block.minecraft.banner.stripe_center.yellow": "पीली खड़ी मध्य पट्टी",
  "block.minecraft.banner.stripe_downleft.black": "काला उलटा विकर्ण",
  "block.minecraft.banner.stripe_downleft.blue": "नीला उलटा विकर्ण",
  "block.minecraft.banner.stripe_downleft.brown": "भूरा उलटा विकर्ण",
  "block.minecraft.banner.stripe_downleft.cyan": "हरिनील उलटा विकर्ण",
  "block.minecraft.banner.stripe_downleft.gray": "स्लेटी उलटा विकर्ण",
  "block.minecraft.banner.stripe_downleft.green": "हरा उलटा विकर्ण",
  "block.minecraft.banner.stripe_downleft.light_blue": "हल्का नीला उलटा विकर्ण",
  "block.minecraft.banner.stripe_downleft.light_gray": "हल्का स्लेटी उलटा विकर्ण",
  "block.minecraft.banner.stripe_downleft.lime": "लाइम उलटा विकर्ण",
  "block.minecraft.banner.stripe_downleft.magenta": "नीलातिरक्त उलटा विकर्ण",
  "block.minecraft.banner.stripe_downleft.orange": "नारंगी उलटा विकर्ण",
  "block.minecraft.banner.stripe_downleft.pink": "गुलाबी उलटा विकर्ण",
  "block.minecraft.banner.stripe_downleft.purple": "जामुनी उलटा विकर्ण",
  "block.minecraft.banner.stripe_downleft.red": "लाल उलटा विकर्ण",
  "block.minecraft.banner.stripe_downleft.white": "सफेद उलटा विकर्ण",
  "block.minecraft.banner.stripe_downleft.yellow": "पीला उलटा विकर्ण",
  "block.minecraft.banner.stripe_downright.black": "काला विकर्ण",
  "block.minecraft.banner.stripe_downright.blue": "नीला विकर्ण",
  "block.minecraft.banner.stripe_downright.brown": "भूरा विकर्ण",
  "block.minecraft.banner.stripe_downright.cyan": "हरिनील विकर्ण",
  "block.minecraft.banner.stripe_downright.gray": "स्लेटी विकर्ण",
  "block.minecraft.banner.stripe_downright.green": "हरा विकर्ण",
  "block.minecraft.banner.stripe_downright.light_blue": "हल्का नीला विकर्ण",
  "block.minecraft.banner.stripe_downright.light_gray": "हल्का स्लेटी विकर्ण",
  "block.minecraft.banner.stripe_downright.lime": "लाइम विकर्ण",
  "block.minecraft.banner.stripe_downright.magenta": "नीलातिरक्त विकर्ण",
  "block.minecraft.banner.stripe_downright.orange": "नारंगी विकर्ण",
  "block.minecraft.banner.stripe_downright.pink": "गुलाबी विकर्ण",
  "block.minecraft.banner.stripe_downright.purple": "जामुनी विकर्ण",
  "block.minecraft.banner.stripe_downright.red": "लाल विकर्ण",
  "block.minecraft.banner.stripe_downright.white": "सफेद विकर्ण",
  "block.minecraft.banner.stripe_downright.yellow": "पीला विकर्ण",
  "block.minecraft.banner.stripe_left.black": "काली वाम पट्टी",
  "block.minecraft.banner.stripe_left.blue": "नीली वाम पट्टी",
  "block.minecraft.banner.stripe_left.brown": "भूरा वाम पट्टी",
  "block.minecraft.banner.stripe_left.cyan": "हरिनील वाम पट्टी",
  "block.minecraft.banner.stripe_left.gray": "स्लेटी वाम पट्टी",
  "block.minecraft.banner.stripe_left.green": "हरी वाम पट्टी",
  "block.minecraft.banner.stripe_left.light_blue": "हल्की नीली वाम पट्टी",
  "block.minecraft.banner.stripe_left.light_gray": "हल्की स्लेटी वाम पट्टी",
  "block.minecraft.banner.stripe_left.lime": "लाइम वाम पट्टी",
  "block.minecraft.banner.stripe_left.magenta": "नीलातिरक्त वाम पट्टी",
  "block.minecraft.banner.stripe_left.orange": "नारंगी वाम पट्टी",
  "block.minecraft.banner.stripe_left.pink": "गुलाबी वाम पट्टी",
  "block.minecraft.banner.stripe_left.purple": "जामुनी वाम पट्टी",
  "block.minecraft.banner.stripe_left.red": "लाल वाम पट्टी",
  "block.minecraft.banner.stripe_left.white": "सफेद वाम पट्टी",
  "block.minecraft.banner.stripe_left.yellow": "पीली वाम पट्टी",
  "block.minecraft.banner.stripe_middle.black": "काली मध्य क्षैतिज पट्टी",
  "block.minecraft.banner.stripe_middle.blue": "नीली मध्य क्षैतिज पट्टी",
  "block.minecraft.banner.stripe_middle.brown": "भूरी मध्य क्षैतिज पट्टी",
  "block.minecraft.banner.stripe_middle.cyan": "हरिनील मध्य क्षैतिज पट्टी",
  "block.minecraft.banner.stripe_middle.gray": "स्लेटी मध्य क्षैतिज पट्टी",
  "block.minecraft.banner.stripe_middle.green": "हरी मध्य क्षैतिज पट्टी",
  "block.minecraft.banner.stripe_middle.light_blue": "हल्की नीली मध्य क्षैतिज पट्टी",
  "block.minecraft.banner.stripe_middle.light_gray": "हल्की स्लेटी मध्य क्षैतिज पट्टी",
  "block.minecraft.banner.stripe_middle.lime": "लाइम मध्य क्षैतिज पट्टी",
  "block.minecraft.banner.stripe_middle.magenta": "नीलातिरक्त मध्य क्षैतिज पट्टी",
  "block.minecraft.banner.stripe_middle.orange": "नारंगी मध्य क्षैतिज पट्टी",
  "block.minecraft.banner.stripe_middle.pink": "गुलाबी मध्य क्षैतिज पट्टी",
  "block.minecraft.banner.stripe_middle.purple": "जामुनी मध्य क्षैतिज पट्टी",
  "block.minecraft.banner.stripe_middle.red": "लाल मध्य क्षैतिज पट्टी",
  "block.minecraft.banner.stripe_middle.white": "सफेद मध्य क्षैतिज पट्टी",
  "block.minecraft.banner.stripe_middle.yellow": "पीली मध्य क्षैतिज पट्टी",
  "block.minecraft.banner.stripe_right.black": "काली दाहिनी पट्टी",
  "block.minecraft.banner.stripe_right.blue": "पीली दाहिनी पट्टी",
  "block.minecraft.banner.stripe_right.brown": "भूरी दाहिनी पट्टी",
  "block.minecraft.banner.stripe_right.cyan": "हरिनील दाहिनी पट्टी",
  "block.minecraft.banner.stripe_right.gray": "स्लेटी दाहिनी पट्टी",
  "block.minecraft.banner.stripe_right.green": "हरी दाहिनी पट्टी",
  "block.minecraft.banner.stripe_right.light_blue": "हल्की नीली दाहिनी पट्टी",
  "block.minecraft.banner.stripe_right.light_gray": "हल्की स्लेटी दाहिनी पट्टी",
  "block.minecraft.banner.stripe_right.lime": "लाइम दाहिनी पट्टी",
  "block.minecraft.banner.stripe_right.magenta": "नीलातिरक्त दाहिनी पट्टी",
  "block.minecraft.banner.stripe_right.orange": "नारंगी दाहिनी पट्टी",
  "block.minecraft.banner.stripe_right.pink": "गुलाबी दाहिनी पट्टी",
  "block.minecraft.banner.stripe_right.purple": "जामुनी दाहिनी पट्टी",
  "block.minecraft.banner.stripe_right.red": "लाल दाहिनी पट्टी",
  "block.minecraft.banner.stripe_right.white": "सफेद दाहिनी पट्टी",
  "block.minecraft.banner.stripe_right.yellow": "पीली दाहिनी पट्टी",
  "block.minecraft.banner.stripe_top.black": "काला रंग का ऊपरी पट्टी",
  "block.minecraft.banner.stripe_top.blue": "नीला रंग का ऊपरी पट्टी",
  "block.minecraft.banner.stripe_top.brown": "भूरा रंग का ऊपरी पट्टी",
  "block.minecraft.banner.stripe_top.cyan": "हरिनील रंग का ऊपरी पट्टी",
  "block.minecraft.banner.stripe_top.gray": "स्लेटी रंग का ऊपरी पट्टी",
  "block.minecraft.banner.stripe_top.green": "हरा रंग का ऊपरी पट्टी",
  "block.minecraft.banner.stripe_top.light_blue": "हल्का नीला रंग का ऊपरी पट्टी",
  "block.minecraft.banner.stripe_top.light_gray": "हल्का स्लेटी रंग का ऊपरी पट्टी",
  "block.minecraft.banner.stripe_top.lime": "लाइम रंग का ऊपरी पट्टी",
  "block.minecraft.banner.stripe_top.magenta": "नीलातिरक्त रंग का ऊपरी पट्टी",
  "block.minecraft.banner.stripe_top.orange": "नारंगी रंग का ऊपरी पट्टी",
  "block.minecraft.banner.stripe_top.pink": "गुलाबी रंग का ऊपरी पट्टी",
  "block.minecraft.banner.stripe_top.purple": "जामुनी रंग का ऊपरी पट्टी",
  "block.minecraft.banner.stripe_top.red": "लाल रंग का ऊपरी पट्टी",
  "block.minecraft.banner.stripe_top.white": "सफेद रंग का ऊपरी पट्टी",
  "block.minecraft.banner.stripe_top.yellow": "पीला रंग का ऊपरी पट्टी",
  "block.minecraft.banner.triangle_bottom.black": "काला निचला त्रिकोण",
  "block.minecraft.banner.triangle_bottom.blue": "नीला निचला त्रिकोण",
  "block.minecraft.banner.triangle_bottom.brown": "भूरा निचला त्रिकोण",
  "block.minecraft.banner.triangle_bottom.cyan": "हरिनील निचला त्रिकोण",
  "block.minecraft.banner.triangle_bottom.gray": "स्लेटी निचला त्रिकोण",
  "block.minecraft.banner.triangle_bottom.green": "हरा निचला त्रिकोण",
  "block.minecraft.banner.triangle_bottom.light_blue": "हल्का नीला निचला त्रिकोण",
  "block.minecraft.banner.triangle_bottom.light_gray": "हल्का स्लेटी निचला त्रिकोण",
  "block.minecraft.banner.triangle_bottom.lime": "लाइम निचला त्रिकोण",
  "block.minecraft.banner.triangle_bottom.magenta": "नीलातिरक्त निचला त्रिकोण",
  "block.minecraft.banner.triangle_bottom.orange": "नारंगी निचला त्रिकोण",
  "block.minecraft.banner.triangle_bottom.pink": "गुलाबी निचला त्रिकोण",
  "block.minecraft.banner.triangle_bottom.purple": "जामुनी निचला त्रिकोण",
  "block.minecraft.banner.triangle_bottom.red": "लाल निचला त्रिकोण",
  "block.minecraft.banner.triangle_bottom.white": "सफेद निचला त्रिकोण",
  "block.minecraft.banner.triangle_bottom.yellow": "पीला निचला त्रिकोण",
  "block.minecraft.banner.triangle_top.black": "काला ऊपरी उलटा त्रिकोण",
  "block.minecraft.banner.triangle_top.blue": "नीला ऊपरी उलटा त्रिकोण",
  "block.minecraft.banner.triangle_top.brown": "भूरा ऊपरी उलटा त्रिकोण",
  "block.minecraft.banner.triangle_top.cyan": "हरिनील ऊपरी उलटा त्रिकोण",
  "block.minecraft.banner.triangle_top.gray": "स्लेटी ऊपरी उलटा त्रिकोण",
  "block.minecraft.banner.triangle_top.green": "हरा ऊपरी उलटा त्रिकोण",
  "block.minecraft.banner.triangle_top.light_blue": "हल्का नीला ऊपरी उलटा त्रिकोण",
  "block.minecraft.banner.triangle_top.light_gray": "हल्का स्लेटी ऊपरी उलटा त्रिकोण",
  "block.minecraft.banner.triangle_top.lime": "लाइम ऊपरी उलटा त्रिकोण",
  "block.minecraft.banner.triangle_top.magenta": "नीलातिरक्त ऊपरी उलटा त्रिकोण",
  "block.minecraft.banner.triangle_top.orange": "नारंगी ऊपरी उलटा त्रिकोण",
  "block.minecraft.banner.triangle_top.pink": "गुलाबी ऊपरी उलटा त्रिकोण",
  "block.minecraft.banner.triangle_top.purple": "जामुनी ऊपरी उलटा त्रिकोण",
  "block.minecraft.banner.triangle_top.red": "लाल ऊपरी उलटा त्रिकोण",
  "block.minecraft.banner.triangle_top.white": "सफेद ऊपरी उलटा त्रिकोण",
  "block.minecraft.banner.triangle_top.yellow": "पीला ऊपरी उलटा त्रिकोण",
  "block.minecraft.banner.triangles_bottom.black": "काला निचला आरा के दाँत का अभिकल्प",
  "block.minecraft.banner.triangles_bottom.blue": "नीला निचला आरा के दाँत का अभिकल्प",
  "block.minecraft.banner.triangles_bottom.brown": "भूरा निचला आरा के दाँत का अभिकल्प",
  "block.minecraft.banner.triangles_bottom.cyan": "हरिनील निचला आरा के दाँत का अभिकल्प",
  "block.minecraft.banner.triangles_bottom.gray": "स्लेटी निचला आरा के दाँत का अभिकल्प",
  "block.minecraft.banner.triangles_bottom.green": "हरा निचला आरा के दाँत का अभिकल्प",
  "block.minecraft.banner.triangles_bottom.light_blue": "हल्का नीला निचला आरा के दाँत का अभिकल्प",
  "block.minecraft.banner.triangles_bottom.light_gray": "हल्का स्लेटी आरा के दाँत का अभिकल्प",
  "block.minecraft.banner.triangles_bottom.lime": "लाइम निचला आरा के दाँत का अभिकल्प",
  "block.minecraft.banner.triangles_bottom.magenta": "नीलातिरक्त निचला आरा के दाँत का अभिकल्प",
  "block.minecraft.banner.triangles_bottom.orange": "नारंगी निचला आरा के दाँत का अभिकल्प",
  "block.minecraft.banner.triangles_bottom.pink": "गुलाबी निचला आरा के दाँत का अभिकल्प",
  "block.minecraft.banner.triangles_bottom.purple": "जामुनी निचला आरा के दाँत का अभिकल्प",
  "block.minecraft.banner.triangles_bottom.red": "लाल निचला आरा के दाँत का अभिकल्प",
  "block.minecraft.banner.triangles_bottom.white": "सफेद निचला आरा के दाँत का अभिकल्प",
  "block.minecraft.banner.triangles_bottom.yellow": "पीला निचला आरा के दाँत का अभिकल्प",
  "block.minecraft.banner.triangles_top.black": "काला ऊपरी आरा के दाँत का अभिकल्प",
  "block.minecraft.banner.triangles_top.blue": "नीला ऊपरी आरा के दाँत का अभिकल्प",
  "block.minecraft.banner.triangles_top.brown": "भूरा ऊपरी आरा के दाँत का अभिकल्प",
  "block.minecraft.banner.triangles_top.cyan": "हरिनील ऊपरी आरा के दाँत का अभिकल्प",
  "block.minecraft.banner.triangles_top.gray": "स्लेटी ऊपरी आरा के दाँत का अभिकल्प",
  "block.minecraft.banner.triangles_top.green": "हरा ऊपरी आरा के दाँत का अभिकल्प",
  "block.minecraft.banner.triangles_top.light_blue": "हल्का नीला ऊपरी आरा के दाँत का अभिकल्प",
  "block.minecraft.banner.triangles_top.light_gray": "हल्का स्लेटी ऊपरी आरा के दाँत का अभिकल्प",
  "block.minecraft.banner.triangles_top.lime": "लाइम ऊपरी आरा के दाँत का अभिकल्प",
  "block.minecraft.banner.triangles_top.magenta": "नीलातिरक्त ऊपरी आरा के दाँत का अभिकल्प",
  "block.minecraft.banner.triangles_top.orange": "नारंगी ऊपरी आरा के दाँत का अभिकल्प",
  "block.minecraft.banner.triangles_top.pink": "गुलाबी ऊपरी आरा के दाँत का अभिकल्प",
  "block.minecraft.banner.triangles_top.purple": "जामुनी ऊपरी आरा के दाँत का अभिकल्प",
  "block.minecraft.banner.triangles_top.red": "लाल ऊपरी आरा के दाँत का अभिकल्प",
  "block.minecraft.banner.triangles_top.white": "सफेद ऊपरी आरा के दाँत का अभिकल्प",
  "block.minecraft.banner.triangles_top.yellow": "पीला ऊपरी आरा के दाँत का अभिकल्प",
  "block.minecraft.barrel": "पीपा",
  "block.minecraft.barrier": "अवरोध",
  "block.minecraft.basalt": "असिताश्म",
  "block.minecraft.beacon": "आकाशदीप",
  "block.minecraft.beacon.primary": "पहली शक्ति",
  "block.minecraft.beacon.secondary": "दूसरी शक्ति",
  "block.minecraft.bed.no_sleep": "आप सिर्फ रात में या एक आँधी के समय सो सकते है",
  "block.minecraft.bed.not_safe": "आप अभी सो नहीं सकते हैं; आसपास राक्षसों हैं",
  "block.minecraft.bed.obstructed": "यह बिस्तर अवरुद्ध है",
  "block.minecraft.bed.occupied": "यह बिस्तर पर कोई सो रहा है",
  "block.minecraft.bed.too_far_away": "आप अभी आराम नहीं कर सकते है; बिस्तर बहुत दूर है",
  "block.minecraft.bedrock": "आधार-शैल",
  "block.minecraft.bee_nest": "मधुमक्खी का घोंसला",
  "block.minecraft.beehive": "मधुमक्खी का छत्ता",
  "block.minecraft.beetroots": "चुकंदर",
  "block.minecraft.bell": "घंटी",
  "block.minecraft.big_dripleaf": "बड़ा बूँदपत्ता",
  "block.minecraft.big_dripleaf_stem": "बड़े ड्रिपलीफ की डाली",
  "block.minecraft.birch_button": "भूर्ज का बटन",
  "block.minecraft.birch_door": "भूर्ज का दरवाजा",
  "block.minecraft.birch_fence": "भूर्ज का बाड़ा",
  "block.minecraft.birch_fence_gate": "भूर्ज का फाटक",
  "block.minecraft.birch_hanging_sign": "सन्टी लटकने का चिन्ह",
  "block.minecraft.birch_leaves": "भूर्ज के पत्तें",
  "block.minecraft.birch_log": "सन्टी लॉग इन करें",
  "block.minecraft.birch_planks": "भूर्ज का तख्ता",
  "block.minecraft.birch_pressure_plate": "भूर्ज का दाब पट्ट",
  "block.minecraft.birch_sapling": "भूर्ज का पौधा",
  "block.minecraft.birch_shelf": "सटीं दराज",
  "block.minecraft.birch_sign": "भूर्ज का संकेत",
  "block.minecraft.birch_slab": "भूर्ज की पटिया",
  "block.minecraft.birch_stairs": "भूर्ज की सीढ़ियाँ",
  "block.minecraft.birch_trapdoor": "भूर्ज का कूट द्वार",
  "block.minecraft.birch_wall_hanging_sign": "बर्च वॉल हैंगिंग साइन",
  "block.minecraft.birch_wall_sign": "भूर्ज का दीवार संकेत",
  "block.minecraft.birch_wood": "भूर्ज की लकड़ी",
  "block.minecraft.black_banner": "काला झंडा",
  "block.minecraft.black_bed": "काला बिस्तर",
  "block.minecraft.black_candle": "काली बत्ती",
  "block.minecraft.black_candle_cake": "काली मोमबत्ती के साथ केक",
  "block.minecraft.black_carpet": "काला कालीन",
  "block.minecraft.black_concrete": "काला कंक्रीट",
  "block.minecraft.black_concrete_powder": "काला कंक्रीट का चूरा",
  "block.minecraft.black_glazed_terracotta": "ब्लैक ग्लेज़ेड टेराकोटा",
  "block.minecraft.black_shulker_box": "काला शल्कर बक्सा",
  "block.minecraft.black_stained_glass": "काला अभिरंजित काँच",
  "block.minecraft.black_stained_glass_pane": "काला अभिरंजित खिड़की का काँच",
  "block.minecraft.black_terracotta": "काला टेराकोटा",
  "block.minecraft.black_wool": "काला ऊन",
  "block.minecraft.blackstone": "कालापाषाण",
  "block.minecraft.blackstone_slab": "कालापाषाण की पटिया",
  "block.minecraft.blackstone_stairs": "कालापाषाण की सीढ़ियाँ",
  "block.minecraft.blackstone_wall": "कालापाषाण की दीवार",
  "block.minecraft.blast_furnace": "वात्या भट्ठी",
  "block.minecraft.blue_banner": "नीला झंडा",
  "block.minecraft.blue_bed": "नीला बिस्तर",
  "block.minecraft.blue_candle": "नीली बत्ती",
  "block.minecraft.blue_candle_cake": "नीली मोमबत्ती के साथ केक",
  "block.minecraft.blue_carpet": "नीला कालीन",
  "block.minecraft.blue_concrete": "नीला कंक्रीट",
  "block.minecraft.blue_concrete_powder": "नीला कंक्रीट का चूरा",
  "block.minecraft.blue_glazed_terracotta": "ब्लू ग्लेज़ेड टेराकोटा",
  "block.minecraft.blue_ice": "नीला बर्फ",
  "block.minecraft.blue_orchid": "नीला ऑर्किड",
  "block.minecraft.blue_shulker_box": "नीला शल्कर बक्सा",
  "block.minecraft.blue_stained_glass": "नीला अभिरंजित काँच",
  "block.minecraft.blue_stained_glass_pane": "नीला अभिरंजित खिड़की का काँच",
  "block.minecraft.blue_terracotta": "नीला टेराकोटा",
  "block.minecraft.blue_wool": "नीला ऊन",
  "block.minecraft.bone_block": "हड्डी का प्रखंड",
  "block.minecraft.bookshelf": "पुस्ताक तख्ता",
  "block.minecraft.brain_coral": "बुद्धि का मूँगा",
  "block.minecraft.brain_coral_block": "बुद्धि का मूँगा का प्रखंड",
  "block.minecraft.brain_coral_fan": "बुद्धि का मूँगा का पंखा",
  "block.minecraft.brain_coral_wall_fan": "बुद्धि का मूँगा का दीवार पंखा",
  "block.minecraft.brewing_stand": "ब्रूइंग स्टैंड",
  "block.minecraft.brick_slab": "ईंट की पटिया",
  "block.minecraft.brick_stairs": "ईंट की सीढ़ियाँ",
  "block.minecraft.brick_wall": "ईंट की दीवार",
  "block.minecraft.bricks": "ईंटें",
  "block.minecraft.brown_banner": "भूरा झंडा",
  "block.minecraft.brown_bed": "भूरा बिस्तर",
  "block.minecraft.brown_candle": "भूरी बत्ती",
  "block.minecraft.brown_candle_cake": "ब्राउन मोमबत्ती के साथ केक",
  "block.minecraft.brown_carpet": "भूरा कालीन",
  "block.minecraft.brown_concrete": "भूरा कंक्रीट",
  "block.minecraft.brown_concrete_powder": "भूरा कंक्रीट का चूरा",
  "block.minecraft.brown_glazed_terracotta": "ब्राउन ग्लेज़ेड टेराकोटा",
  "block.minecraft.brown_mushroom": "भूरा कुकुरमुत्ता",
  "block.minecraft.brown_mushroom_block": "भूरा कुकुरमुत्ता का प्रखंड",
  "block.minecraft.brown_shulker_box": "भूरा शल्कर बक्सा",
  "block.minecraft.brown_stained_glass": "भूरा अभिरंजित काँच",
  "block.minecraft.brown_stained_glass_pane": "भूरा अभिरंजित खिड़की का काँच",
  "block.minecraft.brown_terracotta": "भूरा टेराकोटा",
  "block.minecraft.brown_wool": "भूरा ऊन",
  "block.minecraft.bubble_column": "बबल कॉलम",
  "block.minecraft.bubble_coral": "बुलबुला का मूँगा",
  "block.minecraft.bubble_coral_block": "बुलबुला का मूँगा का प्रखंड",
  "block.minecraft.bubble_coral_fan": "बुलबुला का मूँगा का पंखा",
  "block.minecraft.bubble_coral_wall_fan": "बुलबुला का मूँगा का दीवार पंखा",
  "block.minecraft.budding_amethyst": "मुकुलन जंबुमणि",
  "block.minecraft.bush": "झाड़ी",
  "block.minecraft.cactus": "नागफनी",
  "block.minecraft.cactus_flower": "कैक्टस का फूल",
  "block.minecraft.cake": "केक",
  "block.minecraft.calcite": "कैल्साइट",
  "block.minecraft.calibrated_sculk_sensor": "सम्मोहित स्कलक महसुस करनें वाला।",
  "block.minecraft.campfire": "अलाव",
  "block.minecraft.candle": "बत्ती",
  "block.minecraft.candle_cake": "केक में बत्ती",
  "block.minecraft.carrots": "गाजर",
  "block.minecraft.cartography_table": "मानचित्रकला मेज",
  "block.minecraft.carved_pumpkin": "नक्काशीदार कद्दू",
  "block.minecraft.cauldron": "देग",
  "block.minecraft.cave_air": "गुफे की हवा",
  "block.minecraft.cave_vines": "गुफा की बेलें",
  "block.minecraft.cave_vines_plant": "गुफा बेल का पौधा",
  "block.minecraft.chain": "जंजीर",
  "block.minecraft.chain_command_block": "श्रृंखला आदेश ब्लॉक",
  "block.minecraft.cherry_button": "चेरी का बटन",
  "block.minecraft.cherry_door": "चेरी का दरवाजा",
  "block.minecraft.cherry_fence": "चेरी की बाड़",
  "block.minecraft.cherry_fence_gate": "चेरी का बाड़ दरवाजा",
  "block.minecraft.cherry_hanging_sign": "चेरी की हैंगिंग साइन",
  "block.minecraft.cherry_leaves": "चेरी के पत्ते",
  "block.minecraft.cherry_log": "चेरी के लट्ठे",
  "block.minecraft.cherry_planks": "चेरी के तख्त",
  "block.minecraft.cherry_pressure_plate": "चेरी दबाव प्लेट",
  "block.minecraft.cherry_sapling": "चेरी का पौधा",
  "block.minecraft.cherry_shelf": "चेरी का शेल्फ",
  "block.minecraft.cherry_sign": "चेरी का चिन्ह",
  "block.minecraft.cherry_slab": "चेरी का स्लैब",
  "block.minecraft.cherry_stairs": "चेरी की सीढ़ियाँ",
  "block.minecraft.cherry_trapdoor": "चेरी का ट्रैपडोर",
  "block.minecraft.cherry_wall_hanging_sign": "चेरी का वॉल हैंगिंग साइन",
  "block.minecraft.cherry_wall_sign": "चेरी का दीवार का चिन्ह",
  "block.minecraft.cherry_wood": "चेरी की लकड़ी",
  "block.minecraft.chest": "बक्सा",
  "block.minecraft.chipped_anvil": "एविल को चिपकाया",
  "block.minecraft.chiseled_bookshelf": "गढ़ी हुई किताबों की अलमारी",
  "block.minecraft.chiseled_copper": "तराशा हुआ तांबा",
  "block.minecraft.chiseled_deepslate": "तराशा हुआ डीपस्लेट",
  "block.minecraft.chiseled_nether_bricks": "तराशी हुई नेदर की ईठें",
  "block.minecraft.chiseled_polished_blackstone": "तराशा हुआ चमकदार कालापाषाण",
  "block.minecraft.chiseled_quartz_block": "छेनी क्वार्ट्ज ब्लॉक",
  "block.minecraft.chiseled_red_sandstone": "छेनी लाल बलुआ पत्थर",
  "block.minecraft.chiseled_resin_bricks": "छेनी से गढ़ी राल ईंटें",
  "block.minecraft.chiseled_sandstone": "छेनी बलुआ पत्थर",
  "block.minecraft.chiseled_stone_bricks": "तराशा हुआ पत्थर की ईंटें",
  "block.minecraft.chiseled_tuff": "छेनीदार टफ़",
  "block.minecraft.chiseled_tuff_bricks": "छेनी वाली टफ़ ईंटें",
  "block.minecraft.chorus_flower": "कोरस का फूल",
  "block.minecraft.chorus_plant": "कोरस प्लांट",
  "block.minecraft.clay": "मृत्तिका",
  "block.minecraft.closed_eyeblossom": "बंद आँख का फूल",
  "block.minecraft.coal_block": "कोयला का प्रखंड",
  "block.minecraft.coal_ore": "कोयला अयस्क",
  "block.minecraft.coarse_dirt": "रूखा मिट्टी",
  "block.minecraft.cobbled_deepslate": "पथरीला डीपस्लेट",
  "block.minecraft.cobbled_deepslate_slab": "पथरीले डीपस्लेट की पटिया",
  "block.minecraft.cobbled_deepslate_stairs": "पथरीले डीपस्लेट की सीढ़ियां",
  "block.minecraft.cobbled_deepslate_wall": "पथरीले डीपस्लेट की दीवार",
  "block.minecraft.cobblestone": "फर्शी पत्‍थर",
  "block.minecraft.cobblestone_slab": "फर्शी पत्‍थर की पटिया",
  "block.minecraft.cobblestone_stairs": "कोबलस्टोन सीढ़ियां",
  "block.minecraft.cobblestone_wall": "फर्शी पत्‍थर का दीवार",
  "block.minecraft.cobweb": "मकड़जाल",
  "block.minecraft.cocoa": "कोको",
  "block.minecraft.command_block": "समादेश प्रखंड",
  "block.minecraft.comparator": "लाल पत्थर तुलनित्र",
  "block.minecraft.composter": "खाद का डब्बा",
  "block.minecraft.conduit": "जलक्रोड",
  "block.minecraft.copper_bars": "तांबे की छड़ें",
  "block.minecraft.copper_block": "तांबा का खंड मैथा",
  "block.minecraft.copper_bulb": "तांबे का बल्ब",
  "block.minecraft.copper_chain": "तांबे की ज़ंजीर",
  "block.minecraft.copper_chest": "ताँबे का बक्सा",
  "block.minecraft.copper_door": "तांबे का दरवाज़ा",
  "block.minecraft.copper_golem_statue": "तांबे के गोलेम की मूर्ति",
  "block.minecraft.copper_grate": "तांबे की जाली",
  "block.minecraft.copper_lantern": "तांबे का लालटेन",
  "block.minecraft.copper_ore": "तांबे का अयस्क",
  "block.minecraft.copper_torch": "तांबे की मशाल",
  "block.minecraft.copper_trapdoor": "तांबे का कूट द्वार",
  "block.minecraft.copper_wall_torch": "तांबे की मशाल",
  "block.minecraft.cornflower": "मकई का फूल",
  "block.minecraft.cracked_deepslate_bricks": "फटी डीपस्लेट की ईंटें",
  "block.minecraft.cracked_deepslate_tiles": "फटी डीपस्लेट की टाइल्स",
  "block.minecraft.cracked_nether_bricks": "टूटी हुई नेदर की ईठें",
  "block.minecraft.cracked_polished_blackstone_bricks": "टूटे हुए चमकदार कालापाषाण की ईंटें",
  "block.minecraft.cracked_stone_bricks": "टूटा हुआ पत्थर की ईंटें",
  "block.minecraft.crafter": "शिल्पकार",
  "block.minecraft.crafting_table": "क्राफ्टिंग तालिका",
  "block.minecraft.creaking_heart": "चर-चराता दिल",
  "block.minecraft.creeper_head": "क्रीपर का सिर",
  "block.minecraft.creeper_wall_head": "क्रीपर का दीवार का सिर",
  "block.minecraft.crimson_button": "किरमिजी बटन",
  "block.minecraft.crimson_door": "किरमिजी दरवाजा",
  "block.minecraft.crimson_fence": "किरमिजी बाड़",
  "block.minecraft.crimson_fence_gate": "किरमिजी फाटक",
  "block.minecraft.crimson_fungus": "किरमिजी कवक",
  "block.minecraft.crimson_hanging_sign": "क्रिमसन हैंगिंग साइन",
  "block.minecraft.crimson_hyphae": "किरमिजी कवकतंतुएँ",
  "block.minecraft.crimson_nylium": "क्रिमसन नीलियम",
  "block.minecraft.crimson_planks": "किरमिजी तख्तें",
  "block.minecraft.crimson_pressure_plate": "किरमिजी दाब पट्ट",
  "block.minecraft.crimson_roots": "किरमिजी जड़ें",
  "block.minecraft.crimson_shelf": "चमकिली लाल दराज",
  "block.minecraft.crimson_sign": "किरमिजी संकेत",
  "block.minecraft.crimson_slab": "किरमिजीक पटिया",
  "block.minecraft.crimson_stairs": "किरमिजी सीढ़ियाँ",
  "block.minecraft.crimson_stem": "किरमिजी तना",
  "block.minecraft.crimson_trapdoor": "किरमिजी कूट द्वार",
  "block.minecraft.crimson_wall_hanging_sign": "क्रिमसन वॉल हैंगिंग साइन",
  "block.minecraft.crimson_wall_sign": "किरमिजी दीवार संकेत",
  "block.minecraft.crying_obsidian": "रोनेवाला ज्वालाकाच",
  "block.minecraft.cut_copper": "कटा हुआ तांबा",
  "block.minecraft.cut_copper_slab": "कटे हुए तांबे की पटिया",
  "block.minecraft.cut_copper_stairs": "कटे हुए तांबे की सीढ़ियाँ",
  "block.minecraft.cut_red_sandstone": "कटा हुआ लाल बलुआ पत्थर",
  "block.minecraft.cut_red_sandstone_slab": "कटा हुआ लाल बलुआ पत्थर की पटिया",
  "block.minecraft.cut_sandstone": "कटा हुआ बलुआ पत्थर",
  "block.minecraft.cut_sandstone_slab": "कटा हुआ बलुआ पत्थर की पटिया",
  "block.minecraft.cyan_banner": "हरिनील झंडा",
  "block.minecraft.cyan_bed": "हरिनील बिस्तर",
  "block.minecraft.cyan_candle": "हरिनील बत्ती",
  "block.minecraft.cyan_candle_cake": "सियान मोमबत्ती के साथ केक",
  "block.minecraft.cyan_carpet": "हरिनील कालीन",
  "block.minecraft.cyan_concrete": "हरिनील कंक्रीट",
  "block.minecraft.cyan_concrete_powder": "हरिनील कंक्रीट का चूरा",
  "block.minecraft.cyan_glazed_terracotta": "सियान चमकता हुआ टेराकोटा",
  "block.minecraft.cyan_shulker_box": "हरिनील शल्कर बक्सा",
  "block.minecraft.cyan_stained_glass": "हरिनील अभिरंजित काँच",
  "block.minecraft.cyan_stained_glass_pane": "हरिनील अभिरंजित खिड़की का काँच",
  "block.minecraft.cyan_terracotta": "हरिनील टेराकोटा",
  "block.minecraft.cyan_wool": "हरिनील ऊन",
  "block.minecraft.damaged_anvil": "क्षतिग्रस्त एविल",
  "block.minecraft.dandelion": "सिंहपर्णी",
  "block.minecraft.dark_oak_button": "काला बाँज का बटन",
  "block.minecraft.dark_oak_door": "काला बाँज का दरवाजा",
  "block.minecraft.dark_oak_fence": "काला बाँज का बाड़ा",
  "block.minecraft.dark_oak_fence_gate": "काला बाँज का फाटक",
  "block.minecraft.dark_oak_hanging_sign": "डार्क ओक हैंगिंग साइन",
  "block.minecraft.dark_oak_leaves": "काला बाँज के पत्तें",
  "block.minecraft.dark_oak_log": "डार्क ओक लॉग इन करें",
  "block.minecraft.dark_oak_planks": "काला बाँज का तख्ता",
  "block.minecraft.dark_oak_pressure_plate": "काला बाँज का दाब पट्ट",
  "block.minecraft.dark_oak_sapling": "काला बाँज का पौधा",
  "block.minecraft.dark_oak_shelf": "काले बाँज का शेल्फ",
  "block.minecraft.dark_oak_sign": "काला बाँज का संकेत",
  "block.minecraft.dark_oak_slab": "काला बाँज की पटिया",
  "block.minecraft.dark_oak_stairs": "काला बाँज की सीढ़ियाँ",
  "block.minecraft.dark_oak_trapdoor": "काला बाँज का कूट द्वार",
  "block.minecraft.dark_oak_wall_hanging_sign": "डार्क ओक की दीवार\nलटकने का चिह्न",
  "block.minecraft.dark_oak_wall_sign": "काला बाँज का दीवार संकेत",
  "block.minecraft.dark_oak_wood": "काला बाँज की लकड़ी",
  "block.minecraft.dark_prismarine": "डार्क प्रिज्मरीन",
  "block.minecraft.dark_prismarine_slab": "काला प्रिज्मरीन की पटिया",
  "block.minecraft.dark_prismarine_stairs": "काला प्रिज्मरीन की सीढ़ियाँ",
  "block.minecraft.daylight_detector": "डेलाइट डिटेक्टर",
  "block.minecraft.dead_brain_coral": "मृत बुद्धि का मूँगा",
  "block.minecraft.dead_brain_coral_block": "मृत बुद्धि का मूँगा का प्रखंड",
  "block.minecraft.dead_brain_coral_fan": "मृत बुद्धि का मूँगा का पंखा",
  "block.minecraft.dead_brain_coral_wall_fan": "मृत बुद्धि का मूँगा का दीवार पंखा",
  "block.minecraft.dead_bubble_coral": "मृत बुलबुला का मूँगा",
  "block.minecraft.dead_bubble_coral_block": "मृत बुलबुला का मूँगा का प्रखंड",
  "block.minecraft.dead_bubble_coral_fan": "मृत बुलबुला का मूँगा का पंखा",
  "block.minecraft.dead_bubble_coral_wall_fan": "मृत बुलबुला का मूँगा का दीवार पंखा",
  "block.minecraft.dead_bush": "मृत पौधा",
  "block.minecraft.dead_fire_coral": "मृत आग का मूँगा",
  "block.minecraft.dead_fire_coral_block": "मृत आग का मूँगा का प्रखंड",
  "block.minecraft.dead_fire_coral_fan": "मृत आग का मूँगा का पंखा",
  "block.minecraft.dead_fire_coral_wall_fan": "मृत आग का मूँगा का दीवार पंखा",
  "block.minecraft.dead_horn_coral": "मृत सींग का मूँगा",
  "block.minecraft.dead_horn_coral_block": "मृत सींग का मूँगा का प्रखंड",
  "block.minecraft.dead_horn_coral_fan": "मृत सींग का मूँगा का पंखा",
  "block.minecraft.dead_horn_coral_wall_fan": "मृत सींग का मूँगा का दीवार पंखा",
  "block.minecraft.dead_tube_coral": "मृत नलिका का मूँगा",
  "block.minecraft.dead_tube_coral_block": "मृत ट्यूब कोरल ब्लॉक",
  "block.minecraft.dead_tube_coral_fan": "मृत नलिका का मूँगा का पंखा",
  "block.minecraft.dead_tube_coral_wall_fan": "मृत नलिका का मूँगा का दीवार पंखा",
  "block.minecraft.decorated_pot": "सजा हुआ बर्तन",
  "block.minecraft.deepslate": "डीपस्लेट",
  "block.minecraft.deepslate_brick_slab": "डीपस्लेट ईंट की पटिया",
  "block.minecraft.deepslate_brick_stairs": "डीपस्लेट ईंट की सीढ़ियां",
  "block.minecraft.deepslate_brick_wall": "डीपस्लेट ईंट की दीवार",
  "block.minecraft.deepslate_bricks": "डीपस्लेट की ईंटें",
  "block.minecraft.deepslate_coal_ore": "डीपस्लेट कोयला अयस्क",
  "block.minecraft.deepslate_copper_ore": "डीपस्लेट तांबा अयस्क",
  "block.minecraft.deepslate_diamond_ore": "डीपस्लेट डायमंड अयस्क",
  "block.minecraft.deepslate_emerald_ore": "डीपस्लेट पन्ना अयस्क",
  "block.minecraft.deepslate_gold_ore": "डीपस्लेट स्वर्ण अयस्क",
  "block.minecraft.deepslate_iron_ore": "डीपस्लेट लौह अयस्क",
  "block.minecraft.deepslate_lapis_ore": "लाजुली अयस्क पर डीपस्लेट लापिस",
  "block.minecraft.deepslate_redstone_ore": "डीपस्लेट रेडस्टोन अयस्क",
  "block.minecraft.deepslate_tile_slab": "डीपस्लेट टाइल्स की पटिया",
  "block.minecraft.deepslate_tile_stairs": "डीपस्लेट टाइल्स की सीढ़ियां",
  "block.minecraft.deepslate_tile_wall": "डीपस्लेट टाइल्स की दीवार",
  "block.minecraft.deepslate_tiles": "डीपस्लेट टाइल्स",
  "block.minecraft.detector_rail": "डिटेक्टर रेल",
  "block.minecraft.diamond_block": "हीरा का प्रखंड",
  "block.minecraft.diamond_ore": "हीरक अयस्क",
  "block.minecraft.diorite": "डायोराइट",
  "block.minecraft.diorite_slab": "डाओराइट की पटिया",
  "block.minecraft.diorite_stairs": "डाओराइट की सीढ़ियाँ",
  "block.minecraft.diorite_wall": "डाओराइट का दीवार",
  "block.minecraft.dirt": "मिट्टी",
  "block.minecraft.dirt_path": "कच्ची सड़क",
  "block.minecraft.dispenser": "दवासाज़",
  "block.minecraft.dragon_egg": "अजगर का अंडा",
  "block.minecraft.dragon_head": "ड्रैगन सिर",
  "block.minecraft.dragon_wall_head": "ड्रैगन वॉल हेड",
  "block.minecraft.dried_ghast": "सूखी घास्ट",
  "block.minecraft.dried_kelp_block": "सूखा सिवार का प्रखंड",
  "block.minecraft.dripstone_block": "ड्रिपस्टोन खंड",
  "block.minecraft.dropper": "ड्रॉपर",
  "block.minecraft.emerald_block": "पन्ना का ब्लॉक",
  "block.minecraft.emerald_ore": "पन्ना का अयस्क",
  "block.minecraft.enchanting_table": "करामाती तालिका",
  "block.minecraft.end_gateway": "एन्ड द्वार",
  "block.minecraft.end_portal": "एन्ड प्रवेशद्वार",
  "block.minecraft.end_portal_frame": "एन्ड प्रवेशद्वार का ढ़ांचा",
  "block.minecraft.end_rod": "एन्ड की रॉड",
  "block.minecraft.end_stone": "एन्ड का पत्थर",
  "block.minecraft.end_stone_brick_slab": "एंड के पत्थर की ईंट की पटिया",
  "block.minecraft.end_stone_brick_stairs": "एंड के पत्थर की ईंट की सीढ़ियाँ",
  "block.minecraft.end_stone_brick_wall": "एंड के पत्थर की ईंट की दीवार",
  "block.minecraft.end_stone_bricks": "एंड के पत्थर की ईंट",
  "block.minecraft.ender_chest": "एंडर बक्सा",
  "block.minecraft.exposed_chiseled_copper": "उजागर छेनी वाला तांबा",
  "block.minecraft.exposed_copper": "उजागर तांबा",
  "block.minecraft.exposed_copper_bars": "खुले तांबे की छड़ें",
  "block.minecraft.exposed_copper_bulb": "उजागर तांबे का बल्ब",
  "block.minecraft.exposed_copper_chain": "खुले तांबे की जंजीर",
  "block.minecraft.exposed_copper_chest": "खुले तांबे का बक्सा",
  "block.minecraft.exposed_copper_door": "उजागर तांबे का दरवाजा",
  "block.minecraft.exposed_copper_golem_statue": "तांबे के गोलेम की मूर्ति",
  "block.minecraft.exposed_copper_grate": "उजागर कॉपर ग्रेट",
  "block.minecraft.exposed_copper_lantern": "तांबे की लालटेन",
  "block.minecraft.exposed_copper_trapdoor": "उजागर कॉपर ट्रैपडोर",
  "block.minecraft.exposed_cut_copper": "उजागर कटा तांबा",
  "block.minecraft.exposed_cut_copper_slab": "उजागर हुए कटे तांबे की पटिया",
  "block.minecraft.exposed_cut_copper_stairs": "उजागर हुए कटे तांबे की सीढ़ियाँ",
  "block.minecraft.exposed_lightning_rod": "तड़ितचालक",
  "block.minecraft.farmland": "खेत",
  "block.minecraft.fern": "फर्न",
  "block.minecraft.fire": "आग",
  "block.minecraft.fire_coral": "आग का मूँगा",
  "block.minecraft.fire_coral_block": "आग का मूँगा का प्रखंड",
  "block.minecraft.fire_coral_fan": "आग का मूँगा का पंखा",
  "block.minecraft.fire_coral_wall_fan": "आग का मूँगा का दीवार पंखा",
  "block.minecraft.firefly_bush": "जुगनू झाड़ी",
  "block.minecraft.fletching_table": "फैलेटिंग टेबल",
  "block.minecraft.flower_pot": "गमला",
  "block.minecraft.flowering_azalea": "खिलने वाली अज़ेलिया",
  "block.minecraft.flowering_azalea_leaves": "खिले हुए अजवायन के पत्ते",
  "block.minecraft.frogspawn": "मेंढक स्पव्न",
  "block.minecraft.frosted_ice": "तुषारित बर्फ",
  "block.minecraft.furnace": "भट्ठी",
  "block.minecraft.gilded_blackstone": "मुलम्मा चढ़े कालापाषाण",
  "block.minecraft.glass": "काँच",
  "block.minecraft.glass_pane": "खिड़की का काँच",
  "block.minecraft.glow_lichen": "लाइकेन उगाएँ",
  "block.minecraft.glowstone": "ग्लोस्टोन",
  "block.minecraft.gold_block": "सोना का प्रखंड",
  "block.minecraft.gold_ore": "सोने का अयस्क",
  "block.minecraft.golden_dandelion": "सुनहरा सिंहपर्णी",
  "block.minecraft.granite": "ग्रेनाइट",
  "block.minecraft.granite_slab": "ग्रेनाइट की पटिया",
  "block.minecraft.granite_stairs": "ग्रेनाइट की सीढ़ियाँ",
  "block.minecraft.granite_wall": "ग्रेनाइट की दीवार",
  "block.minecraft.grass": "घास",
  "block.minecraft.grass_block": "घास का प्रखंड",
  "block.minecraft.gravel": "बजरी",
  "block.minecraft.gray_banner": "स्लेटी झंडा",
  "block.minecraft.gray_bed": "स्लेटी बिस्तर",
  "block.minecraft.gray_candle": "स्लेटी बत्ती",
  "block.minecraft.gray_candle_cake": "ग्रे मोमबत्ती के साथ केक",
  "block.minecraft.gray_carpet": "स्लेटी कालीन",
  "block.minecraft.gray_concrete": "स्लेटी कंक्रीट",
  "block.minecraft.gray_concrete_powder": "स्लेटी कंक्रीट का चूरा",
  "block.minecraft.gray_glazed_terracotta": "ग्रे चमकता हुआ टेराकोटा",
  "block.minecraft.gray_shulker_box": "स्लेटी शल्कर बक्सा",
  "block.minecraft.gray_stained_glass": "स्लेटी अभिरंजित काँच",
  "block.minecraft.gray_stained_glass_pane": "स्लेटी अभिरंजित खिड़की का काँच",
  "block.minecraft.gray_terracotta": "स्लेटी टेराकोटा",
  "block.minecraft.gray_wool": "स्लेटी ऊन",
  "block.minecraft.green_banner": "हरा झंडा",
  "block.minecraft.green_bed": "हरा बिस्तर",
  "block.minecraft.green_candle": "हरी बत्ती",
  "block.minecraft.green_candle_cake": "हरी मोमबत्ती के साथ केक",
  "block.minecraft.green_carpet": "हरा कालीन",
  "block.minecraft.green_concrete": "हरा कंक्रीट",
  "block.minecraft.green_concrete_powder": "हरा कंक्रीट का चूरा",
  "block.minecraft.green_glazed_terracotta": "ग्रीन ग्लेज़ेड टेराकोटा",
  "block.minecraft.green_shulker_box": "हरा शल्कर बक्सा",
  "block.minecraft.green_stained_glass": "हरा अभिरंजित काँच",
  "block.minecraft.green_stained_glass_pane": "हरा अभिरंजित खिड़की का काँच",
  "block.minecraft.green_terracotta": "हरा टेराकोटा",
  "block.minecraft.green_wool": "हरा ऊन",
  "block.minecraft.grindstone": "सान",
  "block.minecraft.hanging_roots": "लटकते जड़",
  "block.minecraft.hay_block": "हे बेल",
  "block.minecraft.heavy_core": "भारी कोर",
  "block.minecraft.heavy_weighted_pressure_plate": "भारी भारित दाब पट्ट",
  "block.minecraft.honey_block": "मधु प्रखंड",
  "block.minecraft.honeycomb_block": "मधुकोष का खंड",
  "block.minecraft.hopper": "कूदनेवाला",
  "block.minecraft.horn_coral": "सींग का मूँगा",
  "block.minecraft.horn_coral_block": "सींग का मूँगा का प्रखंड",
  "block.minecraft.horn_coral_fan": "सींग का मूँगा का पंखा",
  "block.minecraft.horn_coral_wall_fan": "सींग का मूँगा का दीवार पंखा",
  "block.minecraft.ice": "बर्फ",
  "block.minecraft.infested_chiseled_stone_bricks": "संक्रमित तराशा हुआ पत्थर की ईंटें",
  "block.minecraft.infested_cobblestone": "संक्रमित फर्शी पत्‍थर",
  "block.minecraft.infested_cracked_stone_bricks": "संक्रमित टूटा हुआ पत्थर की ईंटें",
  "block.minecraft.infested_deepslate": "संक्रमित डीपस्लेट",
  "block.minecraft.infested_mossy_stone_bricks": "संक्रमित दरदर का पत्थर की ईंटें",
  "block.minecraft.infested_stone": "संक्रमित पत्थर",
  "block.minecraft.infested_stone_bricks": "संक्रमित पत्थर की ईंटें",
  "block.minecraft.iron_bars": "लौह छड़",
  "block.minecraft.iron_block": "लोहा का प्रखंड",
  "block.minecraft.iron_chain": "लोहे की जंजीर",
  "block.minecraft.iron_door": "लौह दरवाजा",
  "block.minecraft.iron_ore": "लौह अयस्क",
  "block.minecraft.iron_trapdoor": "लोहे का कूट द्वार",
  "block.minecraft.jack_o_lantern": "जैक ओ'लालटेन",
  "block.minecraft.jigsaw": "जिग्सॉ खंड",
  "block.minecraft.jukebox": "संगीत-यंत्र",
  "block.minecraft.jungle_button": "जंगल का बटन",
  "block.minecraft.jungle_door": "जंगल का दरवाजा",
  "block.minecraft.jungle_fence": "जंगल का बाड़ा",
  "block.minecraft.jungle_fence_gate": "जंगल का फाटक",
  "block.minecraft.jungle_hanging_sign": "जंगल फांसी का चिन्ह",
  "block.minecraft.jungle_leaves": "जंगल के पत्तें",
  "block.minecraft.jungle_log": "जंगल लॉग इन करें",
  "block.minecraft.jungle_planks": "जंगल का तख्ता",
  "block.minecraft.jungle_pressure_plate": "जंगल का दाब पट्ट",
  "block.minecraft.jungle_sapling": "जंगल का पौधा",
  "block.minecraft.jungle_shelf": "जंगल की दराज",
  "block.minecraft.jungle_sign": "जंगल का संकेत",
  "block.minecraft.jungle_slab": "जंगल की पटिया",
  "block.minecraft.jungle_stairs": "जंगल की सीढ़ियाँ",
  "block.minecraft.jungle_trapdoor": "जंगल का कूट द्वार",
  "block.minecraft.jungle_wall_hanging_sign": "जंगल की दीवार\nलटकने का चिह्न",
  "block.minecraft.jungle_wall_sign": "जंगल का दीवार संकेत",
  "block.minecraft.jungle_wood": "जंगल की लकड़ी",
  "block.minecraft.kelp": "सिवार",
  "block.minecraft.kelp_plant": "सिवार का पौधा",
  "block.minecraft.ladder": "सीढ़ी",
  "block.minecraft.lantern": "कंदील",
  "block.minecraft.lapis_block": "लापिस लाजुली का ब्लॉक",
  "block.minecraft.lapis_ore": "लाजवर्द का अयस्क",
  "block.minecraft.large_amethyst_bud": "बड़ा जंबुमणि की कली",
  "block.minecraft.large_fern": "बड़ा फर्न",
  "block.minecraft.lava": "लावा",
  "block.minecraft.lava_cauldron": "लावा की कड़ाही",
  "block.minecraft.leaf_litter": "पत्तों का ढेर",
  "block.minecraft.lectern": "ज्ञानतीठ",
  "block.minecraft.lever": "उत्तोलक",
  "block.minecraft.light": "प्रकाश",
  "block.minecraft.light_blue_banner": "हल्का नीला झंडा",
  "block.minecraft.light_blue_bed": "हल्का नीला बिस्तर",
  "block.minecraft.light_blue_candle": "हल्की नीली बत्ती",
  "block.minecraft.light_blue_candle_cake": "हल्की नीली मोमबत्ती के साथ केक",
  "block.minecraft.light_blue_carpet": "हल्का नीला कालीन",
  "block.minecraft.light_blue_concrete": "हल्का नीला कंक्रीट",
  "block.minecraft.light_blue_concrete_powder": "हल्का नीला कंक्रीट का चूरा",
  "block.minecraft.light_blue_glazed_terracotta": "लाइट ब्लू ग्लेज़ेड टेराकोटा",
  "block.minecraft.light_blue_shulker_box": "हल्का नीला शल्कर बक्सा",
  "block.minecraft.light_blue_stained_glass": "हल्का नीला अभिरंजित काँच",
  "block.minecraft.light_blue_stained_glass_pane": "हल्का नीला अभिरंजित खिड़की का काँच",
  "block.minecraft.light_blue_terracotta": "हल्का नीला टेराकोटा",
  "block.minecraft.light_blue_wool": "हल्का नीला ऊन",
  "block.minecraft.light_gray_banner": "हल्का स्लेटी झंडा",
  "block.minecraft.light_gray_bed": "हल्का स्लेटी बिस्तर",
  "block.minecraft.light_gray_candle": "हल्की स्लेटी बत्ती",
  "block.minecraft.light_gray_candle_cake": "लाइट ग्रे मोमबत्ती के साथ केक",
  "block.minecraft.light_gray_carpet": "हल्का स्लेटी कालीन",
  "block.minecraft.light_gray_concrete": "हल्का स्लेटी कंक्रीट",
  "block.minecraft.light_gray_concrete_powder": "हल्का स्लेटी कंक्रीट का चूरा",
  "block.minecraft.light_gray_glazed_terracotta": "लाइट ग्रे ग्लेज़ेड टेराकोटा",
  "block.minecraft.light_gray_shulker_box": "हल्का स्लेटी शल्कर बक्सा",
  "block.minecraft.light_gray_stained_glass": "हल्का स्लेटी अभिरंजित काँच",
  "block.minecraft.light_gray_stained_glass_pane": "हल्का स्लेटी अभिरंजित खिड़की का काँच",
  "block.minecraft.light_gray_terracotta": "हल्का स्लेटी टेराकोटा",
  "block.minecraft.light_gray_wool": "हल्का स्लेटी ऊन",
  "block.minecraft.light_weighted_pressure_plate": "हल्का भारित दाब पट्ट",
  "block.minecraft.lightning_rod": "तड़ितदंड",
  "block.minecraft.lilac": "नीलक",
  "block.minecraft.lily_of_the_valley": "घाटी के लिली",
  "block.minecraft.lily_pad": "लिली तकती",
  "block.minecraft.lime_banner": "लाइम झंडा",
  "block.minecraft.lime_bed": "लाइम बिस्तर",
  "block.minecraft.lime_candle": "लाईम बत्ती",
  "block.minecraft.lime_candle_cake": "चूने की मोमबत्ती के साथ भोजन",
  "block.minecraft.lime_carpet": "लाइम कालीन",
  "block.minecraft.lime_concrete": "लाइम कंक्रीट",
  "block.minecraft.lime_concrete_powder": "लाइम कंक्रीट का चूरा",
  "block.minecraft.lime_glazed_terracotta": "चूना चमकता हुआ टेराकोटा",
  "block.minecraft.lime_shulker_box": "लाइम शल्कर बक्सा",
  "block.minecraft.lime_stained_glass": "लाइम अभिरंजित काँच",
  "block.minecraft.lime_stained_glass_pane": "लाइम अभिरंजित खिड़की का काँच",
  "block.minecraft.lime_terracotta": "लाइम टेराकोटा",
  "block.minecraft.lime_wool": "लाइम ऊन",
  "block.minecraft.lodestone": "चुंबक पत्थर",
  "block.minecraft.loom": "करघा",
  "block.minecraft.magenta_banner": "नीलातिरक्त झंडा",
  "block.minecraft.magenta_bed": "नीलातिरक्त बिस्तर",
  "block.minecraft.magenta_candle": "नीलातिरक्त बत्ती",
  "block.minecraft.magenta_candle_cake": "मैजेंटा मोमबत्ती के साथ केक",
  "block.minecraft.magenta_carpet": "नीलातिरक्त कालीन",
  "block.minecraft.magenta_concrete": "नीलातिरक्त कंक्रीट",
  "block.minecraft.magenta_concrete_powder": "नीलातिरक्त कंक्रीट का चूरा",
  "block.minecraft.magenta_glazed_terracotta": "मैजेंटा चमकता हुआ टेराकोटा",
  "block.minecraft.magenta_shulker_box": "नीलातिरक्त शल्कर बक्सा",
  "block.minecraft.magenta_stained_glass": "नीलातिरक्त अभिरंजित काँच",
  "block.minecraft.magenta_stained_glass_pane": "नीलातिरक्त अभिरंजित खिड़की का काँच",
  "block.minecraft.magenta_terracotta": "नीलातिरक्त टेराकोटा",
  "block.minecraft.magenta_wool": "नीलातिरक्त ऊन",
  "block.minecraft.magma_block": "मैग्मा ब्लॉक",
  "block.minecraft.mangrove_button": "मैंग्रोव बटन",
  "block.minecraft.mangrove_door": "मैंग्रोव दरवाज़ा",
  "block.minecraft.mangrove_fence": "मैंग्रोव बाड़",
  "block.minecraft.mangrove_fence_gate": "मैंग्रोव बाड़ गेट",
  "block.minecraft.mangrove_hanging_sign": "मैंग्रोव हैंगिंग साइन",
  "block.minecraft.mangrove_leaves": "मैंग्रोव पत्तियां",
  "block.minecraft.mangrove_log": "मैंग्रोव लॉग",
  "block.minecraft.mangrove_planks": "मैंग्रोव प्लांक",
  "block.minecraft.mangrove_pressure_plate": "मैंग्रोव प्रेशर प्लेट",
  "block.minecraft.mangrove_propagule": "मैंग्रोव प्रोपेगुले",
  "block.minecraft.mangrove_roots": "मैंग्रोव जड़ें",
  "block.minecraft.mangrove_shelf": "सुंदरी दराज ",
  "block.minecraft.mangrove_sign": "मैंग्रोव साइन",
  "block.minecraft.mangrove_slab": "Mangrove Slab",
  "block.minecraft.mangrove_stairs": "Mangrove Stairs",
  "block.minecraft.mangrove_trapdoor": "मैंग्रोव ट्रैपडोर",
  "block.minecraft.mangrove_wall_hanging_sign": "मैंग्रोव वॉल हैंगिंग साइन",
  "block.minecraft.mangrove_wall_sign": "मैंग्रोव वॉल साइन",
  "block.minecraft.mangrove_wood": "मैंग्रोव लकड़ी",
  "block.minecraft.medium_amethyst_bud": "मध्यम जंबुमणि की कली",
  "block.minecraft.melon": "खरबूज",
  "block.minecraft.melon_stem": "तरबूज का तना",
  "block.minecraft.moss_block": "काई का खंड",
  "block.minecraft.moss_carpet": "काई का कालीन",
  "block.minecraft.mossy_cobblestone": "काई का फर्शी पत्‍थर",
  "block.minecraft.mossy_cobblestone_slab": "काई का फर्शी पत्‍थर की पटिया",
  "block.minecraft.mossy_cobblestone_stairs": "काई का फर्शी पत्‍थर की सीढ़ियाँ",
  "block.minecraft.mossy_cobblestone_wall": "काई कोबलस्टोन दीवार",
  "block.minecraft.mossy_stone_brick_slab": "काई का पत्थर की ईंट की पटिया",
  "block.minecraft.mossy_stone_brick_stairs": "काई का पत्थर की ईंट की सीढ़ियाँ",
  "block.minecraft.mossy_stone_brick_wall": "काई का पत्थर की ईंट की दीवार",
  "block.minecraft.mossy_stone_bricks": "दलदल का पत्थर की ईंटें",
  "block.minecraft.moving_piston": "पिस्टन को हिलाते हुए",
  "block.minecraft.mud": "कीचड़",
  "block.minecraft.mud_brick_slab": "Mud Brick Slab",
  "block.minecraft.mud_brick_stairs": "मिट्टी की ईंट की सीढ़ियाँ",
  "block.minecraft.mud_brick_wall": "मिट्टी की ईंट की दीवार",
  "block.minecraft.mud_bricks": "मिट्टी के ईंट",
  "block.minecraft.muddy_mangrove_roots": "मैला मैंग्रोव जड़ें",
  "block.minecraft.mushroom_stem": "कुकुरमुत्ता का तना",
  "block.minecraft.mycelium": "कवकजाल",
  "block.minecraft.nether_brick_fence": "नेदर की ईंट की बाड़",
  "block.minecraft.nether_brick_slab": "नेदर ईंट की पटिया",
  "block.minecraft.nether_brick_stairs": "नेदर की ईंट की सीढ़ियाँ",
  "block.minecraft.nether_brick_wall": "नेदर ईंट की दीवार",
  "block.minecraft.nether_bricks": "नेदर के ईंटें",
  "block.minecraft.nether_gold_ore": "नेदर के सोने का अयस्क",
  "block.minecraft.nether_portal": "नेदर प्रवेशद्वार",
  "block.minecraft.nether_quartz_ore": "नेदर स्फटिक का अयस्क",
  "block.minecraft.nether_sprouts": "नेदर के अंकुर",
  "block.minecraft.nether_wart": "नेदर का मस्सा",
  "block.minecraft.nether_wart_block": "नेदर मस्सा ब्लॉक",
  "block.minecraft.netherite_block": "नेदराइट का प्रखंड",
  "block.minecraft.netherrack": "नेदररैक",
  "block.minecraft.note_block": "नोट ब्लॉक करें",
  "block.minecraft.oak_button": "बाँज का बटन",
  "block.minecraft.oak_door": "बाँज का दरवाजा",
  "block.minecraft.oak_fence": "बाँज का बाड़ा",
  "block.minecraft.oak_fence_gate": "बाँज का फाटक",
  "block.minecraft.oak_hanging_sign": "ओक फांसी का संकेत",
  "block.minecraft.oak_leaves": "बाँज के पत्तें",
  "block.minecraft.oak_log": "बाँज का लकड़ी",
  "block.minecraft.oak_planks": "बाँज का तख्ता",
  "block.minecraft.oak_pressure_plate": "बाँज का दाब पट्ट",
  "block.minecraft.oak_sapling": "बाँज का पौधा",
  "block.minecraft.oak_shelf": "बाँज की दराज",
  "block.minecraft.oak_sign": "बाँज का संकेत",
  "block.minecraft.oak_slab": "बाँज की पटिया",
  "block.minecraft.oak_stairs": "बाँज की सीढ़ियाँ",
  "block.minecraft.oak_trapdoor": "बाँज का कूट द्वार",
  "block.minecraft.oak_wall_hanging_sign": "ओक वॉल हैंगिंग साइन",
  "block.minecraft.oak_wall_sign": "बाँज का दीवार संकेत",
  "block.minecraft.oak_wood": "बाँज की लकड़ी",
  "block.minecraft.observer": "पर्यवेक्षक",
  "block.minecraft.obsidian": "ज्वालाकाच",
  "block.minecraft.ochre_froglight": "ओच्रे फ्रोग्लिघ्त",
  "block.minecraft.ominous_banner": "झंडा का आकृति",
  "block.minecraft.open_eyeblossom": "खुली आँख का फूल",
  "block.minecraft.orange_banner": "नारंगी झंडा",
  "block.minecraft.orange_bed": "नारंगी बिस्तर",
  "block.minecraft.orange_candle": "नारंगी बत्ती",
  "block.minecraft.orange_candle_cake": "नारंगी मोमबत्ती के साथ केक",
  "block.minecraft.orange_carpet": "नारंगी कालीन",
  "block.minecraft.orange_concrete": "नारंगी कंक्रीट",
  "block.minecraft.orange_concrete_powder": "नारंगी कंक्रीट का चूरा",
  "block.minecraft.orange_glazed_terracotta": "नारंगी चमकता हुआ टेराकोटा",
  "block.minecraft.orange_shulker_box": "नारंगी शूल्कर बॉक्स",
  "block.minecraft.orange_stained_glass": "नारंगी अभिरंजित काँच",
  "block.minecraft.orange_stained_glass_pane": "नारंगी अभिरंजित खिड़की का काँच",
  "block.minecraft.orange_terracotta": "नारंगी टेराकोटा",
  "block.minecraft.orange_tulip": "नारंगी कंद-पुष्प",
  "block.minecraft.orange_wool": "नारंगी ऊन",
  "block.minecraft.oxeye_daisy": "गुलबहार",
  "block.minecraft.oxidized_chiseled_copper": "ऑक्सीकरण छेनी तांबा",
  "block.minecraft.oxidized_copper": "ऑक्सीकरण तांबा",
  "block.minecraft.oxidized_copper_bars": "ऑक्सीकृत तांबे की छड़ें",
  "block.minecraft.oxidized_copper_bulb": "ऑक्सीकृत कॉपर बल्ब",
  "block.minecraft.oxidized_copper_chain": "ऑक्सीकृत तांबे की ज़ंजीर",
  "block.minecraft.oxidized_copper_chest": "ऑक्सीकृत तांबे का बक्सा",
  "block.minecraft.oxidized_copper_door": "ऑक्सीडाइज्ड कॉपर डोर",
  "block.minecraft.oxidized_copper_golem_statue": "ऑक्सीकृत तांबे की गोलेम की प्रतिमा",
  "block.minecraft.oxidized_copper_grate": "ऑक्सीकृत कॉपर ग्रेट",
  "block.minecraft.oxidized_copper_lantern": "ऑक्सीकृत तांबे की लालटेन",
  "block.minecraft.oxidized_copper_trapdoor": "ऑक्सीडाइज्ड कॉपर ट्रैपडोर",
  "block.minecraft.oxidized_cut_copper": "ऑक्सीकरण किया गया कटा तांबा",
  "block.minecraft.oxidized_cut_copper_slab": "ऑक्सीकरण किए गए कटे तांबे की पटिया",
  "block.minecraft.oxidized_cut_copper_stairs": "ऑक्सीकरण किए गए कटे तांबे की सीढ़ियाँ",
  "block.minecraft.oxidized_lightning_rod": "ऑक्सीकृत तड़ित चालक",
  "block.minecraft.packed_ice": "संकुलित बर्फ",
  "block.minecraft.packed_mud": "संकुलित मिट्टी",
  "block.minecraft.pale_hanging_moss": "फीकी लटकती काई",
  "block.minecraft.pale_moss_block": "फीकी काई ब्लॉक",
  "block.minecraft.pale_moss_carpet": "फीकी काई का कालीन",
  "block.minecraft.pale_oak_button": "फीके बलूत का बटन",
  "block.minecraft.pale_oak_door": "फीका बलूत दरवाज़ा",
  "block.minecraft.pale_oak_fence": "फीका बलूत बाड़",
  "block.minecraft.pale_oak_fence_gate": "फीका बलूत बाड़ दरवाज़ा",
  "block.minecraft.pale_oak_hanging_sign": "फीका बलूत लटकता हुआ चिन्ह",
  "block.minecraft.pale_oak_leaves": "फीकी बाँज के पत्ते",
  "block.minecraft.pale_oak_log": "फीका बलूत लकड़ी का लट्ठा",
  "block.minecraft.pale_oak_planks": "फीकी बाँज के तख्ते",
  "block.minecraft.pale_oak_pressure_plate": "फीका बलूत प्रेशर प्लेट",
  "block.minecraft.pale_oak_sapling": "फीकी बाँज का पौधा",
  "block.minecraft.pale_oak_shelf": "फीका बलूत दराज",
  "block.minecraft.pale_oak_sign": "फीकी बाँज का संकेत",
  "block.minecraft.pale_oak_slab": "फीकी बाँज की पटिया",
  "block.minecraft.pale_oak_stairs": "फीकी बाँज की सीढ़ियाँ",
  "block.minecraft.pale_oak_trapdoor": "फीका बलूत नौका-पृष्ठ का द्वार",
  "block.minecraft.pale_oak_wall_hanging_sign": "फीका बलूत दीवार पर लटकने का चिन्ह",
  "block.minecraft.pale_oak_wall_sign": "फीका बलूत दीवार का चिन्ह",
  "block.minecraft.pale_oak_wood": "फीकी बलूत लकड़ी",
  "block.minecraft.pearlescent_froglight": "पियरलेसेंट फ्रॉगलाइट",
  "block.minecraft.peony": "पीअनी",
  "block.minecraft.petrified_oak_slab": "पेट्रीफाइड ओक स्लैब",
  "block.minecraft.piglin_head": "पिगलीन का सिर",
  "block.minecraft.piglin_wall_head": "पिगलीन की दीवार का सिर",
  "block.minecraft.pink_banner": "गुलाबी झंडा",
  "block.minecraft.pink_bed": "गुलाबी बिस्तर",
  "block.minecraft.pink_candle": "गुलाबी बत्ती",
  "block.minecraft.pink_candle_cake": "गुलाबी मोमबत्ती के साथ केक",
  "block.minecraft.pink_carpet": "गुलाबी कालीन",
  "block.minecraft.pink_concrete": "गुलाबी कंक्रीट",
  "block.minecraft.pink_concrete_powder": "गुलाबी कंक्रीट का चूरा",
  "block.minecraft.pink_glazed_terracotta": "गुलाबी चमकता हुआ टेराकोटा",
  "block.minecraft.pink_petals": "गुलाबी पंखुड़ियाँ",
  "block.minecraft.pink_shulker_box": "गुलाबी शल्कर बक्सा",
  "block.minecraft.pink_stained_glass": "गुलाबी अभिरंजित काँच",
  "block.minecraft.pink_stained_glass_pane": "गुलाबी अभिरंजित खिड़की का काँच",
  "block.minecraft.pink_terracotta": "गुलाबी टेराकोटा",
  "block.minecraft.pink_tulip": "गुलाबी कंद-पुष्प",
  "block.minecraft.pink_wool": "गुलाबी ऊन",
  "block.minecraft.piston": "पिस्टन",
  "block.minecraft.piston_head": "पिस्टन हेड",
  "block.minecraft.pitcher_crop": "पिचर कि फसल",
  "block.minecraft.pitcher_plant": "पिचर के पौधा",
  "block.minecraft.player_head": "खिलाड़ी का सिर",
  "block.minecraft.player_head.named": "%s का सिर",
  "block.minecraft.player_wall_head": "खिलाड़ी दीवार सिर",
  "block.minecraft.podzol": "पॉडज़ोल",
  "block.minecraft.pointed_dripstone": "नुकीला ड्रिपस्टोन",
  "block.minecraft.polished_andesite": "चमकदार एंडेसाइट",
  "block.minecraft.polished_andesite_slab": "चमकदार एंडेसाइट की पटिया",
  "block.minecraft.polished_andesite_stairs": "चमकदार एंडेसाइट की सीढियाँ",
  "block.minecraft.polished_basalt": "चमकदार असिताश्म",
  "block.minecraft.polished_blackstone": "चमकदार कालापाषाण",
  "block.minecraft.polished_blackstone_brick_slab": "चमकदार कालापाषाण की ईंट की पटिया",
  "block.minecraft.polished_blackstone_brick_stairs": "चमकदार कालापाषाण की ईंट की सीढ़ियाँ",
  "block.minecraft.polished_blackstone_brick_wall": "चमकदार कालापाषाण की ईंट की दीवार",
  "block.minecraft.polished_blackstone_bricks": "चमकदार कालापाषाण की ईंटें",
  "block.minecraft.polished_blackstone_button": "चमकदार कालापाषाण का बटन",
  "block.minecraft.polished_blackstone_pressure_plate": "चमकदार कालापाषाण का दाब पट्ट",
  "block.minecraft.polished_blackstone_slab": "चमकदार कालापाषाण की पटिया",
  "block.minecraft.polished_blackstone_stairs": "चमकदार कालापाषाण की सीढ़ियाँ",
  "block.minecraft.polished_blackstone_wall": "चमकदार कालापाषाण की दीवार",
  "block.minecraft.polished_deepslate": "चिकना डीपस्लेट",
  "block.minecraft.polished_deepslate_slab": "चिकने डीपस्लेट की पटिया",
  "block.minecraft.polished_deepslate_stairs": "चिकने डीपस्लेट की सीढ़ियां",
  "block.minecraft.polished_deepslate_wall": "चिकने डीपस्लेट की दीवार",
  "block.minecraft.polished_diorite": "चिकना डायोराइट",
  "block.minecraft.polished_diorite_slab": "चिकना डाओराइट की पटिया",
  "block.minecraft.polished_diorite_stairs": "चिकना डाओराइट की सीढ़ियाँ",
  "block.minecraft.polished_granite": "चिकना ग्रेनाइट",
  "block.minecraft.polished_granite_slab": "चिकने ग्रेनाइट की पटिया",
  "block.minecraft.polished_granite_stairs": "चिकने ग्रेनाइट की सीढ़ियाँ",
  "block.minecraft.polished_tuff": "पॉलिश टफ",
  "block.minecraft.polished_tuff_slab": "पॉलिश टफ स्लैब",
  "block.minecraft.polished_tuff_stairs": "पॉलिश टफ सीढ़ियाँ",
  "block.minecraft.polished_tuff_wall": "पॉलिश टफ दीवार",
  "block.minecraft.poppy": "पोस्त",
  "block.minecraft.potatoes": "आलू",
  "block.minecraft.potted_acacia_sapling": "गमले में बबूल का पौधा",
  "block.minecraft.potted_allium": "गमले में प्याज फूल",
  "block.minecraft.potted_azalea_bush": "गमले में अजालिया",
  "block.minecraft.potted_azure_bluet": "पॉटेड एज़ूर ब्लूट",
  "block.minecraft.potted_bamboo": "गमले में बाँस",
  "block.minecraft.potted_birch_sapling": "गमले में भूर्ज का पौधा",
  "block.minecraft.potted_blue_orchid": "गमले में नीला आर्किड",
  "block.minecraft.potted_brown_mushroom": "गमले में भूरा कुकुरमुत्ता",
  "block.minecraft.potted_cactus": "गमले में कैक्टस",
  "block.minecraft.potted_cherry_sapling": "पॉट में रखने के लिए चेरी के छोटे पेड़",
  "block.minecraft.potted_closed_eyeblossom": "गमले में लगा बंद फूल",
  "block.minecraft.potted_cornflower": "गमलें में मकई का फूल",
  "block.minecraft.potted_crimson_fungus": "गमले में किरमिजी कवक",
  "block.minecraft.potted_crimson_roots": "गमले में किरमिजी जड़ें",
  "block.minecraft.potted_dandelion": "गमले में सिंहपर्णी",
  "block.minecraft.potted_dark_oak_sapling": "गमले में काला बाँज का पौधा",
  "block.minecraft.potted_dead_bush": "गमले में मृत पौधा",
  "block.minecraft.potted_fern": "गमले में फर्न",
  "block.minecraft.potted_flowering_azalea_bush": "पॉटेड फ्लावरिंग अज़ेलिया",
  "block.minecraft.potted_golden_dandelion": "गमले में सुनहरा सिंहपर्णी",
  "block.minecraft.potted_jungle_sapling": "गमले में जंगल का पौधा",
  "block.minecraft.potted_lily_of_the_valley": "घाटी के पॉटेड लिली",
  "block.minecraft.potted_mangrove_propagule": "पॉटेड मैंग्रोव प्रोपेग्यूल",
  "block.minecraft.potted_oak_sapling": "गमले में बाँज का पौधा",
  "block.minecraft.potted_open_eyeblossom": "गमले में खुला आइब्लॉसम",
  "block.minecraft.potted_orange_tulip": "गमले में नारंगी कंद-पुष्प",
  "block.minecraft.potted_oxeye_daisy": "पॉटेड ऑक्सी डेज़ी",
  "block.minecraft.potted_pale_oak_sapling": "गमले में लगा पीला ओक का पौधा",
  "block.minecraft.potted_pink_tulip": "गमले में गुलाबी कंद-पुष्प",
  "block.minecraft.potted_poppy": "गमले में पोस्त",
  "block.minecraft.potted_red_mushroom": "गमले में लाला कुकुरमुत्ता",
  "block.minecraft.potted_red_tulip": "गमले में लाल कंद-पुष्प",
  "block.minecraft.potted_spruce_sapling": "गमले में प्रसरल का पौधा",
  "block.minecraft.potted_torchflower": "पॉट में रखने के लिए टॉर्चफ्लोवर",
  "block.minecraft.potted_warped_fungus": "गमले में विकृत कवक",
  "block.minecraft.potted_warped_roots": "गमले में विकृत जड़ें",
  "block.minecraft.potted_white_tulip": "गमले में सफेद कंद-पुष्प",
  "block.minecraft.potted_wither_rose": "गमले में विदर गुलाब",
  "block.minecraft.powder_snow": "पीसा हुआ बर्फ",
  "block.minecraft.powder_snow_cauldron": "पाउडर बर्फ कड़ाही",
  "block.minecraft.powered_rail": "संचालित रेल",
  "block.minecraft.prismarine": "प्रिज्मरीन",
  "block.minecraft.prismarine_brick_slab": "प्रिज्मरीन ईंट की पटिया",
  "block.minecraft.prismarine_brick_stairs": "प्रिज्मरीन की ईंट की सीढ़ियाँ",
  "block.minecraft.prismarine_bricks": "प्रिज्मरीन ईंटें",
  "block.minecraft.prismarine_slab": "प्रिज्मरीन की पटिया",
  "block.minecraft.prismarine_stairs": "प्रिज्मरीन की सीढ़ियाँ",
  "block.minecraft.prismarine_wall": "प्रिज्मरीन की दीवार",
  "block.minecraft.pumpkin": "कद्दू",
  "block.minecraft.pumpkin_stem": "कद्दू का तना",
  "block.minecraft.purple_banner": "जामुनी झंडा",
  "block.minecraft.purple_bed": "गुलाबी बिस्तर",
  "block.minecraft.purple_candle": "जामुनी बत्ती",
  "block.minecraft.purple_candle_cake": "बैंगनी मोमबत्ती के साथ केक",
  "block.minecraft.purple_carpet": "जामुनी कालीन",
  "block.minecraft.purple_concrete": "जामुनी कंक्रीट",
  "block.minecraft.purple_concrete_powder": "जामुनी कंक्रीट का चूरा",
  "block.minecraft.purple_glazed_terracotta": "बैंगनी चमकता हुआ टेराकोटा",
  "block.minecraft.purple_shulker_box": "जामुनी शल्कर बक्सा",
  "block.minecraft.purple_stained_glass": "जामुनी अभिरंजित काँच",
  "block.minecraft.purple_stained_glass_pane": "जामुनी अभिरंजित खिड़की का काँच",
  "block.minecraft.purple_terracotta": "जामुनी टेराकोटा",
  "block.minecraft.purple_wool": "जामुनी ऊन",
  "block.minecraft.purpur_block": "परपर का प्रखंड",
  "block.minecraft.purpur_pillar": "परपर का स्तंभ",
  "block.minecraft.purpur_slab": "परपर की पटिया",
  "block.minecraft.purpur_stairs": "परपर की सीढ़ियाँ",
  "block.minecraft.quartz_block": "स्फटिक का प्रखंड",
  "block.minecraft.quartz_bricks": "स्फटिक की ईंटे",
  "block.minecraft.quartz_pillar": "स्फटिक का स्तंभ",
  "block.minecraft.quartz_slab": "स्फटिक की पटिया",
  "block.minecraft.quartz_stairs": "स्फटिक की सीढ़ियाँ",
  "block.minecraft.rail": "रेल",
  "block.minecraft.raw_copper_block": "कच्चे तांबे का ब्लॉक",
  "block.minecraft.raw_gold_block": "कच्चे सोने का ब्लॉक",
  "block.minecraft.raw_iron_block": "कच्चे लोहे का ब्लॉक",
  "block.minecraft.red_banner": "लाल झंडा",
  "block.minecraft.red_bed": "लाल बिस्तर",
  "block.minecraft.red_candle": "लाल बत्ती",
  "block.minecraft.red_candle_cake": "लाल मोमबत्ती के साथ केक",
  "block.minecraft.red_carpet": "लाल कालीन",
  "block.minecraft.red_concrete": "लाल कंक्रीट",
  "block.minecraft.red_concrete_powder": "लाल कंक्रीट का चूरा",
  "block.minecraft.red_glazed_terracotta": "लाल चमकता हुआ टेराकोटा",
  "block.minecraft.red_mushroom": "लाल कुकुरमुत्ता",
  "block.minecraft.red_mushroom_block": "लाल कुकुरमुत्ता का प्रखंड",
  "block.minecraft.red_nether_brick_slab": "लाल नेदर ईंट की पटिया",
  "block.minecraft.red_nether_brick_stairs": "लाल नेदर ईंट की सीढ़ियाँ",
  "block.minecraft.red_nether_brick_wall": "लाल नेदर ईंट की दीवार",
  "block.minecraft.red_nether_bricks": "लाल नीदरलैंड ईंटें",
  "block.minecraft.red_sand": "लाल रेत",
  "block.minecraft.red_sandstone": "लाल बलुआ पत्थर",
  "block.minecraft.red_sandstone_slab": "लाल बलुआ पत्थर की पटिया",
  "block.minecraft.red_sandstone_stairs": "लाल बलुआ पत्थर की सीढ़ियाँ",
  "block.minecraft.red_sandstone_wall": "लाल बलुआ पत्थर की दीवार",
  "block.minecraft.red_shulker_box": "लाल शल्कर बक्सा",
  "block.minecraft.red_stained_glass": "लाल अभिरंजित काँच",
  "block.minecraft.red_stained_glass_pane": "लाल अभिरंजित खिड़की का काँच",
  "block.minecraft.red_terracotta": "लाल टेराकोटा",
  "block.minecraft.red_tulip": "लाल कंद-पुष्प",
  "block.minecraft.red_wool": "लाल ऊन",
  "block.minecraft.redstone_block": "रेडस्टोन का ब्लॉक",
  "block.minecraft.redstone_lamp": "रेडस्टोन लैंप",
  "block.minecraft.redstone_ore": "रेडस्टोन का अयस्क",
  "block.minecraft.redstone_torch": "रेडस्टोन की मशाल",
  "block.minecraft.redstone_wall_torch": "रेडस्टोन की दीवार का मशाल",
  "block.minecraft.redstone_wire": "रेडस्टोन का तार",
  "block.minecraft.reinforced_deepslate": "संक्रमित डीपस्लेट",
  "block.minecraft.repeater": "लाल पत्थर पुनरावर्तक",
  "block.minecraft.repeating_command_block": "दोहराए जाने वाले आदेश ब्लॉक",
  "block.minecraft.resin_block": "राल का ब्लॉक",
  "block.minecraft.resin_brick_slab": "राल ईंट स्लैब",
  "block.minecraft.resin_brick_stairs": "राल ईंट सीढ़ियाँ",
  "block.minecraft.resin_brick_wall": "राल ईंट की दीवार",
  "block.minecraft.resin_bricks": "राल ईंट",
  "block.minecraft.resin_clump": "राल का झुरमुट",
  "block.minecraft.respawn_anchor": "पुनर्जन्म का स्थिरक",
  "block.minecraft.rooted_dirt": "जड़ वाली मिट्टी",
  "block.minecraft.rose_bush": "गुलाब की झाड़ी",
  "block.minecraft.sand": "रेत",
  "block.minecraft.sandstone": "बलुआ पत्थर",
  "block.minecraft.sandstone_slab": "बलुआ पत्थर की पटिया",
  "block.minecraft.sandstone_stairs": "बलुआ पत्थर की सीढ़ियाँ",
  "block.minecraft.sandstone_wall": "बलुआ पत्थर की दीवार",
  "block.minecraft.scaffolding": "मचान",
  "block.minecraft.sculk": "स्कुल्क",
  "block.minecraft.sculk_catalyst": "स्कल्क कैटलिस्ट",
  "block.minecraft.sculk_sensor": "स्कल्क संवेदक",
  "block.minecraft.sculk_shrieker": "स्कुल्क श्रिकेर",
  "block.minecraft.sculk_vein": "स्कुल्क वेइन",
  "block.minecraft.sea_lantern": "सागर लालटेन",
  "block.minecraft.sea_pickle": "समुद्र का अचार",
  "block.minecraft.seagrass": "समुद्री घास",
  "block.minecraft.set_spawn": "प्रतिक्रिया बिंदु सेट",
  "block.minecraft.short_dry_grass": "छोटी सूखी घास",
  "block.minecraft.short_grass": "छोटी घास",
  "block.minecraft.shroomlight": "छत्रकदीप",
  "block.minecraft.shulker_box": "शल्कर बक्सा",
  "block.minecraft.skeleton_skull": "कंकाल की खोपड़ी",
  "block.minecraft.skeleton_wall_skull": "कंकाल की दीवार की खोपड़ी",
  "block.minecraft.slime_block": "कीचड़ ब्लॉक",
  "block.minecraft.small_amethyst_bud": "छोटा जंबुमणि की कली",
  "block.minecraft.small_dripleaf": "छोटा ड्रिपलीफ",
  "block.minecraft.smithing_table": "स्मिथिंग टेबल",
  "block.minecraft.smoker": "तंदूर",
  "block.minecraft.smooth_basalt": "चिकना बेसाल्ट",
  "block.minecraft.smooth_quartz": "चिकना स्फटिक का प्रखंड",
  "block.minecraft.smooth_quartz_slab": "चिकना स्फटिक की पटिया",
  "block.minecraft.smooth_quartz_stairs": "चिकना स्फटिक की सीढ़ियाँ",
  "block.minecraft.smooth_red_sandstone": "चिकनी लाल बलुआ पत्थर",
  "block.minecraft.smooth_red_sandstone_slab": "चिकना लाल बलुआ पत्थर की पटिया",
  "block.minecraft.smooth_red_sandstone_stairs": "चिकनी लाल बलुआ पत्थर की सीढ़ियाँ",
  "block.minecraft.smooth_sandstone": "चिकनी बलुआ पत्थर",
  "block.minecraft.smooth_sandstone_slab": "चिकना बलुआ पत्थर की पटिया",
  "block.minecraft.smooth_sandstone_stairs": "चिकनी बलुआ पत्थर की सीढ़ियाँ",
  "block.minecraft.smooth_stone": "चिकना पत्थर",
  "block.minecraft.smooth_stone_slab": "चिकना पत्थर की पटिया",
  "block.minecraft.sniffer_egg": "खोजी का अंडा",
  "block.minecraft.snow": "हिम",
  "block.minecraft.snow_block": "स्नो ब्लॉक",
  "block.minecraft.soul_campfire": "आत्मा का अलाव",
  "block.minecraft.soul_fire": "आत्माओं की आग",
  "block.minecraft.soul_lantern": "आत्माओं का फानूस",
  "block.minecraft.soul_sand": "आत्मा की रेत",
  "block.minecraft.soul_soil": "आत्माओं की भूमि",
  "block.minecraft.soul_torch": "आत्मा की मशाल",
  "block.minecraft.soul_wall_torch": "आत्मा की दीवार मशाल",
  "block.minecraft.spawn.not_valid": "आपके पास बिस्तर या पुनर्जन्म का स्थिरक नहीं है, या वह अवरुद्ध हो गया था",
  "block.minecraft.spawner": "राक्षस पैदा करनेवाला",
  "block.minecraft.spawner.desc1": "स्पॉन एग के साथ इंटरैक्ट करें",
  "block.minecraft.spawner.desc2": "जीव प्रकार सेट करता है",
  "block.minecraft.sponge": "स्पंज",
  "block.minecraft.spore_blossom": "स्पोर का बौर",
  "block.minecraft.spruce_button": "प्रसरल का बटन",
  "block.minecraft.spruce_door": "प्रसरल का दरवाजा",
  "block.minecraft.spruce_fence": "प्रसरल का बाड़ा",
  "block.minecraft.spruce_fence_gate": "प्रसरल का फाटक",
  "block.minecraft.spruce_hanging_sign": "प्रसरल का लटकने वाला संकेत",
  "block.minecraft.spruce_leaves": "प्रसरल के पत्तें",
  "block.minecraft.spruce_log": "स्प्रूस लॉग इन करें",
  "block.minecraft.spruce_planks": "प्रसरल का तख्ता",
  "block.minecraft.spruce_pressure_plate": "प्रसरल का दाब पट्ट",
  "block.minecraft.spruce_sapling": "प्रसरल का पौधा",
  "block.minecraft.spruce_shelf": "प्रसरल की दराज",
  "block.minecraft.spruce_sign": "प्रसरल का संकेत",
  "block.minecraft.spruce_slab": "प्रसरल की पटिया",
  "block.minecraft.spruce_stairs": "प्रसरल की सीढ़ियाँ",
  "block.minecraft.spruce_trapdoor": "प्रसरल का कूट द्वार",
  "block.minecraft.spruce_wall_hanging_sign": "दीवार से लटकने वाला प्रसरल का संकेत",
  "block.minecraft.spruce_wall_sign": "प्रसरल का दीवार संकेत",
  "block.minecraft.spruce_wood": "प्रसरल की लकड़ी",
  "block.minecraft.sticky_piston": "चिपचिपा पिस्टन",
  "block.minecraft.stone": "पत्थर",
  "block.minecraft.stone_brick_slab": "पत्थर की ईंट की पटिया",
  "block.minecraft.stone_brick_stairs": "पत्थर की ईंट की सीढ़ियाँ",
  "block.minecraft.stone_brick_wall": "पत्थर की ईंट की दीवार",
  "block.minecraft.stone_bricks": "पत्थर की ईंटें",
  "block.minecraft.stone_button": "पथरीला बटन",
  "block.minecraft.stone_pressure_plate": "पत्थर का दाब पट्ट",
  "block.minecraft.stone_slab": "पत्थर की पटिया",
  "block.minecraft.stone_stairs": "पत्थर की सीढ़ियाँ",
  "block.minecraft.stonecutter": "संगतराश",
  "block.minecraft.stripped_acacia_log": "छीन लिया बबूल लॉग",
  "block.minecraft.stripped_acacia_wood": "छीना हुआ बबूल की लकड़ी",
  "block.minecraft.stripped_bamboo_block": "फटे हुए बाँस का खंड",
  "block.minecraft.stripped_birch_log": "छीन लिया सन्टी लॉग",
  "block.minecraft.stripped_birch_wood": "छीना हुआ भूर्ज की लकड़ी",
  "block.minecraft.stripped_cherry_log": "चेरी के छीले हुए लट्ठे",
  "block.minecraft.stripped_cherry_wood": "चेरी की छीली हुई लकड़ी",
  "block.minecraft.stripped_crimson_hyphae": "छीना हुआ किरमिजी कवकतंतुएँ",
  "block.minecraft.stripped_crimson_stem": "छीना हुआ किरमिजी तना",
  "block.minecraft.stripped_dark_oak_log": "छीन लिया डार्क ओक लॉग",
  "block.minecraft.stripped_dark_oak_wood": "छीना हुआ काला बाँज की लकड़ी",
  "block.minecraft.stripped_jungle_log": "छीन लिया जंगल लॉग",
  "block.minecraft.stripped_jungle_wood": "छीना हुआ जंगल की लकड़ी",
  "block.minecraft.stripped_mangrove_log": "धारीदार मैंग्रोव लॉग",
  "block.minecraft.stripped_mangrove_wood": "Stripped Mangrove Wood",
  "block.minecraft.stripped_oak_log": "छीन लिया ओक लॉग",
  "block.minecraft.stripped_oak_wood": "छीना हुआ बाँज की लकड़ी",
  "block.minecraft.stripped_pale_oak_log": "धारीदार पीला ओक लॉग",
  "block.minecraft.stripped_pale_oak_wood": "धारीदार पीली ओक की लकड़ी",
  "block.minecraft.stripped_spruce_log": "छीन लिया स्प्रूस लॉग",
  "block.minecraft.stripped_spruce_wood": "छीना हुआ प्रसरल की लकड़ी",
  "block.minecraft.stripped_warped_hyphae": "छीना हुआ विकृत कवकतंतुएँ",
  "block.minecraft.stripped_warped_stem": "छीना हुआ विकृत तना",
  "block.minecraft.structure_block": "ब्लॉक संरचना",
  "block.minecraft.structure_void": "संरचना शून्य",
  "block.minecraft.sugar_cane": "गन्ना",
  "block.minecraft.sunflower": "सूरजमुखी",
  "block.minecraft.suspicious_gravel": "अगिब कंकड़",
  "block.minecraft.suspicious_sand": "संदिग्ध रेत",
  "block.minecraft.sweet_berry_bush": "मीठा फल का झाड़",
  "block.minecraft.tall_dry_grass": "लम्बी सूखी घास",
  "block.minecraft.tall_grass": "लंबा घास",
  "block.minecraft.tall_seagrass": "लंबा समुद्री घास",
  "block.minecraft.target": "निशाना",
  "block.minecraft.terracotta": "टेराकोटा",
  "block.minecraft.test_block": "परीक्षण ब्लॉक",
  "block.minecraft.test_instance_block": "परीक्षण उदाहरण ब्लॉक",
  "block.minecraft.tinted_glass": "रंगीन काँच",
  "block.minecraft.tnt": "टीएनटी",
  "block.minecraft.tnt.disabled": "टीएनटी विस्फोट अक्षम हैं",
  "block.minecraft.torch": "मशाल",
  "block.minecraft.torchflower": "टॉर्चफ्लॉवर",
  "block.minecraft.torchflower_crop": "टॉर्चफ्लोवर फसल",
  "block.minecraft.trapped_chest": "जाल बक्सा",
  "block.minecraft.trial_spawner": "ट्रायल स्पॉनर",
  "block.minecraft.tripwire": "ट्रिपवायर",
  "block.minecraft.tripwire_hook": "ट्रिपवायर हुक",
  "block.minecraft.tube_coral": "नलिका का मूँगा",
  "block.minecraft.tube_coral_block": "नलिका का मूँगा का प्रखंड",
  "block.minecraft.tube_coral_fan": "नलिका का मूँगा का पंखा",
  "block.minecraft.tube_coral_wall_fan": "नलिका का मूँगा का दीवार पंखा",
  "block.minecraft.tuff": "घनाश्म",
  "block.minecraft.tuff_brick_slab": "टफ ईंट स्लैब",
  "block.minecraft.tuff_brick_stairs": "टफ ईंट सीढ़ियाँ",
  "block.minecraft.tuff_brick_wall": "टफ ईंट की दीवार",
  "block.minecraft.tuff_bricks": "टफ ईंटें",
  "block.minecraft.tuff_slab": "टफ स्लैब",
  "block.minecraft.tuff_stairs": "टफ सीढ़ियाँ",
  "block.minecraft.tuff_wall": "टफ दीवार",
  "block.minecraft.turtle_egg": "कछुआ का अंडा",
  "block.minecraft.twisting_vines": "घुमावदार बेलों",
  "block.minecraft.twisting_vines_plant": "घुमावदार बेलों के पौधे",
  "block.minecraft.vault": "तिजोरी",
  "block.minecraft.verdant_froglight": "वर्डेंट फ्रॉगलाइट",
  "block.minecraft.vine": "बेलें",
  "block.minecraft.void_air": "शूंय हवा",
  "block.minecraft.wall_torch": "दीवार का मशाल",
  "block.minecraft.warped_button": "विकृत बटन",
  "block.minecraft.warped_door": "विकृत दरवाजा",
  "block.minecraft.warped_fence": "विकृत बाड़",
  "block.minecraft.warped_fence_gate": "विकृत फाटक",
  "block.minecraft.warped_fungus": "विकृत कवक",
  "block.minecraft.warped_hanging_sign": "वॉर्प्ड लटकती बोर्ड",
  "block.minecraft.warped_hyphae": "विकृत कवकतंतुएँ",
  "block.minecraft.warped_nylium": "विकृत नीलियम",
  "block.minecraft.warped_planks": "विकृत तख्तें",
  "block.minecraft.warped_pressure_plate": "विकृत दाब पट्ट",
  "block.minecraft.warped_roots": "विकृत जड़ें",
  "block.minecraft.warped_shelf": "विकृत दराज",
  "block.minecraft.warped_sign": "विकृत संकेत",
  "block.minecraft.warped_slab": "विकृत पटिया",
  "block.minecraft.warped_stairs": "विकृत सीढ़ियाँ",
  "block.minecraft.warped_stem": "विकृत तना",
  "block.minecraft.warped_trapdoor": "विकृत कूट द्वार",
  "block.minecraft.warped_wall_hanging_sign": "विकृत वॉल हैंगिंग साइन",
  "block.minecraft.warped_wall_sign": "विकृत दीवार संकेत",
  "block.minecraft.warped_wart_block": "विकृत मस्सा ब्लॉक",
  "block.minecraft.water": "पानी",
  "block.minecraft.water_cauldron": "पानी की कड़ाही",
  "block.minecraft.waxed_chiseled_copper": "मोमी तराशा हुआ तांबा",
  "block.minecraft.waxed_copper_bars": "मोमी तांबे की छड़ें",
  "block.minecraft.waxed_copper_block": "मोमी तांबे का खंड",
  "block.minecraft.waxed_copper_bulb": "मोमी कॉपर बल्ब",
  "block.minecraft.waxed_copper_chain": "मोमी तांबे की जंजीर",
  "block.minecraft.waxed_copper_chest": "मोमी तांबे का बक्सा",
  "block.minecraft.waxed_copper_door": "मोमी तांबे का दरवाजा",
  "block.minecraft.waxed_copper_golem_statue": "मोमी तांबे के गोलेम की प्रतिमा",
  "block.minecraft.waxed_copper_grate": "मोमी तांबे की जाली",
  "block.minecraft.waxed_copper_lantern": "मोमी तांबे की लालटेन",
  "block.minecraft.waxed_copper_trapdoor": "मोमी तांबे का ट्रैपडोर",
  "block.minecraft.waxed_cut_copper": "मोमी कटे हुए तांबे",
  "block.minecraft.waxed_cut_copper_slab": "मोमी कटे हुए तांबे की पटिया",
  "block.minecraft.waxed_cut_copper_stairs": "मोमी कटे हुए तांबे की सीढ़ियाँ",
  "block.minecraft.waxed_exposed_chiseled_copper": "लच्छेदार उजागर छेनी तांबे",
  "block.minecraft.waxed_exposed_copper": "मोमी उजागर तांबा",
  "block.minecraft.waxed_exposed_copper_bars": "Waxed Exposed Copper Bars",
  "block.minecraft.waxed_exposed_copper_bulb": "लच्छेदार उजागर कॉपर बल्ब",
  "block.minecraft.waxed_exposed_copper_chain": "Waxed Exposed Copper Chain",
  "block.minecraft.waxed_exposed_copper_chest": "Waxed Exposed Copper Chest",
  "block.minecraft.waxed_exposed_copper_door": "लच्छेदार उजागर तांबे का दरवाजा",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Waxed Exposed Copper Golem Statue",
  "block.minecraft.waxed_exposed_copper_grate": "लच्छेदार उजागर कॉपर ग्रेट",
  "block.minecraft.waxed_exposed_copper_lantern": "Waxed Exposed Copper Lantern",
  "block.minecraft.waxed_exposed_copper_trapdoor": "लच्छेदार उजागर कॉपर ट्रैपडोर",
  "block.minecraft.waxed_exposed_cut_copper": "मोमी खुला कटा तांबा",
  "block.minecraft.waxed_exposed_cut_copper_slab": "मोमी खुले कटे तांबे की पटिया",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "मोमी खुले कटे तांबे की सीढ़ियाँ",
  "block.minecraft.waxed_exposed_lightning_rod": "Waxed Exposed Lightning Rod",
  "block.minecraft.waxed_lightning_rod": "मोमी तड़ितदंड",
  "block.minecraft.waxed_oxidized_chiseled_copper": "लच्छेदार ऑक्सीकरण छेनी तांबा",
  "block.minecraft.waxed_oxidized_copper": "मोम लगा ऑक्सीकृत तांबा",
  "block.minecraft.waxed_oxidized_copper_bars": "Waxed Oxidized Copper Bars",
  "block.minecraft.waxed_oxidized_copper_bulb": "लच्छेदार ऑक्सीकृत कॉपर बल्ब",
  "block.minecraft.waxed_oxidized_copper_chain": "Waxed Oxidized Copper Chain",
  "block.minecraft.waxed_oxidized_copper_chest": "Waxed Oxidized Copper Chest",
  "block.minecraft.waxed_oxidized_copper_door": "लच्छेदार ऑक्सीकृत कॉपर दरवाजा",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Waxed Oxidized Copper Golem Statue",
  "block.minecraft.waxed_oxidized_copper_grate": "लच्छेदार ऑक्सीकृत कॉपर ग्रेट",
  "block.minecraft.waxed_oxidized_copper_lantern": "Waxed Oxidized Copper Lantern",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "लच्छेदार ऑक्सीकृत कॉपर ट्रैपडोर",
  "block.minecraft.waxed_oxidized_cut_copper": "मोम लगा कटा ऑक्सीकृत तांबा",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "मोम लगे कटे ऑक्सीकृत तांबे की पटिया",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "मोम लगे कटे ऑक्सीकृत तांबे की सीढ़ियां",
  "block.minecraft.waxed_oxidized_lightning_rod": "Waxed Oxidized Lightning Rod",
  "block.minecraft.waxed_weathered_chiseled_copper": "लच्छेदार छिद्रित तांबा",
  "block.minecraft.waxed_weathered_copper": "मोमी अपक्षीण तांबा",
  "block.minecraft.waxed_weathered_copper_bars": "Waxed Weathered Copper Bars",
  "block.minecraft.waxed_weathered_copper_bulb": "लच्छेदार तांबे का बल्ब",
  "block.minecraft.waxed_weathered_copper_chain": "Waxed Weathered Copper Chain",
  "block.minecraft.waxed_weathered_copper_chest": "Waxed Weathered Copper Chest",
  "block.minecraft.waxed_weathered_copper_door": "लच्छेदार आबोहवा तांबे का दरवाजा",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Waxed Weathered Copper Golem Statue",
  "block.minecraft.waxed_weathered_copper_grate": "वैक्सड वेदरड कॉपर ग्रेट",
  "block.minecraft.waxed_weathered_copper_lantern": "Waxed Weathered Copper Lantern",
  "block.minecraft.waxed_weathered_copper_trapdoor": "लच्छेदार अनुभवी कॉपर ट्रैपडोर",
  "block.minecraft.waxed_weathered_cut_copper": "मोमी अपक्षीण कटा हुआ तांबा",
  "block.minecraft.waxed_weathered_cut_copper_slab": "मोमी अपक्षीण कटे हुए तांबे की पटिया",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "मोमी अपक्षीण कटे हुए तांबे की सीढ़ियाँ",
  "block.minecraft.waxed_weathered_lightning_rod": "Waxed Weathered Lightning Rod",
  "block.minecraft.weathered_chiseled_copper": "छिद्रित तांबे का मौसम",
  "block.minecraft.weathered_copper": "अपक्षीण हुआ तांबे",
  "block.minecraft.weathered_copper_bars": "Weathered Copper Bars",
  "block.minecraft.weathered_copper_bulb": "आबोहवा कॉपर बल्ब",
  "block.minecraft.weathered_copper_chain": "Weathered Copper Chain",
  "block.minecraft.weathered_copper_chest": "Weathered Copper Chest",
  "block.minecraft.weathered_copper_door": "आबोहवा तांबे का दरवाजा",
  "block.minecraft.weathered_copper_golem_statue": "Weathered Copper Golem Statue",
  "block.minecraft.weathered_copper_grate": "अनुभवी तांबे की जाली",
  "block.minecraft.weathered_copper_lantern": "Weathered Copper Lantern",
  "block.minecraft.weathered_copper_trapdoor": "पुराना तांबे का कूट द्वार",
  "block.minecraft.weathered_cut_copper": "अपक्षीण कटे हुए तांबे",
  "block.minecraft.weathered_cut_copper_slab": "कटे हुए अपक्षीण तांबे की पटिया",
  "block.minecraft.weathered_cut_copper_stairs": "अपक्षीण कटे हुए तांबे की सीढ़ियाँ",
  "block.minecraft.weathered_lightning_rod": "Weathered Lightning Rod",
  "block.minecraft.weeping_vines": "रिसती बेलों",
  "block.minecraft.weeping_vines_plant": "रिसती बेलों के पौधे",
  "block.minecraft.wet_sponge": "गीला स्पंज",
  "block.minecraft.wheat": "गेहूँ की फसलें",
  "block.minecraft.white_banner": "सफेद झंडा",
  "block.minecraft.white_bed": "सफेद बिस्तर",
  "block.minecraft.white_candle": "सफेद बत्ती",
  "block.minecraft.white_candle_cake": "सफेद मोमबत्ती के साथ केक",
  "block.minecraft.white_carpet": "सफेद कालीन",
  "block.minecraft.white_concrete": "सफेद कंक्रीट",
  "block.minecraft.white_concrete_powder": "सफेद कंक्रीट का चूरा",
  "block.minecraft.white_glazed_terracotta": "सफेद चमकता हुआ टेराकोटा",
  "block.minecraft.white_shulker_box": "सफेद शल्कर बक्सा",
  "block.minecraft.white_stained_glass": "सफेद अभिरंजित काँच",
  "block.minecraft.white_stained_glass_pane": "सफेद अभिरंजित खिड़की का काँच",
  "block.minecraft.white_terracotta": "सफेद टेराकोटा",
  "block.minecraft.white_tulip": "सफेद कंद-पुष्प",
  "block.minecraft.white_wool": "सफेद ऊन",
  "block.minecraft.wildflowers": "जंगली फूल",
  "block.minecraft.wither_rose": "विदर गुलाब",
  "block.minecraft.wither_skeleton_skull": "मुरझाए कंकाल खोपड़ी",
  "block.minecraft.wither_skeleton_wall_skull": "मुरझाए कंकाल दीवार खोपड़ी",
  "block.minecraft.yellow_banner": "पीला झंडा",
  "block.minecraft.yellow_bed": "पीला बिस्तर",
  "block.minecraft.yellow_candle": "पीली बत्ती",
  "block.minecraft.yellow_candle_cake": "पीली मोमबत्ती के साथ केक",
  "block.minecraft.yellow_carpet": "पीला कालीन",
  "block.minecraft.yellow_concrete": "पीला कंक्रीट",
  "block.minecraft.yellow_concrete_powder": "पीला कंक्रीट का चूरा",
  "block.minecraft.yellow_glazed_terracotta": "पीला चमकता हुआ टेराकोटा",
  "block.minecraft.yellow_shulker_box": "पीला शल्कर बक्सा",
  "block.minecraft.yellow_stained_glass": "पीला अभिरंजित काँच",
  "block.minecraft.yellow_stained_glass_pane": "पीला अभिरंजित खिड़की का काँच",
  "block.minecraft.yellow_terracotta": "पीला टेराकोटा",
  "block.minecraft.yellow_wool": "पीला ऊन",
  "block.minecraft.zombie_head": "जॉम्बी का सिर",
  "block.minecraft.zombie_wall_head": "ज़ोंबी दीवार सिर",
  "item.minecraft.acacia_boat": "बबूल की नाव",
  "item.minecraft.acacia_chest_boat": "बबूल की बक्से वाली नाव",
  "item.minecraft.allay_spawn_egg": "अलाय स्पॉन अंडा",
  "item.minecraft.amethyst_shard": "जंबुमणि का ठीकरा",
  "item.minecraft.angler_pottery_shard": "एंगलर पॉटरी शार्ड",
  "item.minecraft.angler_pottery_sherd": "एंगलर पॉटरी शेर्ड",
  "item.minecraft.apple": "सेब",
  "item.minecraft.archer_pottery_shard": "आर्चर पॉटरी शार्ड",
  "item.minecraft.archer_pottery_sherd": "आर्चर पॉटरी शेर्ड",
  "item.minecraft.armadillo_scute": "आर्माडिलो स्क्यूट",
  "item.minecraft.armadillo_spawn_egg": "आर्माडिलो स्पॉन अंडा",
  "item.minecraft.armor_stand": "पुतला",
  "item.minecraft.arms_up_pottery_shard": "आर्म्स अप पॉटरी शार्ड",
  "item.minecraft.arms_up_pottery_sherd": "आर्म्स अप पॉटरी शेर्ड",
  "item.minecraft.arrow": "तीर",
  "item.minecraft.axolotl_bucket": "एक्सोलोटल की बाल्टी",
  "item.minecraft.axolotl_spawn_egg": "एक्सोलोटल का जन्म अंडा",
  "item.minecraft.baked_potato": "सेका हुआ आलू",
  "item.minecraft.bamboo_chest_raft": "बांस का बक्से वाला बेड़ा",
  "item.minecraft.bamboo_raft": "बांस राफ्ट",
  "item.minecraft.bat_spawn_egg": "चमगादड़ का जन्म अंडा",
  "item.minecraft.bee_spawn_egg": "मधुमक्खी का जन्म अंडा",
  "item.minecraft.beef": "कच्चा गोमांस",
  "item.minecraft.beetroot": "चुकंदर",
  "item.minecraft.beetroot_seeds": "चुकंदर के बीज",
  "item.minecraft.beetroot_soup": "चुकंदर का रस",
  "item.minecraft.birch_boat": "भूर्ज की नाव",
  "item.minecraft.birch_chest_boat": "बर्च की बक्से वाली नाव",
  "item.minecraft.black_bundle": "काला पोटली",
  "item.minecraft.black_dye": "काला रंजक",
  "item.minecraft.black_harness": "काला हार्नेस",
  "item.minecraft.blade_pottery_shard": "ब्लेड पॉटरी शार्ड",
  "item.minecraft.blade_pottery_sherd": "ब्लेड पॉटरी शेर्ड",
  "item.minecraft.blaze_powder": "ब्लेज़ पाउडर",
  "item.minecraft.blaze_rod": "ज्वाला छड़",
  "item.minecraft.blaze_spawn_egg": "ब्लेज का जन्म अंडा",
  "item.minecraft.blue_bundle": "नीला पोटली",
  "item.minecraft.blue_dye": "नीला रंजक",
  "item.minecraft.blue_egg": "नीला अंडा",
  "item.minecraft.blue_harness": "नीला हार्नेस",
  "item.minecraft.bogged_spawn_egg": "बॉग्ड स्पॉन अंडा",
  "item.minecraft.bolt_armor_trim_smithing_template": "स्मिथिंग टेम्पलेट",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "बोल्ट आर्मर ट्रिम",
  "item.minecraft.bone": "हड्डी",
  "item.minecraft.bone_meal": "हड्डी का चूरा",
  "item.minecraft.book": "पुस्तक",
  "item.minecraft.bordure_indented_banner_pattern": "बॉर्डर इंडेंटेड बैनर पैटर्न",
  "item.minecraft.bow": "धनुष",
  "item.minecraft.bowl": "कटोरी",
  "item.minecraft.bread": "पाव",
  "item.minecraft.breeze_rod": "ब्रीज़ रॉड",
  "item.minecraft.breeze_spawn_egg": "ब्रीज़ स्पॉन अंडा",
  "item.minecraft.brewer_pottery_shard": "ब्रेवर पॉटरी शार्ड",
  "item.minecraft.brewer_pottery_sherd": "ब्रेवर पॉटरी शेर्ड",
  "item.minecraft.brewing_stand": "चल खड़े हो जाओ",
  "item.minecraft.brick": "ईंट",
  "item.minecraft.brown_bundle": "भूरा पोटली",
  "item.minecraft.brown_dye": "भूरा रंजक",
  "item.minecraft.brown_egg": "भूरा अंडा",
  "item.minecraft.brown_harness": "भूरा हार्नेस",
  "item.minecraft.brush": "ब्रश",
  "item.minecraft.bucket": "बाल्टी",
  "item.minecraft.bundle": "गुच्छ",
  "item.minecraft.bundle.empty": "खाली",
  "item.minecraft.bundle.empty.description": "मल्टीपल आइटम्स की मिश्रित स्टैक को रख सकता है",
  "item.minecraft.bundle.full": "भरा",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "मिट्टी के बर्तनों का चूरा जलाएं",
  "item.minecraft.burn_pottery_sherd": "मिट्टी के बर्तनों का चूरा जलाएं",
  "item.minecraft.camel_husk_spawn_egg": "Camel Husk Spawn Egg",
  "item.minecraft.camel_spawn_egg": "ऊंट स्पॉन अंडा",
  "item.minecraft.carrot": "गाजर",
  "item.minecraft.carrot_on_a_stick": "डंडा पर गाजर",
  "item.minecraft.cat_spawn_egg": "बिल्ली का जन्म अंडा",
  "item.minecraft.cauldron": "कड़ाही",
  "item.minecraft.cave_spider_spawn_egg": "गुफावाली मकड़ी का जन्म अंडा",
  "item.minecraft.chainmail_boots": "छल्लों के जूते",
  "item.minecraft.chainmail_chestplate": "छल्लों की छातीकवच",
  "item.minecraft.chainmail_helmet": "छल्लों का टोप",
  "item.minecraft.chainmail_leggings": "छल्लों की टाँगकवच",
  "item.minecraft.charcoal": "काठकोयला",
  "item.minecraft.cherry_boat": "चेरी की नाव",
  "item.minecraft.cherry_chest_boat": "चेरी की बक्से वाली नाव",
  "item.minecraft.chest_minecart": "संदूक के साथ कार्ट",
  "item.minecraft.chicken": "कच्चा मुर्गी",
  "item.minecraft.chicken_spawn_egg": "मुर्गी का जन्म अंडा",
  "item.minecraft.chorus_fruit": "कोरस का फल",
  "item.minecraft.clay_ball": "मृत्तिका का गोला",
  "item.minecraft.clock": "घड़ी",
  "item.minecraft.coal": "कोयला",
  "item.minecraft.coast_armor_trim_smithing_template": "स्मिथिंग खाका",
  "item.minecraft.coast_armor_trim_smithing_template.new": "कोस्ट आर्मर ट्रिम",
  "item.minecraft.cocoa_beans": "कोको बीन्स",
  "item.minecraft.cod": "कच्चा कॉड",
  "item.minecraft.cod_bucket": "सीओडी की बाल्टी",
  "item.minecraft.cod_spawn_egg": "कॉड का जन्म अंडा",
  "item.minecraft.command_block_minecart": "Minecart आदेश ब्लॉक के साथ",
  "item.minecraft.compass": "दिक्सूचक",
  "item.minecraft.cooked_beef": "पक्व गोमांस",
  "item.minecraft.cooked_chicken": "पक्व मुर्गी",
  "item.minecraft.cooked_cod": "पक्क कॉड",
  "item.minecraft.cooked_mutton": "पक्व भेड़",
  "item.minecraft.cooked_porkchop": "पक्व सुअर",
  "item.minecraft.cooked_rabbit": "पक्व खरगोश",
  "item.minecraft.cooked_salmon": "पक्व सैल्मन",
  "item.minecraft.cookie": "बिस्कुट",
  "item.minecraft.copper_axe": "ताँबे की कुल्हाड़ी",
  "item.minecraft.copper_boots": "ताँबे के जूते",
  "item.minecraft.copper_chestplate": "Copper Chestplate",
  "item.minecraft.copper_golem_spawn_egg": "तांबे के गोलेम का जन्म अंडा",
  "item.minecraft.copper_helmet": "Copper Helmet",
  "item.minecraft.copper_hoe": "Copper Hoe",
  "item.minecraft.copper_horse_armor": "तांबे का घोड़े का कवच",
  "item.minecraft.copper_ingot": "तांबे का पिंड",
  "item.minecraft.copper_leggings": "Copper Leggings",
  "item.minecraft.copper_nautilus_armor": "Copper Nautilus Armor",
  "item.minecraft.copper_nugget": "तांबे की डली",
  "item.minecraft.copper_pickaxe": "तांबे की कुदाल",
  "item.minecraft.copper_shovel": "ताँबे का फावड़ा",
  "item.minecraft.copper_spear": "तांबे का भाला",
  "item.minecraft.copper_sword": "ताँबे की तलवार",
  "item.minecraft.cow_spawn_egg": "गाय का जन्म अंडा",
  "item.minecraft.creaking_spawn_egg": "क्रेकिंग स्पॉन अंडा",
  "item.minecraft.creeper_banner_pattern": "झंडा का आकृति",
  "item.minecraft.creeper_banner_pattern.desc": "क्रीपर का अभिकल्प ",
  "item.minecraft.creeper_banner_pattern.new": "क्रीपर चार्ज बैनर पैटर्न",
  "item.minecraft.creeper_spawn_egg": "क्रीपर का जन्म अंडा",
  "item.minecraft.crossbow": "आड़ी कमान",
  "item.minecraft.crossbow.projectile": "प्रक्षेप्य:",
  "item.minecraft.crossbow.projectile.multiple": "प्रक्षिप्ति: %s x %s",
  "item.minecraft.crossbow.projectile.single": "प्रक्षिप्ति: %s",
  "item.minecraft.cyan_bundle": "साइअन बंडल",
  "item.minecraft.cyan_dye": "हरिनील रंजक",
  "item.minecraft.cyan_harness": "सियान हार्नेस",
  "item.minecraft.danger_pottery_shard": "खतरे के बर्तनों का टुकड़ा",
  "item.minecraft.danger_pottery_sherd": "खतरनाक पॉटरी शेर्ड",
  "item.minecraft.dark_oak_boat": "काला बाँज की नाव",
  "item.minecraft.dark_oak_chest_boat": "संदूक वाली डार्क ओक की नाव",
  "item.minecraft.debug_stick": "दोषमार्जन डंडा",
  "item.minecraft.debug_stick.empty": "%s में कोई गुणधर्म नहीं है",
  "item.minecraft.debug_stick.select": "\"%s\" (%s) चयनित किया",
  "item.minecraft.debug_stick.update": "\"%s\" से %s",
  "item.minecraft.diamond": "हीरा",
  "item.minecraft.diamond_axe": "हीरक कुल्हाड़ी",
  "item.minecraft.diamond_boots": "हीरक जूते",
  "item.minecraft.diamond_chestplate": "हीरक छातीकवच",
  "item.minecraft.diamond_helmet": "हीरक टोप",
  "item.minecraft.diamond_hoe": "हीरक कुदाल",
  "item.minecraft.diamond_horse_armor": "डायमंड हार्स कवच",
  "item.minecraft.diamond_leggings": "हीरक टाँगकवच",
  "item.minecraft.diamond_nautilus_armor": "Diamond Nautilus Armor",
  "item.minecraft.diamond_pickaxe": "हीरक गैंती",
  "item.minecraft.diamond_shovel": "हीरक बेलचा",
  "item.minecraft.diamond_spear": "हीरे का भाला",
  "item.minecraft.diamond_sword": "हीरक तलवार",
  "item.minecraft.disc_fragment_5": "डिस्क का टुकड़ा",
  "item.minecraft.disc_fragment_5.desc": "संगीत डिस्क - 5",
  "item.minecraft.dolphin_spawn_egg": "सूंस का जन्म अंडा",
  "item.minecraft.donkey_spawn_egg": "गधा का जन्म अंडा",
  "item.minecraft.dragon_breath": "ड्रैगन की सांस",
  "item.minecraft.dried_kelp": "सूखा सिवार",
  "item.minecraft.drowned_spawn_egg": "डूबा हुआ जॉम्बी का जन्म अंडा",
  "item.minecraft.dune_armor_trim_smithing_template": "स्मिथिंग खाका",
  "item.minecraft.dune_armor_trim_smithing_template.new": "ड्यून आर्मर ट्रिम",
  "item.minecraft.echo_shard": "गूंजता टुकड़ा",
  "item.minecraft.egg": "अंडा",
  "item.minecraft.elder_guardian_spawn_egg": "बड़े संरक्षक अंडे",
  "item.minecraft.elytra": "पक्षवर्म",
  "item.minecraft.emerald": "पन्ना",
  "item.minecraft.enchanted_book": "जादूई पुस्तक",
  "item.minecraft.enchanted_golden_apple": "जादूई सुनहेरा सेब",
  "item.minecraft.end_crystal": "एन्ड स्फटिक",
  "item.minecraft.ender_dragon_spawn_egg": "एंडर ड्रैगन का जन्म अंडा",
  "item.minecraft.ender_eye": "एन्डर की आँख",
  "item.minecraft.ender_pearl": "एन्डर मोती",
  "item.minecraft.enderman_spawn_egg": "एन्डरमैन का जन्म अंडा",
  "item.minecraft.endermite_spawn_egg": "एन्डरमाइट का जन्म अंडा",
  "item.minecraft.evoker_spawn_egg": "जन्म अंडा",
  "item.minecraft.experience_bottle": "बोतल ओ' करामाती",
  "item.minecraft.explorer_pottery_shard": "एक्सप्लोरर पॉटरी शार्ड",
  "item.minecraft.explorer_pottery_sherd": "एक्सप्लोरर पॉटरी शेर्ड",
  "item.minecraft.eye_armor_trim_smithing_template": "स्मिथिंग खाका",
  "item.minecraft.eye_armor_trim_smithing_template.new": "आय आर्मर ट्रिम",
  "item.minecraft.feather": "पंख",
  "item.minecraft.fermented_spider_eye": "किण्वित स्पाइडर आँखों",
  "item.minecraft.field_masoned_banner_pattern": "फील्ड मेसन बैनर पैटर्न",
  "item.minecraft.filled_map": "मानचित्र",
  "item.minecraft.fire_charge": "आग प्रभार",
  "item.minecraft.firework_rocket": "आतिशबाजी रॉकेट",
  "item.minecraft.firework_rocket.flight": "उड़ान की अवधि:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "आतिशबाजी सितारा",
  "item.minecraft.firework_star.black": "काला ",
  "item.minecraft.firework_star.blue": "नीला",
  "item.minecraft.firework_star.brown": "भूरा",
  "item.minecraft.firework_star.custom_color": "कस्टम",
  "item.minecraft.firework_star.cyan": "हरिनील",
  "item.minecraft.firework_star.fade_to": "फीका होना",
  "item.minecraft.firework_star.flicker": "टीमटिमाना",
  "item.minecraft.firework_star.gray": "स्लेटी",
  "item.minecraft.firework_star.green": "हरा",
  "item.minecraft.firework_star.light_blue": "हल्का नीला ",
  "item.minecraft.firework_star.light_gray": "हल्का स्लेटी",
  "item.minecraft.firework_star.lime": "लाइम",
  "item.minecraft.firework_star.magenta": "नीलातिरक्त",
  "item.minecraft.firework_star.orange": "नारंगी",
  "item.minecraft.firework_star.pink": "गुलाबी",
  "item.minecraft.firework_star.purple": "जामुनी",
  "item.minecraft.firework_star.red": "लाल",
  "item.minecraft.firework_star.shape": "अज्ञात आकार",
  "item.minecraft.firework_star.shape.burst": "फूटना",
  "item.minecraft.firework_star.shape.creeper": "क्रीपर के आकार का",
  "item.minecraft.firework_star.shape.large_ball": "बड़ी गेंद",
  "item.minecraft.firework_star.shape.small_ball": "छोटी गेंद",
  "item.minecraft.firework_star.shape.star": "सितारा के आकार का",
  "item.minecraft.firework_star.trail": "निशान",
  "item.minecraft.firework_star.white": "सफेद",
  "item.minecraft.firework_star.yellow": "पिला ",
  "item.minecraft.fishing_rod": "बंसी",
  "item.minecraft.flint": "चकमक पत्थर",
  "item.minecraft.flint_and_steel": "अग्नि का प्रारंभक",
  "item.minecraft.flow_armor_trim_smithing_template": "स्मिथिंग टेम्पलेट",
  "item.minecraft.flow_armor_trim_smithing_template.new": "फ्लो आर्मर ट्रिम",
  "item.minecraft.flow_banner_pattern": "बैनर पैटर्न",
  "item.minecraft.flow_banner_pattern.desc": "फ्लो",
  "item.minecraft.flow_banner_pattern.new": "फ्लो बैनर पैटर्न",
  "item.minecraft.flow_pottery_sherd": "फ्लो पॉटरी शर्ड",
  "item.minecraft.flower_banner_pattern": "झंडा का आकृति",
  "item.minecraft.flower_banner_pattern.desc": "फूल का अभिकल्प",
  "item.minecraft.flower_banner_pattern.new": "फ्लावर चार्ज बैनर पैटर्न",
  "item.minecraft.flower_pot": "गमला",
  "item.minecraft.fox_spawn_egg": "लोमड़ी का जन्म अंडा",
  "item.minecraft.friend_pottery_shard": "दोस्त पॉटरी शार्ड",
  "item.minecraft.friend_pottery_sherd": "दोस्त पॉटरी शेर्ड",
  "item.minecraft.frog_spawn_egg": "मेंढक स्पॉन अंडा",
  "item.minecraft.furnace_minecart": "फर्नेस के साथ कार्ट",
  "item.minecraft.ghast_spawn_egg": "घास्ट का जन्म अंडा",
  "item.minecraft.ghast_tear": "घास्ट का आँसू",
  "item.minecraft.glass_bottle": "काँच की शीशी",
  "item.minecraft.glistering_melon_slice": "चमकीला तरबूज का टुकडा",
  "item.minecraft.globe_banner_pattern": "झंडा का आकृति",
  "item.minecraft.globe_banner_pattern.desc": "ग्लोब",
  "item.minecraft.globe_banner_pattern.new": "ग्लोब बैनर पैटर्न",
  "item.minecraft.glow_berries": "ग्लो बेरी",
  "item.minecraft.glow_ink_sac": "ग्लो स्याही का पुटला",
  "item.minecraft.glow_item_frame": "ग्लो आईटम फ्रेम",
  "item.minecraft.glow_squid_spawn_egg": "ग्लो स्क्विड के अंडे",
  "item.minecraft.glowstone_dust": "चमक स्टोन डस्ट",
  "item.minecraft.goat_horn": "बकरी का सींग",
  "item.minecraft.goat_spawn_egg": "बकरी का जन्म अंडा",
  "item.minecraft.gold_ingot": "स्वर्ण पिंड",
  "item.minecraft.gold_nugget": "सोने का डला",
  "item.minecraft.golden_apple": "सोने का सेब",
  "item.minecraft.golden_axe": "सोने की कुल्हाड़ी",
  "item.minecraft.golden_boots": "सोने के जूते",
  "item.minecraft.golden_carrot": "सोने का गाजर",
  "item.minecraft.golden_chestplate": "सोने की छातीकवच",
  "item.minecraft.golden_helmet": "सोने का टोप",
  "item.minecraft.golden_hoe": "सोने की कुदाल",
  "item.minecraft.golden_horse_armor": "सोने का घोङे का कवच",
  "item.minecraft.golden_leggings": "सौने की टाँगकवच",
  "item.minecraft.golden_nautilus_armor": "Golden Nautilus Armor",
  "item.minecraft.golden_pickaxe": "सोने की गैंती",
  "item.minecraft.golden_shovel": "सोने का बेलचा",
  "item.minecraft.golden_spear": "सोने का भाला",
  "item.minecraft.golden_sword": "सोने की तलवार",
  "item.minecraft.gray_bundle": "स्लेटी पोटली",
  "item.minecraft.gray_dye": "स्लेटी रंजक",
  "item.minecraft.gray_harness": "धूसर हार्नेस",
  "item.minecraft.green_bundle": "हरा पोटली",
  "item.minecraft.green_dye": "हरा रंजक",
  "item.minecraft.green_harness": "हरा हार्नेस",
  "item.minecraft.guardian_spawn_egg": "बड़े संरक्षक अंडे",
  "item.minecraft.gunpowder": "बारूद",
  "item.minecraft.guster_banner_pattern": "ध्वज नमूना",
  "item.minecraft.guster_banner_pattern.desc": "गस्टर",
  "item.minecraft.guster_banner_pattern.new": "गस्टर बैनर पैटर्न",
  "item.minecraft.guster_pottery_sherd": "गस्टर पॉटरी शर्ड",
  "item.minecraft.happy_ghast_spawn_egg": "खुश घास्ट का जनम अंडा",
  "item.minecraft.harness": "दोहन",
  "item.minecraft.heart_of_the_sea": "समुद्र का हृदय",
  "item.minecraft.heart_pottery_shard": "दिल पॉटरी शेर्ड",
  "item.minecraft.heart_pottery_sherd": "दिल पॉटरी शेर्ड",
  "item.minecraft.heartbreak_pottery_shard": "टूटा दिल पॉटरी शार्ड",
  "item.minecraft.heartbreak_pottery_sherd": "टूटा दिल पॉटरी शेर्ड",
  "item.minecraft.hoglin_spawn_egg": "हॉग्लीन का जन्म अंडा",
  "item.minecraft.honey_bottle": "शहद की बोतल",
  "item.minecraft.honeycomb": "मधुकोष",
  "item.minecraft.hopper_minecart": "हूपर के साथ Minecart",
  "item.minecraft.horse_spawn_egg": "घोड़ा जन्म अंडा",
  "item.minecraft.host_armor_trim_smithing_template": "स्मिथिंग खाका",
  "item.minecraft.host_armor_trim_smithing_template.new": "होस्ट आर्मर ट्रिम",
  "item.minecraft.howl_pottery_shard": "हॉवेल पॉटरी शार्ड",
  "item.minecraft.howl_pottery_sherd": "हॉवेल पॉटरी शेर्ड",
  "item.minecraft.husk_spawn_egg": "सूखा जॉम्बी जन्म अंडा",
  "item.minecraft.ink_sac": "स्याही की बोरी",
  "item.minecraft.iron_axe": "लौह कुल्हाड़ी",
  "item.minecraft.iron_boots": "लौह जूते",
  "item.minecraft.iron_chestplate": "लौह छातीकवच",
  "item.minecraft.iron_golem_spawn_egg": "लोहे का गोलेम का जन्म अंडा",
  "item.minecraft.iron_helmet": "लौह टोप",
  "item.minecraft.iron_hoe": "लौह कुदाल",
  "item.minecraft.iron_horse_armor": "लौह हार्स कवच",
  "item.minecraft.iron_ingot": "लौह शिलिका",
  "item.minecraft.iron_leggings": "लौह टाँगकवच",
  "item.minecraft.iron_nautilus_armor": "Iron Nautilus Armor",
  "item.minecraft.iron_nugget": "लोहे का डला",
  "item.minecraft.iron_pickaxe": "लौह गैंती",
  "item.minecraft.iron_shovel": "लौह बेलचा",
  "item.minecraft.iron_spear": "लोहे का भाला",
  "item.minecraft.iron_sword": "लोहे की तलवार",
  "item.minecraft.item_frame": "आइटम सीमा",
  "item.minecraft.jungle_boat": "जंगल की नाव",
  "item.minecraft.jungle_chest_boat": "संदूक वाली जंगली नाव",
  "item.minecraft.knowledge_book": "ज्ञान पुस्तक",
  "item.minecraft.lapis_lazuli": "लापीस लाजुली",
  "item.minecraft.lava_bucket": "लावा की बाल्टी",
  "item.minecraft.lead": "डोरी",
  "item.minecraft.leather": "चमड़ा",
  "item.minecraft.leather_boots": "चमड़े के जूते",
  "item.minecraft.leather_chestplate": "चमड़े की छातीकवच",
  "item.minecraft.leather_helmet": "चमड़े का टोप",
  "item.minecraft.leather_horse_armor": "चमड़े का घोड़ा कवच",
  "item.minecraft.leather_leggings": "चमड़े की टाँगकवच",
  "item.minecraft.light_blue_bundle": "हल्का नीला गठ्ठा",
  "item.minecraft.light_blue_dye": "हल्का नीला रंजक",
  "item.minecraft.light_blue_harness": "हल्का नीला हार्नेस",
  "item.minecraft.light_gray_bundle": "हल्का धूसर बंडल",
  "item.minecraft.light_gray_dye": "हल्का स्लेटी रंजक",
  "item.minecraft.light_gray_harness": "हल्का स्लेटी हार्नेस",
  "item.minecraft.lime_bundle": "चूना बंडल",
  "item.minecraft.lime_dye": "लाइम रंजक",
  "item.minecraft.lime_harness": "लाइम हार्नेस",
  "item.minecraft.lingering_potion": "लिंगरिंग औषधि",
  "item.minecraft.lingering_potion.effect.awkward": "अक्वार्ड लिंगिंग पॉशन",
  "item.minecraft.lingering_potion.effect.empty": "लिन्दरिंग यून्राक्टेबल औषधि",
  "item.minecraft.lingering_potion.effect.fire_resistance": "अग्नि प्रतिरोध के लिंगभेद की औषधि",
  "item.minecraft.lingering_potion.effect.harming": "हानिकारक की लिंगनिंग औषधि",
  "item.minecraft.lingering_potion.effect.healing": "हीलिंग के लिन्फरिंग पोशन",
  "item.minecraft.lingering_potion.effect.infested": "संकट का लटकता हुआ औषधि",
  "item.minecraft.lingering_potion.effect.invisibility": "अदर्शन के लिन्फरिंग पोशन",
  "item.minecraft.lingering_potion.effect.leaping": "लीपिंग का लिन्फरिंग पोशन",
  "item.minecraft.lingering_potion.effect.levitation": "लेवेनिंग पोशन ऑफ लेवेशन",
  "item.minecraft.lingering_potion.effect.luck": "लकीरिंग पॉशन ऑफ़ लक",
  "item.minecraft.lingering_potion.effect.mundane": "मुंडेन लिंगरिंग पॉशन",
  "item.minecraft.lingering_potion.effect.night_vision": "लिविंगरिंग पॉशन ऑफ नाइट विजन",
  "item.minecraft.lingering_potion.effect.oozing": "चिपचिपाहट का लटकता हुआ औषधि",
  "item.minecraft.lingering_potion.effect.poison": "विषाक्तता की लिंगभेद की औषधि",
  "item.minecraft.lingering_potion.effect.regeneration": "पुनर्जन्म के लिन्गेरिंग पोशन",
  "item.minecraft.lingering_potion.effect.slow_falling": "धीमी गति से गिरने की भावना",
  "item.minecraft.lingering_potion.effect.slowness": "धीमेपन का लिन्फरिंग पोशन",
  "item.minecraft.lingering_potion.effect.strength": "ताकत का लिंगांतरण औषधि",
  "item.minecraft.lingering_potion.effect.swiftness": "झुकाव की लिंगभेद की औषधि",
  "item.minecraft.lingering_potion.effect.thick": "मोटी लिंगरिंग औषधि",
  "item.minecraft.lingering_potion.effect.turtle_master": "कछुए मास्टर की भाषाई औषधि",
  "item.minecraft.lingering_potion.effect.water": "लिटरिंग वॉटर बॉटल",
  "item.minecraft.lingering_potion.effect.water_breathing": "पानी श्वास का लेशरिंग पोशन",
  "item.minecraft.lingering_potion.effect.weakness": "कमजोरी के लिन्फरिंग पोशन",
  "item.minecraft.lingering_potion.effect.weaving": "बुनाई का लटकता हुआ औषधि",
  "item.minecraft.lingering_potion.effect.wind_charged": "हवा चार्जिंग का लटकता हुआ औषधि",
  "item.minecraft.llama_spawn_egg": "लामा का जन्म अंडा",
  "item.minecraft.lodestone_compass": "चुंबक पत्थर का दिक्सूचक",
  "item.minecraft.mace": "गदा",
  "item.minecraft.magenta_bundle": "मेजेंटा बंडल",
  "item.minecraft.magenta_dye": "नीलातिरक्त रंजक",
  "item.minecraft.magenta_harness": "मैजेंटा हार्नेस",
  "item.minecraft.magma_cream": "लावा क्रीम",
  "item.minecraft.magma_cube_spawn_egg": "मैग्मा घन जन्म अंडा",
  "item.minecraft.mangrove_boat": "मैंग्रोव बोट",
  "item.minecraft.mangrove_chest_boat": "संदूक वाली सदाबहार नाव",
  "item.minecraft.map": "खाली मानचित्र",
  "item.minecraft.melon_seeds": "तरबूज के बीज",
  "item.minecraft.melon_slice": "तरबूज का टुकड़ा",
  "item.minecraft.milk_bucket": "दूध की बाल्टी",
  "item.minecraft.minecart": "गाड़ी",
  "item.minecraft.miner_pottery_shard": "माइनर पॉटरी शार्ड",
  "item.minecraft.miner_pottery_sherd": "माइनर पॉटरी शेर्ड",
  "item.minecraft.mojang_banner_pattern": "झंडा का आकृति",
  "item.minecraft.mojang_banner_pattern.desc": "चीज",
  "item.minecraft.mojang_banner_pattern.new": "चीज़ ध्वज पैटर्न",
  "item.minecraft.mooshroom_spawn_egg": "मूशरूम का जन्म अंडा",
  "item.minecraft.mourner_pottery_shard": "शोकाकुल मिट्टी के बर्तनों का टुकड़ा",
  "item.minecraft.mourner_pottery_sherd": "शोकाकुल मिट्टी के बर्तनों का शेर",
  "item.minecraft.mule_spawn_egg": "खच्चर जन्म अंडा",
  "item.minecraft.mushroom_stew": "मशरूम स्टू",
  "item.minecraft.music_disc_11": "संगीत चक्रिका",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "संगीत चक्रिका",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "संगीत चक्रिका",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "संगीत चक्रिका",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "संगीत चक्रिका",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "संगीत चक्रिका",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "संगीत चक्रिका",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "संगीत चक्रिका",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Music Box)",
  "item.minecraft.music_disc_far": "संगीत चक्रिका",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "संगीत चक्रिका",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "संगीत चक्रिका",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "संगीत चक्रिका",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "संगीत चक्रिका",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "संगीत चक्रिका",
  "item.minecraft.music_disc_pigstep.desc": "लेना रैन - Pigstep",
  "item.minecraft.music_disc_precipice": "संगीत चक्रिका",
  "item.minecraft.music_disc_precipice.desc": "एरोन चेरोफ - प्रीसिपाइस",
  "item.minecraft.music_disc_relic": "संगीत डिस्क",
  "item.minecraft.music_disc_relic.desc": "हारून चेरोफ़ - अवशेष",
  "item.minecraft.music_disc_stal": "संगीत चक्रिका",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "संगीत चक्रिका",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "म्यूजिक डिस्क",
  "item.minecraft.music_disc_tears.desc": "एमोस रॉडी - टियर्स",
  "item.minecraft.music_disc_wait": "संगीत चक्रिका",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "संगीत चक्रिका",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "कच्चा मटन",
  "item.minecraft.name_tag": "नाम टैग",
  "item.minecraft.nautilus_shell": "नॉटिलस शैल",
  "item.minecraft.nautilus_spawn_egg": "Nautilus Spawn Egg",
  "item.minecraft.nether_brick": "नेदर ईंट",
  "item.minecraft.nether_star": "नेदर सितारा",
  "item.minecraft.nether_wart": "निचली गांठ",
  "item.minecraft.netherite_axe": "नेदराइट की कुल्हाड़ी",
  "item.minecraft.netherite_boots": "नेदराइट के जूते",
  "item.minecraft.netherite_chestplate": "नेदराइट की छातीकवच",
  "item.minecraft.netherite_helmet": "नेदराइट का टोप",
  "item.minecraft.netherite_hoe": "नेदराइट का कुदाल",
  "item.minecraft.netherite_horse_armor": "Netherite Horse Armor",
  "item.minecraft.netherite_ingot": "नेदराइट का पिंड",
  "item.minecraft.netherite_leggings": "नेदराइट की टाँगकवच",
  "item.minecraft.netherite_nautilus_armor": "Netherite Nautilus Armor",
  "item.minecraft.netherite_pickaxe": "नेदराइट की कुदाली",
  "item.minecraft.netherite_scrap": "नेदराइट की टुकड़ी",
  "item.minecraft.netherite_shovel": "नेदराइट का फावड़ा",
  "item.minecraft.netherite_spear": "Netherite Spear",
  "item.minecraft.netherite_sword": "नेदराइट की तलवार",
  "item.minecraft.netherite_upgrade_smithing_template": "स्मिथिंग खाका",
  "item.minecraft.netherite_upgrade_smithing_template.new": "नेदराइट उन्नयन",
  "item.minecraft.oak_boat": "बाँज की नाव",
  "item.minecraft.oak_chest_boat": "बलूत की बक्से वाली नाव",
  "item.minecraft.ocelot_spawn_egg": "ऑसलॉट का जन्म अंडा",
  "item.minecraft.ominous_bottle": "भयावह बोतल",
  "item.minecraft.ominous_trial_key": "भयावह परीक्षण कुंजी",
  "item.minecraft.orange_bundle": "नारंगी पोटली",
  "item.minecraft.orange_dye": "नारंगी रंजक",
  "item.minecraft.orange_harness": "नारंगी दोहन",
  "item.minecraft.painting": "चित्र",
  "item.minecraft.pale_oak_boat": "फीका बलूत नाव",
  "item.minecraft.pale_oak_chest_boat": "फीकी बलूत की बक्से वाली नाव",
  "item.minecraft.panda_spawn_egg": "पाँडा का जन्म अंडा",
  "item.minecraft.paper": "कागज",
  "item.minecraft.parched_spawn_egg": "Parched Spawn Egg",
  "item.minecraft.parrot_spawn_egg": "तोता का जन्म अंडा",
  "item.minecraft.phantom_membrane": "प्रेत झिल्ली",
  "item.minecraft.phantom_spawn_egg": "घोस्ट जन्म अंडा",
  "item.minecraft.pig_spawn_egg": "सूअर का जन्म अंडा",
  "item.minecraft.piglin_banner_pattern": "झंडा का आकृति",
  "item.minecraft.piglin_banner_pattern.desc": "थूथन",
  "item.minecraft.piglin_banner_pattern.new": "नाक ध्वज पैटर्न",
  "item.minecraft.piglin_brute_spawn_egg": "निष्ठुर पिगलीन का जन्म अंडा",
  "item.minecraft.piglin_spawn_egg": "पिगलीन का जन्म अंडा",
  "item.minecraft.pillager_spawn_egg": "लुटेरा का जन्म अंडा",
  "item.minecraft.pink_bundle": "गुलाबी पोटली",
  "item.minecraft.pink_dye": "गुलाबी रंजक",
  "item.minecraft.pink_harness": "गुलाबी दोहन",
  "item.minecraft.pitcher_plant": "मटका संयंत्र",
  "item.minecraft.pitcher_pod": "पिचर पॉड",
  "item.minecraft.plenty_pottery_shard": "खूब मिट्टी के बर्तन",
  "item.minecraft.plenty_pottery_sherd": "खूब मिट्टी के बर्तन",
  "item.minecraft.poisonous_potato": "जहरीला आलू",
  "item.minecraft.polar_bear_spawn_egg": "ध्रुवीय भालू का जन्म अंडा",
  "item.minecraft.popped_chorus_fruit": "Popped कोरस फल",
  "item.minecraft.porkchop": "कच्चा सुअर",
  "item.minecraft.potato": "आलू",
  "item.minecraft.potion": "खुराक",
  "item.minecraft.potion.effect.awkward": "अजीब औषधि",
  "item.minecraft.potion.effect.empty": "अनौचेंबल पोशन",
  "item.minecraft.potion.effect.fire_resistance": "आग प्रतिरोध की औषधि",
  "item.minecraft.potion.effect.harming": "चोट की औषधि",
  "item.minecraft.potion.effect.healing": "उपचार की औषधि",
  "item.minecraft.potion.effect.infested": "संकट की औषधि",
  "item.minecraft.potion.effect.invisibility": "अदर्शन औषधि",
  "item.minecraft.potion.effect.leaping": "लांघनेवाला औषधि",
  "item.minecraft.potion.effect.levitation": "उत्तोलन की औषधि",
  "item.minecraft.potion.effect.luck": "किस्मत की औषधि",
  "item.minecraft.potion.effect.mundane": "सांसारिक औषधि",
  "item.minecraft.potion.effect.night_vision": "रात दृष्टि की औषधि",
  "item.minecraft.potion.effect.oozing": "चिपचिपाहट की औषधि",
  "item.minecraft.potion.effect.poison": "ज़हर की औषधि",
  "item.minecraft.potion.effect.regeneration": "पुनर्जनन औषधि",
  "item.minecraft.potion.effect.slow_falling": "धीमे से गिरना",
  "item.minecraft.potion.effect.slowness": "सुस्ती की औषधि",
  "item.minecraft.potion.effect.strength": "शक्ति की औषधि",
  "item.minecraft.potion.effect.swiftness": "तेज़ी के औषधि",
  "item.minecraft.potion.effect.thick": "मोटी औषधि",
  "item.minecraft.potion.effect.turtle_master": "कछुए मास्टर की औषधि",
  "item.minecraft.potion.effect.water": "पानी की शीशी",
  "item.minecraft.potion.effect.water_breathing": "जल श्वास की औषधि",
  "item.minecraft.potion.effect.weakness": "कमजोरी की औषधि",
  "item.minecraft.potion.effect.weaving": "बुनाई की औषधि",
  "item.minecraft.potion.effect.wind_charged": "हवा चार्जिंग की औषधि",
  "item.minecraft.pottery_shard_archer": "आर्चर पॉटरी शार्ड",
  "item.minecraft.pottery_shard_arms_up": "आर्म्स अप पॉटरी शार्ड",
  "item.minecraft.pottery_shard_prize": "पुरस्कार मिट्टी के बर्तनों का टुकड़ा",
  "item.minecraft.pottery_shard_skull": "खोपड़ी मिट्टी के बर्तनों का टुकड़ा",
  "item.minecraft.powder_snow_bucket": "पीसेे हुए बर्फ की बाल्टी",
  "item.minecraft.prismarine_crystals": "प्रिज्मरीन का क्रिस्टल",
  "item.minecraft.prismarine_shard": "प्रिज्मरीन का टुकड़ा",
  "item.minecraft.prize_pottery_shard": "पुरस्कार मिट्टी के बर्तनों का टुकड़ा",
  "item.minecraft.prize_pottery_sherd": "पुरस्कार पॉटरी शेर्ड",
  "item.minecraft.pufferfish": "आध्मादतक मछली",
  "item.minecraft.pufferfish_bucket": "आध्मादतक मछली की बाल्टी",
  "item.minecraft.pufferfish_spawn_egg": "आध्मादतक मछली का जन्म अंडा",
  "item.minecraft.pumpkin_pie": "कद्दू पाई",
  "item.minecraft.pumpkin_seeds": "कद्दू के बीज",
  "item.minecraft.purple_bundle": "बैंगनी बंडल",
  "item.minecraft.purple_dye": "जामुनी रंजक",
  "item.minecraft.purple_harness": "बैंगनी दोहन",
  "item.minecraft.quartz": "नेदर स्फटिक",
  "item.minecraft.rabbit": "कच्चा खरगोश",
  "item.minecraft.rabbit_foot": "खरगोश की पैर",
  "item.minecraft.rabbit_hide": "खरगोश की खाल",
  "item.minecraft.rabbit_spawn_egg": "खरगोश का जन्म अंडा",
  "item.minecraft.rabbit_stew": "खरगोश का खिचड़ी",
  "item.minecraft.raiser_armor_trim_smithing_template": "स्मिथिंग खाका",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "राइज़र आर्मर ट्रिम",
  "item.minecraft.ravager_spawn_egg": "ग्रामबासी के अंडे",
  "item.minecraft.raw_copper": "कच्चा तांबा",
  "item.minecraft.raw_gold": "कच्चा सोना",
  "item.minecraft.raw_iron": "कच्चा लोहा",
  "item.minecraft.recovery_compass": "रिकवरी कम्पास",
  "item.minecraft.red_bundle": "लाल पोटली",
  "item.minecraft.red_dye": "लाल रंजक",
  "item.minecraft.red_harness": "लाल दोहन",
  "item.minecraft.redstone": "रेडस्टोन का चूरा",
  "item.minecraft.resin_brick": "राल ईंट",
  "item.minecraft.resin_clump": "रेजिन का गुच्छा",
  "item.minecraft.rib_armor_trim_smithing_template": "स्मिथिंग खाका",
  "item.minecraft.rib_armor_trim_smithing_template.new": "रिब आर्मर ट्रिम",
  "item.minecraft.rotten_flesh": "सड़े हुए माँस",
  "item.minecraft.saddle": "काठी",
  "item.minecraft.salmon": "कच्चा सैल्मन",
  "item.minecraft.salmon_bucket": "सॅल्मन की बाल्टी",
  "item.minecraft.salmon_spawn_egg": "सैल्मन का जन्म अंडा",
  "item.minecraft.scrape_pottery_sherd": "खुरचने का मटकी टुकड़ा",
  "item.minecraft.scute": "स्कूट",
  "item.minecraft.sentry_armor_trim_smithing_template": "स्मिथिंग खाका",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "सेंटीरी आर्मर ट्रिम",
  "item.minecraft.shaper_armor_trim_smithing_template": "स्मिथिंग खाका",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "शेपर्स आर्मर ट्रिम",
  "item.minecraft.sheaf_pottery_shard": "शेफ पॉटरी शार्ड",
  "item.minecraft.sheaf_pottery_sherd": "शेफ पॉटरी शेड",
  "item.minecraft.shears": "कैंची",
  "item.minecraft.sheep_spawn_egg": "भेड़ का जन्म अंडा",
  "item.minecraft.shelter_pottery_shard": "आश्रय बर्तनों का टुकड़ा",
  "item.minecraft.shelter_pottery_sherd": "आश्रय मिट्टी के बर्तनों का शेर",
  "item.minecraft.shield": "ढाल",
  "item.minecraft.shield.black": "काली ढाल",
  "item.minecraft.shield.blue": "नीली ढाल",
  "item.minecraft.shield.brown": "भूरी ढाल",
  "item.minecraft.shield.cyan": "हरिनील ढाल",
  "item.minecraft.shield.gray": "स्लेटी ढाल",
  "item.minecraft.shield.green": "हरी ढाल",
  "item.minecraft.shield.light_blue": "हल्की नीली ढाल",
  "item.minecraft.shield.light_gray": "हल्की स्लेटी ढाल",
  "item.minecraft.shield.lime": "लाइम ढाल",
  "item.minecraft.shield.magenta": "नीलातिरक्त ढाल",
  "item.minecraft.shield.orange": "नारंगी ढाल",
  "item.minecraft.shield.pink": "गुलाबी ढाल",
  "item.minecraft.shield.purple": "जामुनी ढाल",
  "item.minecraft.shield.red": "लाल ढाल",
  "item.minecraft.shield.white": "सफेद ढाल",
  "item.minecraft.shield.yellow": "पीली ढाल",
  "item.minecraft.shulker_shell": "शल्कर का खोल",
  "item.minecraft.shulker_spawn_egg": "शल्कर का जन्म अंडा",
  "item.minecraft.sign": "संकेत",
  "item.minecraft.silence_armor_trim_smithing_template": "स्मिथिंग खाका",
  "item.minecraft.silence_armor_trim_smithing_template.new": "मौन आर्मर ट्रिम",
  "item.minecraft.silverfish_spawn_egg": "सिल्वरफिश के अंडे",
  "item.minecraft.skeleton_horse_spawn_egg": "कंकाल घोड़े के अंडे",
  "item.minecraft.skeleton_spawn_egg": "कंकाल के अंडे",
  "item.minecraft.skull_banner_pattern": "झंडा का आकृति",
  "item.minecraft.skull_banner_pattern.desc": "खोपड़ी का अभिकल्प",
  "item.minecraft.skull_banner_pattern.new": "खोपड़ी चार्ज ध्वज पैटर्न",
  "item.minecraft.skull_pottery_shard": "खोपड़ी मिट्टी के बर्तनों का टुकड़ा",
  "item.minecraft.skull_pottery_sherd": "खोपड़ी के बर्तनों का शेर",
  "item.minecraft.slime_ball": "कीचड़ बॉल",
  "item.minecraft.slime_spawn_egg": "स्लाइम का जन्म अंडा",
  "item.minecraft.smithing_template": "स्मिथिंग टेम्पलेट",
  "item.minecraft.smithing_template.applies_to": "पर लागू होता है:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "पिंड या क्रिस्टल जोड़ें",
  "item.minecraft.smithing_template.armor_trim.applies_to": "कवच",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "कवच का एक टुकड़ा जोड़ें",
  "item.minecraft.smithing_template.armor_trim.ingredients": "सिल्लियां और क्रिस्टल",
  "item.minecraft.smithing_template.ingredients": "अवयव:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "नेथेराइट पिंड जोड़ें",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "हीरा उपकरण",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "हीरा कवच, हथियार या उपकरण जोड़ें",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "नेथेराइट भूल गया",
  "item.minecraft.smithing_template.upgrade": "उन्नत करना: ",
  "item.minecraft.sniffer_spawn_egg": "स्निफर स्पॉन एग",
  "item.minecraft.snort_pottery_shard": "सूंघना मिट्टी के बर्तनों का टुकड़ा",
  "item.minecraft.snort_pottery_sherd": "स्नॉर्ट पॉटरी शेर्ड",
  "item.minecraft.snout_armor_trim_smithing_template": "स्मिथिंग खाका",
  "item.minecraft.snout_armor_trim_smithing_template.new": "नाक आर्मर ट्रिम",
  "item.minecraft.snow_golem_spawn_egg": "हिम गोलेम का जन्म अंडा",
  "item.minecraft.snowball": "बर्फ का गोला",
  "item.minecraft.spectral_arrow": "स्पेक्ट्रल एरो",
  "item.minecraft.spider_eye": "मकड़ी की आँख",
  "item.minecraft.spider_spawn_egg": "मकड़ी का जन्म अंडा",
  "item.minecraft.spire_armor_trim_smithing_template": "स्मिथिंग खाका",
  "item.minecraft.spire_armor_trim_smithing_template.new": "स्पायर आर्मर ट्रिम",
  "item.minecraft.splash_potion": "स्पलैश पोशन",
  "item.minecraft.splash_potion.effect.awkward": "अजीब स्पलैश औषधि",
  "item.minecraft.splash_potion.effect.empty": "स्पलैश अनूर््वनेबल पोशन",
  "item.minecraft.splash_potion.effect.fire_resistance": "आग प्रतिरोध की स्पलैश औषधि",
  "item.minecraft.splash_potion.effect.harming": "चोट की स्प्लिश औषधि",
  "item.minecraft.splash_potion.effect.healing": "उपचार की स्प्लिश औषधि",
  "item.minecraft.splash_potion.effect.infested": "संकट की स्प्लैश औषधि",
  "item.minecraft.splash_potion.effect.invisibility": "अदर्शन के स्पलैश औषधि",
  "item.minecraft.splash_potion.effect.leaping": "उछाल की स्पलैश औषधि",
  "item.minecraft.splash_potion.effect.levitation": "लेवीय की स्पलैश पोशन",
  "item.minecraft.splash_potion.effect.luck": "भाग्य की स्पलैश औषधि",
  "item.minecraft.splash_potion.effect.mundane": "सांसारिक स्पलैश औषधि",
  "item.minecraft.splash_potion.effect.night_vision": "रात दृष्टि के स्पलैश औषधि",
  "item.minecraft.splash_potion.effect.oozing": "चिपचिपाहट की स्प्लैश औषधि",
  "item.minecraft.splash_potion.effect.poison": "जहर की स्प्लिश औषधि",
  "item.minecraft.splash_potion.effect.regeneration": "पुनर्जनन की स्प्लिश औषधि",
  "item.minecraft.splash_potion.effect.slow_falling": "धीमी गति से गिरने की स्प्लैश औषधि",
  "item.minecraft.splash_potion.effect.slowness": "सुस्ती की औषधि स्प्लिश",
  "item.minecraft.splash_potion.effect.strength": "शक्ति की स्प्लिश औषधि",
  "item.minecraft.splash_potion.effect.swiftness": "स्प्लिश पोशन ऑफ़ स्विफ्टनेस",
  "item.minecraft.splash_potion.effect.thick": "मोटी स्पलैश औषधि",
  "item.minecraft.splash_potion.effect.turtle_master": "कछुए मास्टर की मछली",
  "item.minecraft.splash_potion.effect.water": "स्पलैश पानी की बोतल",
  "item.minecraft.splash_potion.effect.water_breathing": "स्प्लिश औषधि पानी सांस लेने की",
  "item.minecraft.splash_potion.effect.weakness": "कमजोरी की स्पलैश औषधि",
  "item.minecraft.splash_potion.effect.weaving": "उछाल की स्पलैश औषधि",
  "item.minecraft.splash_potion.effect.wind_charged": "चोट की स्प्लिश औषधि",
  "item.minecraft.spruce_boat": "प्रसरल की नाव",
  "item.minecraft.spruce_chest_boat": "प्रसरल की बक्से वाली नाव",
  "item.minecraft.spyglass": "दूरदर्शक यंत्र",
  "item.minecraft.squid_spawn_egg": "स्क्वीड के अंडे",
  "item.minecraft.stick": "डंडा",
  "item.minecraft.stone_axe": "पत्यक की कुल्हाड़ी",
  "item.minecraft.stone_hoe": "पत्थर की कुदाल",
  "item.minecraft.stone_pickaxe": "पत्थर की गैंती",
  "item.minecraft.stone_shovel": "पत्थर का बेलचा",
  "item.minecraft.stone_spear": "पत्थर का भाला",
  "item.minecraft.stone_sword": "पत्थर की तलवार",
  "item.minecraft.stray_spawn_egg": "जानबर का जन्म अंडा",
  "item.minecraft.strider_spawn_egg": "स्ट्राईडर का जन्म अंडा",
  "item.minecraft.string": "धागा",
  "item.minecraft.sugar": "चीनी",
  "item.minecraft.suspicious_stew": "संदिग्ध शोरबा",
  "item.minecraft.sweet_berries": "मीठे फल",
  "item.minecraft.tadpole_bucket": "टैडपोल की बाल्टी",
  "item.minecraft.tadpole_spawn_egg": "टैडपोल स्पॉन एग",
  "item.minecraft.tide_armor_trim_smithing_template": "स्मिथिंग खाका",
  "item.minecraft.tide_armor_trim_smithing_template.new": "ज्वार आर्मर ट्रिम",
  "item.minecraft.tipped_arrow": "टिप किए गए तीर",
  "item.minecraft.tipped_arrow.effect.awkward": "टिप किए गए तीर",
  "item.minecraft.tipped_arrow.effect.empty": "अनवरनीय इत्तला दे दी एरो",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "आग प्रतिरोध के तीर",
  "item.minecraft.tipped_arrow.effect.harming": "क्षति पहुंचाने के तीर",
  "item.minecraft.tipped_arrow.effect.healing": "निरंतर शक्ति प्रदान करने वाले तीर",
  "item.minecraft.tipped_arrow.effect.infested": "संकट का बाण",
  "item.minecraft.tipped_arrow.effect.invisibility": "अद्रश्य तीर",
  "item.minecraft.tipped_arrow.effect.leaping": "लीपिंग का तीर",
  "item.minecraft.tipped_arrow.effect.levitation": "पुनर्जनन के तीर",
  "item.minecraft.tipped_arrow.effect.luck": "भाग्य का तीर",
  "item.minecraft.tipped_arrow.effect.mundane": "टिप किए गए तीर",
  "item.minecraft.tipped_arrow.effect.night_vision": "रात दृष्टि के तीर",
  "item.minecraft.tipped_arrow.effect.oozing": "चिपचिपाहट का बाण",
  "item.minecraft.tipped_arrow.effect.poison": "जहर के तीर",
  "item.minecraft.tipped_arrow.effect.regeneration": "पुनर्जनन करने के तीर",
  "item.minecraft.tipped_arrow.effect.slow_falling": "धीमी गति से गिरना",
  "item.minecraft.tipped_arrow.effect.slowness": "धीमा करने के तीर",
  "item.minecraft.tipped_arrow.effect.strength": "शक्ति के तीर",
  "item.minecraft.tipped_arrow.effect.swiftness": "स्विफ्ट का तीर",
  "item.minecraft.tipped_arrow.effect.thick": "टिप किए गए तीर",
  "item.minecraft.tipped_arrow.effect.turtle_master": "कछुआ मास्टर का तीर",
  "item.minecraft.tipped_arrow.effect.water": "छिलके का तीर",
  "item.minecraft.tipped_arrow.effect.water_breathing": "पानी में साँस लेने के तीर",
  "item.minecraft.tipped_arrow.effect.weakness": "कमजोरी करने के तीर",
  "item.minecraft.tipped_arrow.effect.weaving": "बुनाई का बाण",
  "item.minecraft.tipped_arrow.effect.wind_charged": "हवा चार्जिंग का बाण",
  "item.minecraft.tnt_minecart": "गाड़ी में टीएनटी",
  "item.minecraft.torchflower_seeds": "टार्चफ्लॉवर के बीज",
  "item.minecraft.totem_of_undying": "अमर की कुलदेवता",
  "item.minecraft.trader_llama_spawn_egg": "ट्रेडर लामा",
  "item.minecraft.trial_key": "परीक्षण चाबी",
  "item.minecraft.trident": "त्रिशूल",
  "item.minecraft.tropical_fish": "उष्ण मछ्ली",
  "item.minecraft.tropical_fish_bucket": "उष्णकटिबंधीय मछली की बाल्टी",
  "item.minecraft.tropical_fish_spawn_egg": "उष्णकटिबंधीय मछली के अंडे",
  "item.minecraft.turtle_helmet": "कछुआ का खोल",
  "item.minecraft.turtle_scute": "कछुआ का चोइंटा",
  "item.minecraft.turtle_spawn_egg": "कछुआ का जन्म अंडा",
  "item.minecraft.vex_armor_trim_smithing_template": "स्मिथिंग खाका",
  "item.minecraft.vex_armor_trim_smithing_template.new": "वेक्स आर्मर ट्रिम",
  "item.minecraft.vex_spawn_egg": "वेक्स स्पॉन एग",
  "item.minecraft.villager_spawn_egg": "ग्रामवासी के अंडे",
  "item.minecraft.vindicator_spawn_egg": "ग्रामवासी के एग",
  "item.minecraft.wandering_trader_spawn_egg": "पर्यटक व्यापारी का जन्म अंड़ा",
  "item.minecraft.ward_armor_trim_smithing_template": "स्मिथिंग खाका",
  "item.minecraft.ward_armor_trim_smithing_template.new": "वार्ड आर्मर ट्रिम",
  "item.minecraft.warden_spawn_egg": "जलजीव अंडों के संरक्षक",
  "item.minecraft.warped_fungus_on_a_stick": "डंडे पर विकृत कवक",
  "item.minecraft.water_bucket": "पानी की बाल्टी",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Wayfinder Armor Trim",
  "item.minecraft.wheat": "गेहूँ",
  "item.minecraft.wheat_seeds": "गेहूँ के बीज",
  "item.minecraft.white_bundle": "सफेद पोटली",
  "item.minecraft.white_dye": "सफेद रंजक",
  "item.minecraft.white_harness": "White Harness",
  "item.minecraft.wild_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Wild Armor Trim",
  "item.minecraft.wind_charge": "पवन आवेश",
  "item.minecraft.witch_spawn_egg": "डायन का जन्म अंडा",
  "item.minecraft.wither_skeleton_spawn_egg": "विदर कंकाल का जन्म अंडा",
  "item.minecraft.wither_spawn_egg": "विदर का जन्म अंडा",
  "item.minecraft.wolf_armor": "भेड़िये का कवच",
  "item.minecraft.wolf_spawn_egg": "भेड़िया का जन्म अंडा",
  "item.minecraft.wooden_axe": "लकड़ी की कुल्हाड़ी",
  "item.minecraft.wooden_hoe": "लकड़ी की कुदाल",
  "item.minecraft.wooden_pickaxe": "लकड़ी की गैंती",
  "item.minecraft.wooden_shovel": "लकड़ी का बेलचा",
  "item.minecraft.wooden_spear": "लकड़ी का भाला",
  "item.minecraft.wooden_sword": "लकड़ी की तलवार",
  "item.minecraft.writable_book": "किताब और कलम",
  "item.minecraft.written_book": "व्रित्तें बुक",
  "item.minecraft.yellow_bundle": "Yellow Bundle",
  "item.minecraft.yellow_dye": "पीला रंजक",
  "item.minecraft.yellow_harness": "पीला दोहन",
  "item.minecraft.zoglin_spawn_egg": "ज़ॉग्लीन का जन्म अंडा",
  "item.minecraft.zombie_horse_spawn_egg": "जोंबी होर्श स्पाॅन एग",
  "item.minecraft.zombie_nautilus_spawn_egg": "Zombie Nautilus Spawn Egg",
  "item.minecraft.zombie_spawn_egg": "जॉम्बी का जन्म अंडा",
  "item.minecraft.zombie_villager_spawn_egg": "जोंबी विलेजर स्पान एग",
  "item.minecraft.zombified_piglin_spawn_egg": "जोम्बी पिगलीन का जन्म अंडा"
}
export const hi_in = items; 
